

import React, { useEffect, useRef, useState, } from 'react'
import { formatRoundoff, handleErrorToast, sortProjects, formatCurrencyIndian, getMonthName, ViewRequestStatus, ViewRequestRemarks, ViewDynamicApprovalStatus, ViewDynamicApprovalRemarks, isMoreThan24Hours, Lock, CSSForSelect, CSSForSelect15vWWidth, ProgressModal, Addbutton, CSSForSelectModern, getCSSForFilterDropdown, CSSForSelectModern15VWWidth } from '../../CustomFunctions';
import axios from 'axios';

import { BASE_URL } from '../../../config/axios';
import { toast, ToastContainer } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Dashboardnavbar from '../../../layout/Dashboardnavbar';
import { datearray, formattedDateLong } from '../../Date';
import { AddwithWhiteCircle, CircularGrid, Reciept, UpdatePencil, SearchBig, Employee, Eye, DropdownArrow, DropdownArrowOption, SelectVehical, Month, Year } from '../../AllSvg';
import { Monthprefix0, Projects, SubCompany, SubCompanyModern, VehicleModern, YearModern } from '../../FilterDropdown';
import usePermission from '../../../config/permissions';
import { DocumentModel } from '../ProjectDetailsCrudButtons';
import { height, width } from '@mui/system';
import Select, { components } from "react-select";

import SkeletonLoader from '../../Skeletonloader';
import { VehicleModelBulk } from '../BulkModals';
import ReactToPrint from 'react-to-print';
import { DownloadVehicleBill } from '../BulkModals';
// import nodatafound from "../../../assets/images/nodatafound.png"
// !  ************** Vehicle Model Components Start **************  ! //
import VehicleBillingStats from '../../StatusBar/VehcileBillingStats';
import { AddMultipleVehicleBilling } from '../BulkCRUD';
import {
    Truck, IndianRupee, CreditCard, MapPin, Briefcase, Hash, Calendar, Clock,
    TrendingUp, Building2, User, Phone, FileText, Save, Loader, ChevronRight, X,
    Search,
    Filter,
    ChevronUp,
    ChevronDown,
    LucideReceiptText,
    Sparkles,
    Landmark,
    Wallet,
    AlertCircle,
    Tag,
    Trash2,
    Users,
    Edit2,
    Receipt,
    ReceiptIndianRupeeIcon
} from 'lucide-react';
import { AddDynamicButton } from '../Components/modernbuttons/AddDynamicButton';


const AddVehicleModel = ({ projectId, getVehicle, subCompanyid }) => {
    const [show, setShow] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const [activeSection, setActiveSection] = useState('vehicle');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [tabValidationAttempted, setTabValidationAttempted] = useState({});

    const sections = [
        { id: 'vehicle', label: 'Vehicle & Project', icon: Truck },
        { id: 'billing', label: 'Timeline & Billing', icon: IndianRupee },
        { id: 'bank', label: 'Bank Details', icon: CreditCard },
        { id: 'address', label: 'Address', icon: MapPin },
    ];

    // Which fields belong to which tab — used for per-tab validation
    const tabRequiredFields = {
        vehicle: ["name", "project", "vehicle_num", "boqtransportation"],
        billing: ["vehicle_start_date", "agreement_duration", "select_billing_type"],
        bank: ["bank_name", "account_holder_name", "account_num", "ifsc_code", "pan_card", "mobile"],
        address: ["address"],
    };

    const handleShow = () => {
        setShow(true);
        setErrors({});
        setTabValidationAttempted({});
        setActiveSection('vehicle');
    };

    const initialFormData = {
        project: projectId ? projectId : "null",
        name: "",
        vehicle_num: "",
        fixed_km: "",
        fixed_bill_amt: "",
        extra_amt_above_fix_km: "",
        bank_name: "",
        account_holder_name: "",
        account_num: "",
        ifsc_code: "",
        pan_card: "",
        gst_num: "",
        address: "",
        mobile: "",
        km_per_lit: "",
        fuel_price: "",
        boqtransportation: 'null',
        agreement_duration: '',
        agreement_end_date: null,
        select_billing_type: null,
        end_date: null,
        vehicle_start_date: null,
    };

    const role = sessionStorage.getItem('sitemanagement_role');
    const employeeId = sessionStorage.getItem('sitemanagement_emp_id');

    const handleClose = (event) => {
        if (event) event.preventDefault();
        setShow(false);
        setFormData(initialFormData);
        setTabValidationAttempted({});
    };

    const getProjects = async () => {
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${role === "AuthorityEngineer" ? employeeId : "null"}/null/${role === "DataEntryOperator" ? employeeId : "null"}/null/`);
            const sortedList = sortProjects(pro.data, "site_prcode");
            setProjectList(sortedList);
        } catch (err) {
            handleErrorToast(err);
        }
    };
    useEffect(() => {
        if (show === true) getProjects();
    }, [show]);

    const [formData, setFormData] = useState(initialFormData);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    // Extra conditional-required checks (billing sub-fields) — used both by full validate and per-tab validate
    const getConditionalErrors = () => {
        const condErrors = {};
        if ((formData.select_billing_type === "As per fuel") && !formData.fuel_price) {
            condErrors.fuel_price = `Fuel prize is required!`;
        }
        if ((formData.select_billing_type === "As per fuel") && !formData.km_per_lit) {
            condErrors.km_per_lit = `Kilometer per litre is required!`;
        }
        if ((formData.select_billing_type === "As per kilometer") && !formData.fixed_km) {
            condErrors.fixed_km = `Fixed KM is required!`;
        }
        if ((formData.select_billing_type === "As per kilometer") && !formData.extra_amt_above_fix_km) {
            condErrors.extra_amt_above_fix_km = `Required field!`;
        }
        return condErrors;
    };

    const validateForm = () => {
        const newErrors = { ...getConditionalErrors() };
        const requiredFields = [
            "name", "project", "vehicle_num", "boqtransportation", "bank_name",
            "account_holder_name", "account_num", "ifsc_code", "pan_card",
            'agreement_duration', 'select_billing_type', "mobile", "address", "vehicle_start_date",
        ];

        requiredFields.forEach((field) => {
            const value = formData[field];
            if (value === "" || value === null || value === undefined || value === "null") {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // Validate only the fields belonging to the current tab
    const validateCurrentTab = () => {
        const currentTab = activeSection;
        const newErrors = { ...getConditionalErrors() };
        const fieldsToValidate = tabRequiredFields[currentTab] || [];

        fieldsToValidate.forEach((field) => {
            const value = formData[field];
            if (value === "" || value === null || value === undefined || value === "null") {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        // Only relevant conditional errors count for the "billing" tab
        const relevantErrors = {};
        Object.keys(newErrors).forEach((key) => {
            if (fieldsToValidate.includes(key) || ["fuel_price", "km_per_lit", "fixed_km", "extra_amt_above_fix_km"].includes(key)) {
                if (currentTab === "billing" || fieldsToValidate.includes(key)) {
                    relevantErrors[key] = newErrors[key];
                }
            }
        });

        setErrors((prev) => ({ ...prev, ...relevantErrors }));

        // Clear errors for fields in this tab that are now filled
        setErrors((prev) => {
            const updated = { ...prev };
            fieldsToValidate.forEach((field) => {
                if (formData[field] && formData[field] !== "null") delete updated[field];
            });
            return updated;
        });

        setTabValidationAttempted((prev) => ({ ...prev, [currentTab]: true }));

        return Object.keys(relevantErrors).length === 0;
    };

    const hasCurrentTabErrors = () => {
        const currentTab = activeSection;
        const fieldsToValidate = tabRequiredFields[currentTab] || [];
        const hasFieldError = fieldsToValidate.some((field) => errors[field]);
        const hasConditionalError = currentTab === "billing" && ["fuel_price", "km_per_lit", "fixed_km", "extra_amt_above_fix_km"].some((f) => errors[f]);
        return hasFieldError || hasConditionalError;
    };

    const getCurrentTabErrorMessage = () => {
        const currentTab = activeSection;
        const missingFields = (tabRequiredFields[currentTab] || [])
            .filter((field) => !formData[field] || formData[field] === "null")
            .map((field) => field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '));

        if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
        if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
        if (missingFields.length > 1) return `Please fill all required fields in ${sections.find(s => s.id === currentTab)?.label} before proceeding`;
        return `Please fix the errors in this section before proceeding`;
    };

    // Does a given tab have any missing required field? (for the warning dot)
    const tabHasMissingFields = (tabId) => {
        const fieldsToValidate = tabRequiredFields[tabId] || [];
        const missing = fieldsToValidate.some((field) => !formData[field] || formData[field] === "null");
        if (tabId === "billing") {
            const condMissing = Object.keys(getConditionalErrors()).length > 0;
            return missing || condMissing;
        }
        return missing;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const capitalizeFields = ["name", "vehicle_num", "bank_name", "account_holder_name", "pan_card", "ifsc_code", "gst_num"];
        let finalValue = capitalizeFields.includes(name) ? value.toUpperCase() : value;

        if (name === "mobile") {
            if (!/^\d*$/.test(finalValue)) return;
            if (finalValue.length > 10) return;
            setFormData((prev) => ({ ...prev, mobile: finalValue }));
            setErrors((prev) => {
                const newErrors = { ...prev };
                if (finalValue.length !== 10) newErrors.mobile = "Mobile number must be 10 digits";
                else delete newErrors.mobile;
                return newErrors;
            });
            setInputState((prev) => ({ ...prev, mobile: finalValue.length === 10 ? "green" : "" }));
            return;
        }

        if (name === "pan_card") {
            const pan_card = value.toUpperCase();
            if (!/^[A-Z0-9]*$/.test(pan_card)) return;
            if (pan_card.length === 10 && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan_card)) {
                setErrors((prev) => ({ ...prev, pan_card: "Invalid PAN format (ABCDE1234F)" }));
            } else {
                setErrors((prev) => { const n = { ...prev }; delete n.pan_card; return n; });
            }
            setFormData((prev) => ({ ...prev, pan_card: pan_card }));
            return;
        }

        if (name === "gst_num") {
            if (!/^[A-Z0-9]*$/.test(finalValue)) return;
            if (finalValue.length > 15) return;
            setFormData((prev) => ({ ...prev, gst_num: finalValue }));
            const isValidGst = finalValue.length === 15 && /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(finalValue);
            setErrors((prev) => {
                const err = { ...prev };
                isValidGst || finalValue.length < 15 ? delete err.gst_num : (err.gst_num = "Invalid GST format (22ABCDE1234F1Z5)");
                return err;
            });
            setInputState((prev) => ({ ...prev, gst_num: isValidGst ? "green" : "" }));
            return;
        }

        setFormData((prev) => ({ ...prev, [name]: finalValue }));
        setInputState((prev) => ({ ...prev, [name]: finalValue.trim() ? "green" : "" }));
        if (finalValue.trim()) {
            setErrors((prev) => { const n = { ...prev }; delete n[name]; return n; });
        }
    };

    const [loading, setLoading] = useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            let ress = await axios.post(`${BASE_URL}/siteproject/vehicle/`, formData);
            if (ress.status === 200) {
                getVehicle ? getVehicle() : window.location.reload();
                toast.dismiss(loadingToastId);
                toast.success("Vehicle Added Successfully");
                handleClose();
            } else {
                alert(ress);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }

    };


    const [boqList, setBoqList] = useState([]);
    const getBoq = async () => {
        try {
            const ress = await axios.get(`${BASE_URL}/siteproject/boqtransportbyproject/${formData.project}/`);
            setBoqList(ress.data);
        } catch (err) { }
    };

    const ProjectListOption = projectList
        ?.sort((a, b) => a.site_prcode?.localeCompare(b.site_prcode))
        .map((i) => ({ value: i.id, label: `${i.site_prcode} - ${i.project_short_name}` }));

    const handleProjectChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({ ...formData, project: "null" });
        } else {
            setFormData({ ...formData, project: selectedOption.value });
        }
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.project;
            return updatedErrors;
        });
    };

    useEffect(() => {
        if (formData.project !== "null" && show === true) getBoq();
    }, [formData.project, show]);

    const boqOptions = boqList
        ?.sort((a, b) => a?.rate?.toString().localeCompare(b?.rate?.toString(), 'en', { ignorePunctuation: true }))
        .map(i => ({ value: i.id, label: `₹${formatCurrencyIndian(i.rate)}` }));

    useEffect(() => {
        setBoqList([]);
    }, [formData.project]);

    useEffect(() => {
        const { vehicle_start_date, agreement_duration } = formData;
        const addMonthsToDate = (dateString, months) => {
            if (!dateString || !months) return "";
            const date = new Date(dateString);
            date.setMonth(date.getMonth() + Number(months));
            return date.toISOString().split("T")[0];
        };
        const agreementEndDate = addMonthsToDate(vehicle_start_date, agreement_duration);
        setFormData((prev) => ({ ...prev, agreement_end_date: agreementEndDate }));
    }, [formData.vehicle_start_date, formData.agreement_duration]);

    const BillingTypeOption = [
        { value: "As per kilometer", label: "As per kilometer" },
        { value: "As per fuel", label: "As per fuel" },
    ].sort((a, b) => a.label?.localeCompare(b.label));

    useEffect(() => {
        if (formData.select_billing_type === "As per fuel") {
            setFormData((prev) => ({ ...prev, fixed_km: "", extra_amt_above_fix_km: "" }));
        }
        if (formData.select_billing_type === "As per kilometer") {
            setFormData((prev) => ({ ...prev, km_per_lit: "", fuel_price: "" }));
        }
    }, [formData.select_billing_type]);

    // Tab switch — validates current tab first, blocks switch on failure
    const handleTabSwitch = (targetTabId) => {
        if (activeSection === targetTabId) return;
        if (validateCurrentTab()) {
            setActiveSection(targetTabId);
            const modalBody = document.querySelector('.modern-modal-body');
            if (modalBody) modalBody.scrollTop = 0;
        } else {
            const modalBody = document.querySelector('.modern-modal-body');
            if (modalBody) modalBody.scrollTop = 0;
        }
    };

    const goToNextTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        const nextTab = sections[currentIndex + 1]?.id;
        if (!nextTab) return;
        handleTabSwitch(nextTab);
    };
    const goToPreviousTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        if (currentIndex > 0) setActiveSection(sections[currentIndex - 1].id);
    };

    const renderVehicleSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Truck size={18} />
                <h4>Vehicle & Project</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Briefcase size={14} /> Site Project <span className="required">{(siteRole === "SiteManagement" || projectId) ? "(Read-Only)" : "*"}</span></label>
                    <Select
                        options={ProjectListOption}
                        isDisabled={!!(siteRole === "SiteManagement" || projectId)}
                        onChange={handleProjectChange}
                        value={formData.project === "null" || formData.project === undefined ? null : ProjectListOption.find((option) => option.value === formData.project)}
                        placeholder="Select a Project"
                        isSearchable isClearable
                        noOptionsMessage={() => "No other options"}
                        styles={CSSForSelectModern}
                    />
                    {errors.project && <span className="error-message">Site {errors.project}</span>}
                </div>

                {formData.project !== "null" && (
                    <div className="form-field">
                        <label><IndianRupee size={14} /> BOQ Rate</label>
                        <Select
                            options={boqOptions}
                            placeholder="Select a Boq"
                            value={boqOptions?.find(option => option.value === formData.boqtransportation)}
                            onChange={(selectedOption) => handleInputChange({ target: { name: "boqtransportation", value: selectedOption ? selectedOption.value : "null" } })}
                            styles={CSSForSelectModern}
                            isClearable isSearchable
                        />
                        {errors.boqtransportation && <span className="error-message">BOQ rate is required!</span>}
                    </div>
                )}

                <div className="form-field">
                    <label><Truck size={14} /> Vehicle Name<span className="required">*</span></label>
                    <input type="text" name="name" placeholder="Vehicle Name" value={formData.name} onChange={handleInputChange} className={errors.name ? "error" : inputState.name ? "success" : ""} />
                    {errors.name && <span className="error-message">Vehicle {errors.name}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> Vehicle Number<span className="required">*</span></label>
                    <input type="text" name="vehicle_num" placeholder="Vehicle Number" value={formData.vehicle_num} onChange={handleInputChange} className={errors.vehicle_num ? "error" : inputState.vehicle_num ? "success" : ""} />
                    {errors.vehicle_num && <span className="error-message">Vehicle no. is required!</span>}
                </div>

                {formData.project === "null" && (
                    <div className="form-field">
                        <label><FileText size={14} /> GST Number<span className="required">*</span></label>
                        <input type="text" name="gst_num" placeholder="GST Number" value={formData.gst_num} onChange={handleInputChange} className={errors.gst_num ? "error" : inputState.gst_num ? "success" : ""} />
                        {errors.gst_num && <span className="error-message">{errors.gst_num}</span>}
                    </div>
                )}
            </div>

            <div className="section-navigation-buttons nav-buttons-wrapper">
                {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                    <div className="tab-error-message">
                        <AlertCircle size={14} />
                        <span>{getCurrentTabErrorMessage()}</span>
                    </div>
                )}
                {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
                <button type="button" className="btn-next" onClick={goToNextTab}>
                    Next: Timeline & Billing <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );

    const renderBillingSection = () => (
        <div className="form-section">
            <div className="section-title">
                <IndianRupee size={18} />
                <h4>Timeline & Billing</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Calendar size={14} /> Vehicle Start Date<span className="required">*</span></label>
                    <input type="date" name="vehicle_start_date" onChange={handleInputChange} value={formData.vehicle_start_date} className={errors.vehicle_start_date ? "error" : inputState.vehicle_start_date ? "success" : ""} />
                    {errors.vehicle_start_date && <span className="error-message">Vehicle start date is required!</span>}
                </div>

                <div className="form-field">
                    <label><Clock size={14} /> Agreement Duration<span className="required">*</span></label>
                    <input type="number" name="agreement_duration" placeholder="Example 6 months" value={formData.agreement_duration} onChange={handleInputChange} className={errors.agreement_duration ? "error" : inputState.agreement_duration ? "success" : ""} />
                    {errors.agreement_duration && <span className="error-message">Agreement duration is required!</span>}
                </div>

                <div className="form-field">
                    <label><Calendar size={14} /> Agreement End Date<span className="required">(Read-Only)</span></label>
                    <input type="date" name="agreement_end_date" disabled value={formData.agreement_end_date} className="readonly-field" />
                </div>

                <div className="form-field">
                    <label><Calendar size={14} /> Vehicle End Date</label>
                    <input
                        type="date"
                        name="end_date"
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setFormData((prev) => ({
                                ...prev,
                                [name]: value === "" ? null : value,
                            }));
                        }}
                        value={formData.end_date ?? null}
                        className={errors.end_date ? "error" : inputState.end_date ? "success" : ""}
                    />
                    {errors.end_date && <span className="error-message">Vehicle end date is required!</span>}
                </div>

                <div className="form-field">
                    <label><Briefcase size={14} /> Billing Type<span className="required">*</span></label>
                    <Select
                        options={BillingTypeOption}
                        placeholder="Select Billing Type"
                        value={BillingTypeOption?.find(option => option.value === formData.select_billing_type)}
                        onChange={(selectedOption) => handleInputChange({ target: { name: "select_billing_type", value: selectedOption ? selectedOption.value : "null" } })}
                        styles={CSSForSelectModern}
                        isClearable isSearchable
                    />
                    {errors.select_billing_type && <span className="error-message">Billing type is required!</span>}
                </div>

                {formData.select_billing_type === "As per kilometer" ? (
                    <>
                        <div className="form-field">
                            <label><TrendingUp size={14} /> Fixed Kilometer<span className="required">*</span></label>
                            <input type="number" name="fixed_km" placeholder="0" min={0} value={formData.fixed_km} onChange={handleInputChange} className={errors.fixed_km ? "error" : inputState.fixed_km ? "success" : ""} />
                            {errors.fixed_km && <span className="error-message">{errors.fixed_km}</span>}
                        </div>
                        <div className="form-field">
                            <label><IndianRupee size={14} /> Extra Amount Per KM After Fixed KM<span className="required">*</span></label>
                            <input type="number" min={0} name="extra_amt_above_fix_km" placeholder="0" value={formData.extra_amt_above_fix_km} onChange={handleInputChange} className={errors.extra_amt_above_fix_km ? "error" : inputState.extra_amt_above_fix_km ? "success" : ""} />
                            {errors.extra_amt_above_fix_km && <span className="error-message">Required field!</span>}
                        </div>
                    </>
                ) : formData.select_billing_type === "As per fuel" ? (
                    <>
                        <div className="form-field">
                            <label><TrendingUp size={14} /> Kilometer per Litre<span className="required">*</span></label>
                            <input type="number" name="km_per_lit" placeholder="Kilometer per Litre" min={0} value={formData.km_per_lit} onChange={handleInputChange} className={errors.km_per_lit ? "error" : inputState.km_per_lit ? "success" : ""} />
                            {errors.km_per_lit && <span className="error-message">{errors.km_per_lit}</span>}
                        </div>
                        <div className="form-field">
                            <label><IndianRupee size={14} /> Fuel Price<span className="required">*</span></label>
                            <input type="number" name="fuel_price" placeholder="0" min={0} value={formData.fuel_price} onChange={handleInputChange} className={errors.fuel_price ? "error" : inputState.fuel_price ? "success" : ""} />
                            {errors.fuel_price && <span className="error-message">{errors.fuel_price}</span>}
                        </div>
                    </>
                ) : null}

                <div className="form-field">
                    <label><IndianRupee size={14} /> Fixed Bill Amount</label>
                    <input type="number" min={0} name="fixed_bill_amt" placeholder="0" value={formData.fixed_bill_amt} onChange={handleInputChange} className={errors.fixed_bill_amt ? "error" : inputState.fixed_bill_amt ? "success" : ""} />
                    {errors.fixed_bill_amt && <span className="error-message">Fixed bill amount is required</span>}
                </div>

                {formData.project !== "null" && (
                    <div className="form-field">
                        <label><FileText size={14} /> GST Number</label>
                        <input type="text" name="gst_num" placeholder="GST Number" value={formData.gst_num} onChange={handleInputChange} className={errors.gst_num ? "error" : inputState.gst_num ? "success" : ""} />
                        {errors.gst_num && <span className="error-message">{errors.gst_num}</span>}
                    </div>
                )}
            </div>

            <div className="section-navigation-buttons dual-buttons">
                <div className="nav-buttons-wrapper">
                    <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                        <ChevronRight size={16} className="rotate-left" /> Previous
                    </button>
                    {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                        <div className="tab-error-message">
                            <AlertCircle size={14} />
                            <span>{getCurrentTabErrorMessage()}</span>
                        </div>
                    )}
                    <button type="button" className="btn-next" onClick={goToNextTab}>
                        Next: Bank Details <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );

    const renderBankSection = () => (
        <div className="form-section">
            <div className="section-title">
                <CreditCard size={18} />
                <h4>Bank Details</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Building2 size={14} /> Bank Name<span className="required">*</span></label>
                    <input type="text" name="bank_name" placeholder="Bank Name" value={formData.bank_name} onChange={handleInputChange} className={errors.bank_name ? "error" : inputState.bank_name ? "success" : ""} />
                    {errors.bank_name && <span className="error-message">Bank name is required!</span>}
                </div>

                <div className="form-field">
                    <label><User size={14} /> Account Holder Name<span className="required">*</span></label>
                    <input type="text" name="account_holder_name" placeholder="Account Holder Name" value={formData.account_holder_name} onChange={handleInputChange} className={errors.account_holder_name ? "error" : inputState.account_holder_name ? "success" : ""} />
                    {errors.account_holder_name && <span className="error-message">Required field!</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> Account Number<span className="required">*</span></label>
                    <input type="number" min={0} name="account_num" placeholder="Account Number" value={formData.account_num} onChange={handleInputChange} className={errors.account_num ? "error" : inputState.account_num ? "success" : ""} />
                    {errors.account_num && <span className="error-message">Account number is required!</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> IFSC Code<span className="required">*</span></label>
                    <input type="text" name="ifsc_code" placeholder="IFSC Code" value={formData.ifsc_code} onChange={handleInputChange} className={errors.ifsc_code ? "error" : inputState.ifsc_code ? "success" : ""} />
                    {errors.ifsc_code && <span className="error-message">IFSC code is required!</span>}
                </div>

                <div className="form-field">
                    <label><CreditCard size={14} /> PAN Card<span className="required">*</span></label>
                    <input type="text" name="pan_card" placeholder="PAN Card" maxLength={10} value={formData.pan_card} onChange={handleInputChange} className={errors.pan_card ? "error" : inputState.pan_card ? "success" : ""} />
                    {errors.pan_card && <span className="error-message">{errors.pan_card}</span>}
                </div>

                <div className="form-field">
                    <label><Phone size={14} /> Mobile Number<span className="required">(10-digits only)*</span></label>
                    <input type="text" name="mobile" inputMode="numeric" pattern="[0-9]*" placeholder="Mobile Number" value={formData.mobile} onChange={handleInputChange} className={errors.mobile ? "error" : inputState.mobile ? "success" : ""} />
                    {errors.mobile && <span className="error-message">{errors.mobile}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons dual-buttons">
                <div className="nav-buttons-wrapper">
                    <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                        <ChevronRight size={16} className="rotate-left" /> Previous
                    </button>
                    {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                        <div className="tab-error-message">
                            <AlertCircle size={14} />
                            <span>{getCurrentTabErrorMessage()}</span>
                        </div>
                    )}
                    <button type="button" className="btn-next" onClick={goToNextTab}>
                        Next: Address <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );

    const renderAddressSection = () => (
        <div className="form-section">
            <div className="section-title">
                <MapPin size={18} />
                <h4>Address</h4>
            </div>
            <div className="form-grid">
                <div className="form-field full-width">
                    <label><MapPin size={14} /> Address<span className="required">*</span></label>
                    <textarea name="address" placeholder="Address" value={formData.address} onChange={handleInputChange} rows={3} className={errors.address ? "error" : inputState.address ? "success" : ""} />
                    {errors.address && <span className="error-message">Address is required!</span>}
                </div>
            </div>

            <div className="form-actions">
                <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                    <ChevronRight size={16} className="rotate-left" /> Previous: Bank Details
                </button>
                <div className="submit-buttons">
                    <button type="button" className="btn-secondaryy" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="button" className="btn-primaryy" onClick={handleFormSubmit} disabled={loading}>
                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                        <span>{loading ? 'Adding...' : 'Add Vehicle'}</span>
                    </button>
                </div>
            </div>

            <p className="error-message" style={{ marginTop: '12px' }}>
                {isSubmitted && Object.keys(errors).length > 0 && (
                    Object.keys(errors).length > 5 ? (
                        <span>Please fill all mandatory fields!</span>
                    ) : (
                        Object.keys(errors).map((field) => field.charAt(0).toUpperCase() + field.slice(1)).join(', ') + ' are required!'
                    )
                )}
            </p>
        </div>
    );

    const renderCurrentSection = () => {
        switch (activeSection) {
            case 'vehicle': return renderVehicleSection();
            case 'billing': return renderBillingSection();
            case 'bank': return renderBankSection();
            case 'address': return renderAddressSection();
            default: return renderVehicleSection();
        }
    };

    return (
        <>
            <AddDynamicButton title="Add Vehicle" logo={<Truck size={24} />} onClick={handleShow} />

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Truck size={24} />
                            </div>
                            <div>
                                <Modal.Title>Add Vehicle Details</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Fill in the details to add a new vehicle</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

                    <Modal.Body className="modern-modal-body">
                        <div className="section-navigation">
                            {sections.map((section) => {
                                const Icon = section.icon;
                                const showWarning = tabValidationAttempted[activeSection] && tabHasMissingFields(section.id) && section.id !== activeSection;
                                return (
                                    <button
                                        key={section.id}
                                        className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${showWarning ? 'has-warning' : ''}`}
                                        onClick={() => handleTabSwitch(section.id)}
                                    >
                                        <Icon size={16} />
                                        <span>{section.label}</span>
                                        {showWarning && <div className="warning-dot" title="Missing required fields" />}
                                        {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                                    </button>
                                );
                            })}
                        </div>

                        <form onSubmit={handleFormSubmit} className="project-form">
                            {renderCurrentSection()}
                        </form>
                    </Modal.Body>
                </Modal>
            )}
        </ >
    );
};



const UpdateVehicle = ({ i, projectId, getVehicle, usedIn, subCompanyid }) => {
    const [projectList, setProjectList] = useState([]);
    const [show, setShow] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [activeSection, setActiveSection] = useState('vehicle');
    const [tabValidationAttempted, setTabValidationAttempted] = useState({});

    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const sections = [
        { id: 'vehicle', label: 'Vehicle Details', icon: Truck },
        { id: 'bank', label: 'Bank Details', icon: CreditCard },
    ];

    const handleShow = () => {
        setFormData(i);
        setActiveSection('vehicle');
        setTabValidationAttempted({});
        setErrors({});
        setShow(true);
    }

    const getProjects = async () => {
        try {
            const pro = await axios.get(
                sessionStorage.getItem("sitemanagement_role") === "AuthorityEngineer"
                    ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem(
                        "sitemanagement_emp_id"
                    )}/${subCompanyid}/null/`
                    : sessionStorage.getItem("sitemanagement_role") ===
                        "DataEntryOperator"
                        ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/null/null/${sessionStorage.getItem(
                            "sitemanagement_emp_id"
                        )}/`
                        : `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/null/${subCompanyid}/null/null/`
            );
            const sortedList = sortProjects(pro.data, "site_prcode");
            setProjectList(sortedList);
        } catch (err) {
            handleErrorToast(err);
        } finally {
        }
    };

    useEffect(() => {
        if (show === true) {
            getProjects();
        }
    }, [show])

    const [formData, setFormData] = useState({
        project: projectId ? projectId : "null",
        name: "",
        vehicle_num: "",
        fixed_km: "",
        fixed_bill_amt: "",
        extra_amt_above_fix_km: "",

        bank_name: "",
        account_holder_name: "",
        account_num: "",
        ifsc_code: "",
        pan_card: "",
        gst_num: "",
        address: "",
        mobile: "",
        km_per_lit: "",
        fuel_price: "",
        boqtransportation: 'null',
        agreement_duration: '',
        agreement_end_date: null,
        select_billing_type: null,
        end_date: null,
        vehicle_start_date: null,
    });


    // !  ************** Validation start **************  ! //
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    // ---------- Field labels ----------
    const fieldLabels = {
        project: 'Site Project',
        name: 'Vehicle Name',
        vehicle_num: 'Vehicle Number',
        vehicle_start_date: 'Vehicle Start Date',
        agreement_duration: 'Agreement Duration',
        end_date: 'Vehicle End Date',
        select_billing_type: 'Billing Type',
        fixed_km: 'Fixed Kilometer',
        extra_amt_above_fix_km: 'Extra Amount Per KM',
        km_per_lit: 'Kilometer Per Litre',
        fuel_price: 'Fuel Price',
        bank_name: 'Bank Name',
        account_holder_name: 'Account Holder Name',
        account_num: 'Account Number',
        mobile: 'Mobile Number',
        ifsc_code: 'IFSC Code',
        pan_card: 'PAN Card',
        gst_num: 'GST Number',
        address: 'Address',
    };

    // ---------- Tab-wise required fields ----------
    const getTabRequiredFields = (tabId, data = formData) => {
        const map = {
            vehicle: [
                'vehicle_start_date',
                'agreement_duration',

                'select_billing_type',
                ...(data.select_billing_type === "As per kilometer" ? ['fixed_km', 'extra_amt_above_fix_km'] : []),
                ...(data.select_billing_type === "As per fuel" ? ['km_per_lit', 'fuel_price'] : []),
            ],
            bank: [
                'bank_name',
                'account_holder_name',
                'account_num',
                'mobile',
                'ifsc_code',
                'pan_card',
                'address',
                ...(data.project === "null" ? ['gst_num'] : []),
            ],
        };
        return map[tabId] || [];
    };

    const isFieldEmpty = (field, data = formData) => {
        const value = data[field];
        return value === null || value === undefined || value === "null" || (typeof value === 'string' && value.trim() === "");
    };

    const tabHasMissingFields = (tabId) => getTabRequiredFields(tabId).some((field) => isFieldEmpty(field));

    const validateCurrentTab = () => {
        const currentTab = activeSection;
        const fieldsToValidate = getTabRequiredFields(currentTab);
        const newErrors = {};

        fieldsToValidate.forEach((field) => {
            if (isFieldEmpty(field)) {
                newErrors[field] = `${fieldLabels[field] || field} is required!`;
            }
        });

        setErrors(prev => {
            const updated = { ...prev, ...newErrors };
            fieldsToValidate.forEach((field) => {
                if (!isFieldEmpty(field)) delete updated[field];
            });
            return updated;
        });

        setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

        return Object.keys(newErrors).length === 0;
    };

    const hasCurrentTabErrors = () => getTabRequiredFields(activeSection).some(field => errors[field]);

    const getCurrentTabErrorMessage = () => {
        const missingFields = getTabRequiredFields(activeSection)
            .filter(field => isFieldEmpty(field))
            .map(field => fieldLabels[field] || field);

        if (missingFields.length === 0) return null;
        if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;

        const tabLabel = sections.find(s => s.id === activeSection)?.label || activeSection;
        return `Please fill all required fields in ${tabLabel} before proceeding`;
    };

    const goToNextTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        const nextTab = sections[currentIndex + 1]?.id;

        if (!validateCurrentTab()) {
            const formContainer = document.querySelector('.modern-modal-body');
            if (formContainer) formContainer.scrollTop = 0;
            return;
        }

        if (nextTab) {
            setErrors(prev => {
                const nextTabFields = getTabRequiredFields(nextTab);
                const filtered = { ...prev };
                nextTabFields.forEach(field => delete filtered[field]);
                return filtered;
            });
        }

        if (currentIndex < sections.length - 1) {
            setActiveSection(nextTab);
        }
    };

    const goToPreviousTab = () => {
        const idx = sections.findIndex(s => s.id === activeSection);
        if (idx > 0) {
            setActiveSection(sections[idx - 1].id);
        }
    };

    const validateForm = () => {
        const newErrors = {};

        sections.forEach((section) => {
            getTabRequiredFields(section.id).forEach((field) => {
                if (isFieldEmpty(field)) {
                    newErrors[field] = `${fieldLabels[field] || field} is required!`;
                }
            });
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        const capitalizeFields = [
            "name",
            "vehicle_num",
            "bank_name",
            "account_holder_name",
            "pan_card",
            "ifsc_code",
            "gst_num",
        ];

        let finalValue = capitalizeFields.includes(name)
            ? value.toUpperCase()
            : value;

        /* ---------- MOBILE VALIDATION ---------- */
        if (name === "mobile") {
            if (!/^\d*$/.test(finalValue)) return;
            if (finalValue.length > 10) return;

            setFormData((prev) => ({
                ...prev,
                mobile: finalValue,
            }));

            setErrors((prev) => {
                const newErrors = { ...prev };
                if (finalValue.length !== 10) {
                    newErrors.mobile = "Mobile number must be 10 digits";
                } else {
                    delete newErrors.mobile;
                }
                return newErrors;
            });

            setInputState((prev) => ({
                ...prev,
                mobile: finalValue.length === 10 ? "green" : "",
            }));
            return;
        }

        /* ---------- PAN VALIDATION ---------- */
        if (name === "pan_card") {
            const pan_card = value.toUpperCase();

            if (!/^[A-Z0-9]*$/.test(pan_card)) return;

            if (pan_card.length === 10 && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan_card)) {
                setErrors((prev) => ({
                    ...prev,
                    pan_card: "Invalid PAN format (ABCDE1234F)",
                }));
            } else {
                setErrors((prev) => {
                    const newErrors = { ...prev };
                    delete newErrors.pan_card;
                    return newErrors;
                });
            }

            setFormData((prev) => ({ ...prev, pan_card: pan_card }));
            setInputState((prev) => ({ ...prev, pan_card: pan_card.trim() ? "green" : "" }));
            return;
        }
        /* ---------- GST ---------- */
        if (name === "gst_num") {
            if (!/^[A-Z0-9]*$/.test(finalValue)) return;
            if (finalValue.length > 15) return;

            setFormData((prev) => ({ ...prev, gst_num: finalValue }));

            const isValidGst =
                finalValue.length === 15 &&
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(finalValue);

            setErrors((prev) => {
                const err = { ...prev };
                isValidGst || finalValue.length < 15
                    ? delete err.gst_num
                    : (err.gst_num = "Invalid GST format (22ABCDE1234F1Z5)");
                return err;
            });

            setInputState((prev) => ({
                ...prev,
                gst_num: isValidGst ? "green" : "",
            }));
            return;
        }

        /* ---------- NORMAL FIELDS ---------- */
        setFormData((prev) => ({
            ...prev,
            [name]: finalValue,
        }));

        setInputState((prev) => ({
            ...prev,
            [name]: finalValue?.toString().trim() ? "green" : "",
        }));

        if (finalValue?.toString().trim()) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };


    // ?  ************** Validation End **************  ! //


    const [loading, setLoading] = useState(false);
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setShowProgressModal(true);
            setLoading(true);
            setUploadProgress(0);

            const loadingToastId = toast.loading("Loading: Please wait...");

            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100);

            try {
                let ress = await axios.put(
                    `${BASE_URL}/siteproject/vehicle/${i.id}/`,
                    formData
                );

                if (ress.status === 200) {
                    await getVehicle();
                    clearInterval(interval);
                    toast.dismiss(loadingToastId);
                    toast.success("Updated Successfully");
                    handleClose();
                }
            } catch (err) {
                clearInterval(interval);
                setUploadProgress(0);
                handleErrorToast(err);
            } finally {
                clearInterval(interval);
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 1500);
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        } else {
            const firstErrorTab = sections.find(s => tabHasMissingFields(s.id))?.id;
            if (firstErrorTab) {
                setActiveSection(firstErrorTab);
                setTabValidationAttempted(prev => ({ ...prev, [firstErrorTab]: true }));
            }
        }
    };

    const handleClose = (event) => {
        if (event) {
            event.preventDefault();
        }
        setShow(false);
        setFormData(i);
        setActiveSection('vehicle');
        setTabValidationAttempted({});
        setErrors({});
    }
    const [boqList, setBoqList] = useState([]);
    const [loadingboq, setLoadingboq] = useState(false);
    const getBoq = async () => {

        try {
            const ress = await axios.get(`${BASE_URL}/siteproject/boqtransportbyproject/${formData.project}/`);
            setBoqList(ress.data)
            setLoadingboq(true);
        } catch (err) {
        } finally {

        }
    }


    useEffect(() => {
        if (formData.project !== "null" && show === true) {
            getBoq();
        }
    }, [formData.project, show])

    const ProjectListOption = projectList
        ?.sort((a, b) => a.site_prcode?.localeCompare(b.site_prcode))
        .map((i) => ({
            value: i.id,
            label: `${i.site_prcode} - ${i.project_short_name}`,
        }));

    const handleProjectChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                project: "null",
            });
        } else {
            setFormData({
                ...formData,
                project: selectedOption.value,
            });
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.project;
            return updatedErrors;
        });
    };

    const boqOptions = boqList
        ?.sort((a, b) =>
            a?.rate?.toString().localeCompare(b?.rate?.toString(), 'en', {
                ignorePunctuation: true
            })
        )
        .map(i => ({
            value: i.id,
            label: `₹${formatCurrencyIndian(i.rate)}`
        }));

    useEffect(() => {
        setBoqList([]);
    }, [formData.project])


    useEffect(() => {
        const {
            vehicle_start_date,
            agreement_duration,
        } = formData;

        const addMonthsToDate = (dateString, months) => {
            if (!dateString || !months) return "";
            const date = new Date(dateString);
            date.setMonth(date.getMonth() + Number(months));
            return date.toISOString().split("T")[0];
        };

        const agreementEndDate = addMonthsToDate(
            vehicle_start_date,
            agreement_duration
        );

        setFormData((prev) => ({
            ...prev,
            agreement_end_date: agreementEndDate,
        }));
    }, [
        formData.vehicle_start_date,
        formData.agreement_duration,
    ]);

    const BillingType = [
        { value: "As per kilometer", label: "As per kilometer" },
        { value: "As per fuel", label: "As per fuel" },
    ]

    const BillingTypeOption = BillingType
        ?.sort((a, b) => a.label?.localeCompare(b.label))
        .map((i) => ({
            value: i.value,
            label: `${i.label}`,
        }));

    useEffect(() => {
        if (formData.select_billing_type === "As per fuel") {
            setFormData((prev) => ({
                ...prev,
                fixed_km: "",
                extra_amt_above_fix_km: "",
            }))
        }
        if (formData.select_billing_type === "As per kilometer") {
            setFormData((prev) => ({
                ...prev,
                km_per_lit: "",
                fuel_price: "",
            }))
        }
    }, [formData.select_billing_type])

    const renderVehicleSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Truck size={18} />
                <h4>Vehicle Details</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><MapPin size={14} /> Site Project</label>
                    <Select
                        options={ProjectListOption}
                        onChange={handleProjectChange}
                        value={
                            formData.project === "null" || formData.project === undefined
                                ? null
                                : ProjectListOption.find((option) => option.value === formData.project)
                        }
                        placeholder="Select a Project"
                        isSearchable isClearable
                        noOptionsMessage={() => "No other options"}
                        styles={CSSForSelectModern}
                    />
                    {errors.project && <span className="error-message">{errors.project}</span>}
                </div>

                {formData.project !== "null" && (
                    <div className="form-field">
                        <label><Hash size={14} /> BOQ Rate</label>
                        <Select
                            inputId="boqtransportation"
                            name="boqtransportation"
                            options={boqOptions}
                            placeholder="Select a Boq"
                            value={boqOptions?.find(option => option.value === formData.boqtransportation)}
                            onChange={(selectedOption) =>
                                handleInputChange({
                                    target: {
                                        name: "boqtransportation",
                                        value: selectedOption ? selectedOption.value : "null"
                                    }
                                })
                            }
                            styles={CSSForSelectModern}
                            isClearable
                            isSearchable
                        />
                        {errors.boqtransportation && <span className="error-message">BOQ rate is required!</span>}
                    </div>
                )}

                <div className="form-field">
                    <label><Truck size={14} /> Vehicle Name</label>
                    <input type="text" name="name" placeholder="Vehicle Name" value={formData.name} onChange={handleInputChange} className={errors.name ? "error" : inputState.name ? "success" : ""} />
                    {errors.name && <span className="error-message">{errors.name}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> Vehicle Number</label>
                    <input type="text" name="vehicle_num" placeholder="Vehicle Number" value={formData.vehicle_num} onChange={handleInputChange} className={errors.vehicle_num ? "error" : inputState.vehicle_num ? "success" : ""} />
                    {errors.vehicle_num && <span className="error-message">{errors.vehicle_num}</span>}
                </div>

                <div className="form-field">
                    <label> Vehicle Start Date<span className="required">*</span></label>
                    <input type="date" name="vehicle_start_date" onChange={handleInputChange} value={formData.vehicle_start_date} className={errors.vehicle_start_date ? "error" : inputState.vehicle_start_date ? "success" : ""} />
                    {errors.vehicle_start_date && <span className="error-message">{errors.vehicle_start_date}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> Agreement Duration (months)<span className="required">*</span></label>
                    <input type="number" min={0} name="agreement_duration" placeholder="Example-6" value={formData.agreement_duration} onChange={handleInputChange} className={errors.agreement_duration ? "error" : inputState.agreement_duration ? "success" : ""} />
                    {errors.agreement_duration && <span className="error-message">{errors.agreement_duration}</span>}
                </div>

                <div className="form-field">
                    <label> Agreement End Date <span className="required" style={{ fontSize: '10px' }}>(Read-Only)</span></label>
                    <input type="date" name="agreement_end_date" disabled value={formData.agreement_end_date} />
                </div>

                <div className="form-field">
                    <label> Vehicle End Date</label>
                    <input
                        type="date"
                        name="end_date"
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setFormData((prev) => ({
                                ...prev,
                                [name]: value === "" ? null : value,
                            }));
                        }}
                        value={formData.end_date ?? null}
                        className={errors.end_date ? "error" : inputState.end_date ? "success" : ""}
                    />
                    {errors.end_date && <span className="error-message">{errors.end_date}</span>}
                </div>

                <div className="form-field">
                    <label><Tag size={14} /> Billing Type<span className="required">*</span></label>
                    <Select
                        inputId="select_billing_type"
                        name="select_billing_type"
                        options={BillingTypeOption}
                        placeholder="Select Billing Type"
                        value={BillingTypeOption?.find(option => option.value === formData.select_billing_type)}
                        onChange={(selectedOption) =>
                            handleInputChange({
                                target: {
                                    name: "select_billing_type",
                                    value: selectedOption ? selectedOption.value : "null"
                                }
                            })
                        }
                        styles={CSSForSelectModern}
                        isClearable
                        isSearchable
                    />
                    {errors.select_billing_type && <span className="error-message">{errors.select_billing_type}</span>}
                </div>

                {formData.select_billing_type === "As per kilometer" ? (
                    <>
                        <div className="form-field">
                            <label><Hash size={14} /> Fixed Kilometer<span className="required">*</span></label>
                            <input type="number" min={0} name="fixed_km" placeholder="0" value={formData.fixed_km} onChange={handleInputChange} className={errors.fixed_km ? "error" : inputState.fixed_km ? "success" : ""} />
                            {errors.fixed_km && <span className="error-message">{errors.fixed_km}</span>}
                        </div>
                        <div className="form-field">
                            <label><IndianRupee size={14} /> Extra Amount Per KM After Fixed KM<span className="required">*</span></label>
                            <input type="number" min={0} name="extra_amt_above_fix_km" placeholder="0" value={formData.extra_amt_above_fix_km} onChange={handleInputChange} className={errors.extra_amt_above_fix_km ? "error" : inputState.extra_amt_above_fix_km ? "success" : ""} />
                            {errors.extra_amt_above_fix_km && <span className="error-message">{errors.extra_amt_above_fix_km}</span>}
                        </div>
                    </>
                ) : formData.select_billing_type === "As per fuel" ? (
                    <>
                        <div className="form-field">
                            <label><Hash size={14} /> Kilometer per Litre<span className="required">*</span></label>
                            <input type="number" min={0} name="km_per_lit" placeholder="Kilometer per Litre" value={formData.km_per_lit} onChange={handleInputChange} className={errors.km_per_lit ? "error" : inputState.km_per_lit ? "success" : ""} />
                            {errors.km_per_lit && <span className="error-message">{errors.km_per_lit}</span>}
                        </div>
                        <div className="form-field">
                            <label><IndianRupee size={14} /> Fuel Price<span className="required">*</span></label>
                            <input type="number" min={0} name="fuel_price" placeholder="0" value={formData.fuel_price} onChange={handleInputChange} className={errors.fuel_price ? "error" : inputState.fuel_price ? "success" : ""} />
                            {errors.fuel_price && <span className="error-message">{errors.fuel_price}</span>}
                        </div>
                    </>
                ) : null}

                <div className="form-field">
                    <label><IndianRupee size={14} /> Fixed Bill Amount</label>
                    <input type="number" min={0} name="fixed_bill_amt" placeholder="0" value={formData.fixed_bill_amt} onChange={handleInputChange} className={errors.fixed_bill_amt ? "error" : inputState.fixed_bill_amt ? "success" : ""} />
                    {errors.fixed_bill_amt && <span className="error-message">{errors.fixed_bill_amt}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons nav-buttons-wrapper">
                {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                    <div className="tab-error-message">
                        <AlertCircle size={14} />
                        <span>{getCurrentTabErrorMessage()}</span>
                    </div>
                )}
                {tabValidationAttempted[activeSection] && !hasCurrentTabErrors() && (
                    <div></div>
                )}
                <button type="button" className="btn-next" onClick={goToNextTab} disabled={tabHasMissingFields('vehicle')}>
                    Next: Bank Details <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );

    const renderBankSection = () => (
        <div className="form-section">
            <div className="section-title">
                <CreditCard size={18} />
                <h4>Bank Details</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Building2 size={14} /> Bank Name<span className="required">*</span></label>
                    <input type="text" name="bank_name" placeholder="Bank Name" value={formData.bank_name} onChange={handleInputChange} className={errors.bank_name ? "error" : inputState.bank_name ? "success" : ""} />
                    {errors.bank_name && <span className="error-message">{errors.bank_name}</span>}
                </div>

                <div className="form-field">
                    <label><User size={14} /> Account Holder Name<span className="required">*</span></label>
                    <input type="text" name="account_holder_name" placeholder="Account Holder Name" value={formData.account_holder_name} onChange={handleInputChange} className={errors.account_holder_name ? "error" : inputState.account_holder_name ? "success" : ""} />
                    {errors.account_holder_name && <span className="error-message">{errors.account_holder_name}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> Account Number<span className="required">*</span></label>
                    <input type="number" min={0} name="account_num" placeholder="Account Number" value={formData.account_num} onChange={handleInputChange} className={errors.account_num ? "error" : inputState.account_num ? "success" : ""} />
                    {errors.account_num && <span className="error-message">{errors.account_num}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> IFSC Code<span className="required">*</span></label>
                    <input type="text" maxLength={15} name="ifsc_code" placeholder="Example-ABCIN0000691" value={formData.ifsc_code} onChange={handleInputChange} className={errors.ifsc_code ? "error" : inputState.ifsc_code ? "success" : ""} />
                    {errors.ifsc_code && <span className="error-message">{errors.ifsc_code}</span>}
                </div>

                <div className="form-field">
                    <label><CreditCard size={14} /> PAN Card<span className="required">*</span></label>
                    <input type="text" maxLength={10} name="pan_card" placeholder="ABCDE1234F" value={formData.pan_card} onChange={handleInputChange} className={errors.pan_card ? "error" : inputState.pan_card ? "success" : ""} />
                    {errors.pan_card && <span className="error-message">{errors.pan_card}</span>}
                </div>

                <div className="form-field">
                    <label><Phone size={14} /> Mobile Number<span className="required">*</span> <span className="required" style={{ fontSize: '10px' }}>(10-digits only)</span></label>
                    <input type="text" name="mobile" placeholder="Mobile Number" value={formData.mobile} onChange={handleInputChange} maxLength={10} inputMode="numeric" pattern="[0-9]*" className={errors.mobile ? "error" : inputState.mobile ? "success" : ""} />
                    {errors.mobile && <span className="error-message">{errors.mobile}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> GST Number {formData.project === "null" && <span className="required">*</span>}</label>
                    <input type="text" maxLength={15} name="gst_num" placeholder="GST Number" value={formData.gst_num} onChange={handleInputChange} className={errors.gst_num ? "error" : inputState.gst_num ? "success" : ""} />
                    {errors.gst_num && <span className="error-message">{errors.gst_num}</span>}
                </div>

                <div className="form-field full-width">
                    <label><MapPin size={14} /> Address<span className="required">*</span></label>
                    <textarea name="address" placeholder="Address" value={formData.address} onChange={handleInputChange} rows={2} className={errors.address ? "error" : inputState.address ? "success" : ""} />
                    {errors.address && <span className="error-message">{errors.address}</span>}
                </div>
            </div>

            <div className="form-actions">
                <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                    <ChevronRight size={16} className="rotate-left" /> Previous: Vehicle Details
                </button>
                <div className="submit-buttons">
                    <button type="button" className="btn-secondaryy" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="submit" className="btn-primaryy" disabled={loading || tabHasMissingFields('bank')}>
                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                        <span>{loading ? 'Updating...' : 'Update'}</span>
                    </button>
                </div>
            </div>

            {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                <div className="tab-error-message" style={{ marginTop: '12px' }}>
                    <AlertCircle size={14} />
                    <span>{getCurrentTabErrorMessage()}</span>
                </div>
            )}
        </div>
    );

    const renderCurrentSection = () => {
        switch (activeSection) {
            case 'vehicle': return renderVehicleSection();
            case 'bank': return renderBankSection();
            default: return renderVehicleSection();
        }
    };

    return (
        <div>
            <button title='Update Vehicle Details' className="model-edit-button-modern actionn-icon" style={{ background: "#00000075" }} onClick={handleShow}>
                <UpdatePencil modernButton="true" />
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Truck size={24} />
                            </div>
                            <div>
                                <Modal.Title>Update Vehicle Details</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Update the details of this vehicle</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="section-navigation">
                            {sections.map((section) => {
                                const Icon = section.icon;
                                const hasMissing = tabHasMissingFields(section.id);
                                return (
                                    <button
                                        key={section.id}
                                        className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissing && section.id !== activeSection ? 'has-warning' : ''}`}
                                        onClick={() => {
                                            if (activeSection !== section.id) {
                                                if (validateCurrentTab()) {
                                                    setActiveSection(section.id);
                                                } else {
                                                    const formContainer = document.querySelector('.modern-modal-body');
                                                    if (formContainer) formContainer.scrollTop = 0;
                                                }
                                            }
                                        }}
                                    >
                                        <Icon size={16} />
                                        <span>{section.label}</span>
                                        {hasMissing && section.id !== activeSection && (
                                            <div className="warning-dot" title="Missing required fields" />
                                        )}
                                        {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                                    </button>
                                );
                            })}
                        </div>

                        <form onSubmit={handleFormSubmit} className="project-form">
                            {renderCurrentSection()}
                        </form>

                        <p className="error-message" style={{ marginTop: '12px' }}>
                            {!isSubmitted && Object.keys(errors).length > 5 && (
                                <span>Please fill all mandatory fields!</span>
                            )}
                        </p>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </div>
    )
}

const DeleteVehicle = ({ i, getVehicle }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            let res = await axios.delete(`${BASE_URL}/siteproject/vehicle/${i.id}/`);

            if (res.status === 200) {
                await getVehicle();
                toast.dismiss(loadingToastId);
                toast.success("Deleted Successfully");
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Vehicle" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#fff"
                    />
                </svg>
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
                    <Modal.Header className="modern-modal-header requirement-modal-header">
                        <div className="header-content">
                            <div className="requirement-header-icon">
                                <Trash2 size={22} />
                            </div>
                            <div>
                                <Modal.Title>Delete Vehicle</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    This action cannot be undone
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body requirement-modal-body">
                        <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
                            <AlertCircle size={16} />
                            <span>
                                Are you sure you want to delete <strong>{i.name}</strong>'s vehicle details?
                            </span>
                        </div>

                        <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
                            <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-primaryy"
                                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                                onClick={handleFormSubmitDelete}
                                disabled={loading}
                            >
                                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                                <span>{loading ? 'Deleting...' : 'Delete'}</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
}


const AddVehicleLogDetails = ({ getVehicleLogDetail, projectid, subCompanyid, projectList }) => {
    const [vehicleList, setVehicleList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [show, setShow] = useState(false);
    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const [project, setProject] = useState(projectid ? projectid : "null");
    const [activeSection, setActiveSection] = useState('vehicle');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [tabValidationAttempted, setTabValidationAttempted] = useState({});

    const sections = [
        { id: 'vehicle', label: 'Vehicle & Project', icon: Truck },
        { id: 'trip', label: 'Trip Timing', icon: Clock },
        { id: 'details', label: 'Personnel & Purpose', icon: Users },
    ];

    // Which fields belong to which tab — used for per-tab validation
    const tabRequiredFields = {
        vehicle: ["project", "vehicle", "date"],
        trip: ["from_time", "to_time", "commencement_of_trip", "conclusion_of_trip"],
        details: ["employee", "purpose_and_place"],
    };

    const initialFormData = {
        vehicle: "",
        date: "",
        from_time: "10:00:00",
        to_time: "17:30:00",
        commencement_of_trip: "",
        conclusion_of_trip: "",
        person_using_conveyance: "",
        other_person: "",
        purpose_and_place: "",
        employee: [],
        project: project,
    };

    const handleShow = () => {
        setShow(true);
        setErrors({});
        setTabValidationAttempted({});
        setActiveSection('vehicle');
    };

    const handleClose = (event) => {
        if (event) event.preventDefault();
        setShow(false);
        setFormData(initialFormData);
        setProject(projectid ? projectid : "null");
        setErrors({});
        setTabValidationAttempted({});
        setActiveSection('vehicle');
    };

    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            project: project,
        }));

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.project;
            return updatedErrors;
        });
    }, [project]);

    const getEmployee = async () => {
        try {
            const emp = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${formData.project ? formData.project : "null"}/null/`);
            setEmployeeList(emp.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
        }
    };
    const getVehicle = async () => {
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapi/${formData.project ? formData.project : "null"}/`);
            setVehicleList(veh.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
        }
    };

    // !  ************** Validation start **************  ! //
    const [errors, setErrors] = useState({});
    const [inputState] = useState({});

    // Extra conditional-required checks used by both full validate and per-tab validate
    const getConditionalErrors = () => {
        const condErrors = {};
        if (!formData.to_time) {
            condErrors.to_time = "To time is required.";
        } else if (formData.to_time <= formData.from_time) {
            condErrors.to_time = "To time must be later than From time.";
        }
        if (formData.date) {
            const selectedDateObj = new Date(formData.date);
            selectedDateObj.setHours(0, 0, 0, 0);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (selectedDateObj > today) {
                condErrors.date = "Future date is not allowed";
            }
        }
        if (formData.conclusion_of_trip && Number(formData.conclusion_of_trip) <= Number(formData.commencement_of_trip)) {
            condErrors.conclusion_of_trip = "Conclusion of Trip must be greater than Commencement of Trip";
        }
        return condErrors;
    };

    const validateForm = () => {
        const newErrors = { ...getConditionalErrors() };
        const requiredFields = [
            "vehicle",
            "date",
            "from_time",
            "to_time",
            "commencement_of_trip",
            "conclusion_of_trip",
            "purpose_and_place",
            "employee",
            "project",
        ];

        requiredFields.forEach((field) => {
            if (field === "employee") {
                if (!formData.employee || formData.employee.length === 0) {
                    newErrors.employee = "Employee is required !";
                }
            } else if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Validate only the fields belonging to the current tab
    const validateCurrentTab = () => {
        const currentTab = activeSection;
        const condErrors = getConditionalErrors();
        const newErrors = {};
        const fieldsToValidate = tabRequiredFields[currentTab] || [];

        fieldsToValidate.forEach((field) => {
            if (field === "employee") {
                if (!formData.employee || formData.employee.length === 0) {
                    newErrors.employee = "Employee is required !";
                }
            } else if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        // Fold in conditional errors relevant to this tab's fields
        Object.keys(condErrors).forEach((key) => {
            if (fieldsToValidate.includes(key)) newErrors[key] = condErrors[key];
        });

        setErrors((prev) => {
            const updated = { ...prev, ...newErrors };
            fieldsToValidate.forEach((field) => {
                const stillInvalid = field in newErrors;
                if (!stillInvalid) delete updated[field];
            });
            return updated;
        });

        setTabValidationAttempted((prev) => ({ ...prev, [currentTab]: true }));

        return Object.keys(newErrors).length === 0;
    };

    const hasCurrentTabErrors = () => {
        const currentTab = activeSection;
        const fieldsToValidate = tabRequiredFields[currentTab] || [];
        return fieldsToValidate.some((field) => errors[field]);
    };

    const getCurrentTabErrorMessage = () => {
        const currentTab = activeSection;
        const missingFields = (tabRequiredFields[currentTab] || [])
            .filter((field) => {
                if (field === "employee") return !formData.employee || formData.employee.length === 0;
                return !formData[field];
            })
            .map((field) => field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '));

        if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
        if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
        if (missingFields.length > 1) return `Please fill all required fields in ${sections.find(s => s.id === currentTab)?.label} before proceeding`;
        return `Please fix the errors in this section before proceeding`;
    };

    // Does a given tab have any missing required field? (for the warning dot)
    const tabHasMissingFields = (tabId) => {
        const fieldsToValidate = tabRequiredFields[tabId] || [];
        return fieldsToValidate.some((field) => {
            if (field === "employee") return !formData.employee || formData.employee.length === 0;
            return !formData[field];
        });
    };
    // ?  ************** Validation End **************  ! //

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));

        if (name === "date" && value) {
            const selectedDateObj = new Date(value);
            selectedDateObj.setHours(0, 0, 0, 0);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (selectedDateObj > today) {
                setErrors((prev) => ({ ...prev, date: "Future date is not allowed !" }));
                return;
            } else {
                setErrors((prev) => { const n = { ...prev }; delete n.date; return n; });
            }
        } else if (value) {
            setErrors((prev) => { const n = { ...prev }; delete n[name]; return n; });
        }

        if (name === 'commencement_of_trip') {
            setErrors(prevState => {
                const n = { ...prevState };
                delete n.conclusion_of_trip;   // ← always deletes, never re-checks
                return n;
            });
        }

        if (name === 'conclusion_of_trip') {
            if (Number(value) <= Number(formData.commencement_of_trip)) {
                setErrors(prevState => ({
                    ...prevState,
                    conclusion_of_trip: 'Conclusion of Trip must be greater than Commencement of Trip',
                }));
            } else {
                setErrors(prevState => {
                    const n = { ...prevState };
                    delete n.conclusion_of_trip;
                    return n;
                });
            }
        }

        if (name === 'commencement_of_trip') {
            setErrors(prevState => {
                const n = { ...prevState };
                delete n.conclusion_of_trip;
                return n;
            });
        }
    };

    const [loading, setLoading] = useState(false);

    const handleFormSubmit = async (e) => {
        if (e) e.preventDefault();
        if (!validateForm()) return;

        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            let ress = await axios.post(`${BASE_URL}/siteproject/vehiclelogdetail/`, formData);

            if (ress.status === 200) {
                getVehicleLogDetail ? await getVehicleLogDetail() : window.location.reload();
                toast.dismiss(loadingToastId);
                toast.success("Vehicle Log Added Successfully");
                handleClose();
            } else {
                alert(ress);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    useEffect(() => {
        if (formData.project !== "null") {
            getVehicle();
            getEmployee();
        } else {
            setVehicleList([]);
            setEmployeeList([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.project]);

    const generateTimeOptions = (startTime = "00:00") => {
        const times = [];
        let current = new Date(`2024-01-01T${startTime}:00`);
        const end = new Date(`2024-01-01T23:59:00`);

        while (current <= end) {
            times.push(current.toTimeString().slice(0, 5));
            current.setMinutes(current.getMinutes() + 30);
        }
        return times;
    };

    const options = [
        {
            value: 'Select Employee',
            label: 'Select Employee',
        },
        ...employeeList
            .filter(i => i.employee_status === "active")
            .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
            .map((e) => ({
                value: e.id,
                label: `${e.emp_code} - ${e.name}`,
            })),
    ];

    const handleChangecc = (selected) => {
        const employee = selected.length > 0 ? selected.map((item) => item.value) : "";
        setFormData((prevState) => ({
            ...prevState,
            employee,
        }));
        setErrors((prev) => {
            const n = { ...prev };
            if (selected.length > 0) delete n.employee;
            return n;
        });
    };

    const timeOptions = generateTimeOptions(formData.from_time || "00:00");
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const vehicleOptions = vehicleList
        ?.filter((i) => {
            if (!i.end_date) return true;
            const endDate = new Date(i.end_date);
            endDate.setHours(0, 0, 0, 0);
            return endDate >= today;
        })
        ?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }))
        .map((i) => ({
            value: i.id,
            label: `${i.vehicle_num} - ${i.name}`,
        }));

    // Tab switch — validates current tab first, blocks switch on failure
    const handleTabSwitch = (targetTabId) => {
        if (activeSection === targetTabId) return;
        if (validateCurrentTab()) {
            setActiveSection(targetTabId);
            const modalBody = document.querySelector('.modern-modal-body');
            if (modalBody) modalBody.scrollTop = 0;
        } else {
            const modalBody = document.querySelector('.modern-modal-body');
            if (modalBody) modalBody.scrollTop = 0;
        }
    };

    const goToNextTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        const nextTab = sections[currentIndex + 1]?.id;
        if (!nextTab) return;
        handleTabSwitch(nextTab);
    };
    const goToPreviousTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        if (currentIndex > 0) setActiveSection(sections[currentIndex - 1].id);
    };

    const renderVehicleSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Truck size={18} />
                <h4>Vehicle & Project</h4>
            </div>
            <div className="form-grid">
                {siteRole !== 'SiteManagement' && (
                    <div className="form-field">
                        <Projects inputvalue="project" usedFor="form" toggleProject={project} setToggleProject={setProject} value="id" subcompany={subCompanyid} error={errors.project} SetErrors={setErrors} cssType="modern" />
                        {errors.project && <span className="error-message">{errors.project}</span>}
                    </div>
                )}

                {formData.project !== "null" && (
                    <div className="form-field">
                        <label><Truck size={14} /> Vehicle<span className="required">*</span></label>
                        <Select
                            name="vehicle"
                            placeholder="Select a vehicle"
                            options={vehicleOptions}
                            isClearable
                            value={vehicleOptions?.find((opt) => opt.value === formData.vehicle)}
                            onChange={(selectedOption) => {
                                setFormData((prev) => ({ ...prev, vehicle: selectedOption ? selectedOption.value : "" }));
                                setErrors((prev) => { const n = { ...prev }; if (selectedOption) delete n.vehicle; return n; });
                            }}
                            styles={CSSForSelectModern}
                        />
                        {errors.vehicle && <span className="error-message">{errors.vehicle}</span>}
                    </div>
                )}

                <div className="form-field">
                    <label><Calendar size={14} /> Date<span className="required">*</span></label>
                    <input
                        type="date"
                        name="date"
                        max={new Date().toISOString().split("T")[0]}
                        value={formData.date}
                        onChange={handleInputChange}
                        className={errors.date ? "error" : inputState.date ? "success" : ""}
                    />
                    {errors.date && <span className="error-message">{errors.date}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons nav-buttons-wrapper">
                {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                    <div className="tab-error-message">
                        <AlertCircle size={14} />
                        <span>{getCurrentTabErrorMessage()}</span>
                    </div>
                )}
                {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
                <button type="button" className="btn-next" onClick={goToNextTab}>
                    Next: Trip Timing <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );

    const renderTripSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Clock size={18} />
                <h4>Trip Timing</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Clock size={14} /> From Time<span className="required">*</span></label>
                    <input
                        type="time"
                        name="from_time"
                        value={formData.from_time}
                        onChange={handleInputChange}
                        className={errors.from_time ? "error" : inputState.from_time ? "success" : ""}
                    />
                    {errors.from_time && <span className="error-message">{errors.from_time}</span>}
                </div>

                <div className="form-field">
                    <label><Clock size={14} /> To Time<span className="required">*</span></label>
                    <input
                        type="time"
                        name="to_time"
                        min={formData.from_time}
                        value={formData.to_time}
                        onChange={handleInputChange}
                        className={errors.to_time ? "error" : inputState.to_time ? "success" : ""}
                    />
                    {errors.to_time && <span className="error-message">{errors.to_time}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> Commencement of Trip (Initial Reading)<span className="required">*</span></label>
                    <input
                        type="number"
                        min={0}
                        name="commencement_of_trip"
                        placeholder="Commencement of Trip"
                        value={formData.commencement_of_trip}
                        onChange={handleInputChange}
                        className={errors.commencement_of_trip ? "error" : inputState.commencement_of_trip ? "success" : ""}
                    />
                    {errors.commencement_of_trip && <span className="error-message">{errors.commencement_of_trip}</span>}
                </div>

                {formData.commencement_of_trip && (
                    <div className="form-field">
                        <label><Hash size={14} /> Conclusion of Trip (Final Reading)<span className="required">*</span></label>
                        <input
                            type="number"
                            min={formData.commencement_of_trip}
                            name="conclusion_of_trip"
                            placeholder={formData.commencement_of_trip}
                            value={formData.conclusion_of_trip}
                            onChange={handleInputChange}
                            className={errors.conclusion_of_trip ? "error" : inputState.conclusion_of_trip ? "success" : ""}
                        />
                        {errors.conclusion_of_trip && <span className="error-message">{errors.conclusion_of_trip}</span>}
                    </div>
                )}
            </div>

            <div className="section-navigation-buttons dual-buttons">
                <div className="nav-buttons-wrapper">
                    <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                        <ChevronRight size={16} className="rotate-left" /> Previous
                    </button>
                    {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                        <div className="tab-error-message">
                            <AlertCircle size={14} />
                            <span>{getCurrentTabErrorMessage()}</span>
                        </div>
                    )}
                    <button type="button" className="btn-next" onClick={goToNextTab}>
                        Next: Personnel & Purpose <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );

    const renderDetailsSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Users size={18} />
                <h4>Personnel & Purpose</h4>
            </div>
            <div className="form-grid">
                <div className="form-field full-width">
                    <label><Users size={14} /> Person Using Conveyance<span className="required">*</span></label>
                    <Select
                        options={options}
                        isMulti
                        placeholder="Select Name"
                        onChange={handleChangecc}
                        styles={CSSForSelectModern}
                    />
                    {errors.employee && <span className="error-message">{errors.employee}</span>}
                </div>

                <div className="form-field full-width">
                    <label><MapPin size={14} /> Purpose And Place<span className="required">*</span></label>
                    <input
                        type="text"
                        name="purpose_and_place"
                        placeholder="Purpose And Place"
                        value={formData.purpose_and_place}
                        onChange={handleInputChange}
                        className={errors.purpose_and_place ? "error" : inputState.purpose_and_place ? "success" : ""}
                    />
                    {errors.purpose_and_place && <span className="error-message">{errors.purpose_and_place}</span>}
                </div>
            </div>

            <div className="form-actions">
                <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                    <ChevronRight size={16} className="rotate-left" /> Previous: Trip Timing
                </button>
                <div className="submit-buttons">
                    <button type="button" className="btn-secondaryy" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="button" className="btn-primaryy" onClick={handleFormSubmit} disabled={loading}>
                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                        <span>{loading ? 'Adding...' : 'Add Log'}</span>
                    </button>
                </div>
            </div>

            <p className="error-message" style={{ marginTop: '12px' }}>
                {Object.keys(errors).length > 0 && (
                    Object.keys(errors).length > 5 ? (
                        <span>Please fill all mandatory fields!</span>
                    ) : (
                        Object.keys(errors).map((field) => field.charAt(0).toUpperCase() + field.slice(1)).join(', ') + ' are required!'
                    )
                )}
            </p>
        </div>
    );

    const renderCurrentSection = () => {
        switch (activeSection) {
            case 'vehicle': return renderVehicleSection();
            case 'trip': return renderTripSection();
            case 'details': return renderDetailsSection();
            default: return renderVehicleSection();
        }
    };

    return (
        <>
            <AddDynamicButton title="Add Vehicle Log Details" logo={<Truck size={24} />} onClick={handleShow} />

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Truck size={24} />
                            </div>
                            <div>
                                <Modal.Title>Add Vehicle Log Details</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Fill in the details to add a new vehicle log</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

                    <Modal.Body className="modern-modal-body">
                        <div className="section-navigation">
                            {sections.map((section) => {
                                const Icon = section.icon;
                                const showWarning = tabValidationAttempted[activeSection] && tabHasMissingFields(section.id) && section.id !== activeSection;
                                return (
                                    <button
                                        key={section.id}
                                        className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${showWarning ? 'has-warning' : ''}`}
                                        onClick={() => handleTabSwitch(section.id)}
                                    >
                                        <Icon size={16} />
                                        <span>{section.label}</span>
                                        {showWarning && <div className="warning-dot" title="Missing required fields" />}
                                        {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                                    </button>
                                );
                            })}
                        </div>

                        <form onSubmit={handleFormSubmit} className="project-form">
                            {renderCurrentSection()}
                        </form>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};



const UpdateVehicleLogDetail = ({ getVehicleLogDetail, i }) => {
    const [vehicleList, setVehicleList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [show, setShow] = useState(false);
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const [activeSection, setActiveSection] = useState('vehicle');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [tabValidationAttempted, setTabValidationAttempted] = useState({});

    const sections = [
        { id: 'vehicle', label: 'Vehicle & Project', icon: Truck },
        { id: 'trip', label: 'Trip Timing', icon: Clock },
        { id: 'details', label: 'Personnel & Purpose', icon: Users },
    ];

    // Only the editable fields are enforced for tab validation (rest are read-only)
    const tabRequiredFields = {
        vehicle: [],
        trip: ["commencement_of_trip", "conclusion_of_trip"],
        details: ["purpose_and_place"],
    };

    const handleShow = () => {
        getEmployee();
        setShow(true);
        getVehicle();
        setFormData(i);
        getProjects();
        setErrors({});
        setTabValidationAttempted({});
        setActiveSection('vehicle');
    };

    const handleClose = (event) => {
        if (event) event.preventDefault();
        setShow(false);
        setFormData(i);
        setErrors({});
        setTabValidationAttempted({});
        setActiveSection('vehicle');
    };

    const getProjects = async () => {
        try {
            const pro = await axios.get(
                sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
                    `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                    : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
                        `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                        : `${BASE_URL}/siteproject/project/`
            );
            const sortedProjects = sortProjects(pro.data, 'site_prcode');
            setProjectList(sortedProjects);
        } catch (err) {
            handleErrorToast(err);
        }
    };
    const [projectList, setProjectList] = useState([]);

    const getEmployee = async () => {
        try {
            const emp = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${i.project_id}/null/`);
            setEmployeeList(emp.data);
        } catch (err) {
            if (err.response) {
                const errorData = err.response.data;
                if (typeof errorData.error === 'string') {
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        }
    };
    const getVehicle = async () => {
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${i.project_id}/null/`);
            setVehicleList(veh.data);
        } catch (err) {
            handleErrorToast(err);
        }
    };

    const [formData, setFormData] = useState({
        vehicle: "",
        date: "",
        from_time: "",
        to_time: "",
        commencement_of_trip: "",
        conclusion_of_trip: "",
        person_using_conveyance: "",
        employee: [],
        purpose_and_place: "",
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    // Extra conditional-required checks used by both full validate and per-tab validate
    const getConditionalErrors = () => {
        const condErrors = {};
        if (formData.conclusion_of_trip && Number(formData.conclusion_of_trip) <= Number(formData.commencement_of_trip)) {
            condErrors.conclusion_of_trip = "Conclusion of Trip must be greater than Commencement of Trip";
        }
        return condErrors;
    };

    const validateForm = () => {
        const newErrors = { ...getConditionalErrors() };
        const requiredFields = [
            "vehicle", "date", "from_time", "to_time",
            "commencement_of_trip", "conclusion_of_trip", "purpose_and_place",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] && field !== "employee") {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            } else if (formData[field]?.length === 0 && field === "employee") {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Validate only the fields belonging to the current tab
    const validateCurrentTab = () => {
        const currentTab = activeSection;
        const condErrors = getConditionalErrors();
        const newErrors = {};
        const fieldsToValidate = tabRequiredFields[currentTab] || [];

        fieldsToValidate.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        Object.keys(condErrors).forEach((key) => {
            if (fieldsToValidate.includes(key)) newErrors[key] = condErrors[key];
        });

        setErrors((prev) => {
            const updated = { ...prev, ...newErrors };
            fieldsToValidate.forEach((field) => {
                if (!(field in newErrors)) delete updated[field];
            });
            return updated;
        });

        setTabValidationAttempted((prev) => ({ ...prev, [currentTab]: true }));

        return Object.keys(newErrors).length === 0;
    };

    const hasCurrentTabErrors = () => {
        const currentTab = activeSection;
        const fieldsToValidate = tabRequiredFields[currentTab] || [];
        return fieldsToValidate.some((field) => errors[field]);
    };

    const getCurrentTabErrorMessage = () => {
        const currentTab = activeSection;
        const missingFields = (tabRequiredFields[currentTab] || [])
            .filter((field) => !formData[field])
            .map((field) => field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '));

        if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
        if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
        if (missingFields.length > 1) return `Please fill all required fields in ${sections.find(s => s.id === currentTab)?.label} before proceeding`;
        return `Please fix the errors in this section before proceeding`;
    };

    const tabHasMissingFields = (tabId) => {
        const fieldsToValidate = tabRequiredFields[tabId] || [];
        return fieldsToValidate.some((field) => !formData[field]);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });

        if (name === 'conclusion_of_trip') {
            if (Number(value) <= Number(formData.commencement_of_trip)) {
                setErrors(prevState => ({ ...prevState, conclusion_of_trip: 'Conclusion of Trip must be greater than Commencement of Trip' }));
            } else {
                setErrors(prevState => { const n = { ...prevState }; delete n.conclusion_of_trip; return n; });
            }
        } else if (value) {
            setErrors((prev) => { const n = { ...prev }; delete n[name]; return n; });
        }

        if (name === 'commencement_of_trip') {
            setErrors(prevState => { const n = { ...prevState }; delete n.conclusion_of_trip; return n; });
        }

        setFormData({ ...formData, [name]: value });
    };

    const [loading, setLoading] = useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            let ress = await axios.put(`${BASE_URL}/siteproject/vehiclelogdetail/${i.id}/`, formData);
            if (ress.status === 200) {
                await getVehicleLogDetail();
                toast.dismiss(loadingToastId);
                toast.success("Vehicle Log Updated Successfully");
                setShow(false);
            } else {
                alert(ress);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const getSelectedEmployees = () => {
        if (formData.employee?.length > 0) {
            return formData.employee.map((empId) => options.find((option) => option.value === empId)).filter((option) => option);
        }
        return options.find((option) => option.value === formData.person_using_conveyance);
    };

    const options = [
        { value: 'Select Employee', label: 'Select Employee' },
        ...employeeList
            .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
            .map((e) => ({ value: e.id, label: `${e.emp_code} - ${e.name}` })),
    ];

    const handleChangecc = (selected) => {
        const employee = selected.length > 0 ? selected.map((item) => item.value) : "";
        setFormData((prevState) => ({ ...prevState, employee }));
    };

    const handleTabSwitch = (targetTabId) => {
        if (activeSection === targetTabId) return;
        if (validateCurrentTab()) {
            setActiveSection(targetTabId);
            const modalBody = document.querySelector('.modern-modal-body');
            if (modalBody) modalBody.scrollTop = 0;
        } else {
            const modalBody = document.querySelector('.modern-modal-body');
            if (modalBody) modalBody.scrollTop = 0;
        }
    };

    const goToNextTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        const nextTab = sections[currentIndex + 1]?.id;
        if (!nextTab) return;
        handleTabSwitch(nextTab);
    };
    const goToPreviousTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        if (currentIndex > 0) setActiveSection(sections[currentIndex - 1].id);
    };

    const renderVehicleSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Truck size={18} />
                <h4>Vehicle & Project</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Truck size={14} /> Vehicle<span className="required">(Read-Only)</span></label>
                    <select
                        name="vehicle"
                        value={formData.vehicle}
                        onChange={handleInputChange}
                        disabled
                        className="readonly-field"
                    >
                        <option value="">Select a vehicle</option>
                        {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((v, index) => (
                            <option key={index} value={v.id}>{v.vehicle_num} - {v.name}</option>
                        ))}
                    </select>
                    {errors.vehicle && <span className="error-message">{errors.vehicle}</span>}
                </div>

                <div className="form-field">
                    <label><Calendar size={14} /> Date<span className="required">(Read-Only)</span></label>
                    <input
                        type="date"
                        name="date"
                        value={formData.date}
                        disabled
                        onChange={handleInputChange}
                        className="readonly-field"
                    />
                    {errors.date && <span className="error-message">{errors.date}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons nav-buttons-wrapper">
                {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                    <div className="tab-error-message">
                        <AlertCircle size={14} />
                        <span>{getCurrentTabErrorMessage()}</span>
                    </div>
                )}
                {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
                <button type="button" className="btn-next" onClick={goToNextTab}>
                    Next: Trip Timing <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );

    const renderTripSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Clock size={18} />
                <h4>Trip Timing</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Clock size={14} /> From Time<span className="required">(Read-Only)</span></label>
                    <input type="time" name="from_time" disabled value={formData.from_time} onChange={handleInputChange} className="readonly-field" />
                    {errors.from_time && <span className="error-message">{errors.from_time}</span>}
                </div>

                <div className="form-field">
                    <label><Clock size={14} /> To Time<span className="required">(Read-Only)</span></label>
                    <input type="time" name="to_time" disabled value={formData.to_time} onChange={handleInputChange} className="readonly-field" />
                    {errors.to_time && <span className="error-message">{errors.to_time}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> Commencement of Trip (Initial Reading)<span className="required">*</span></label>
                    <input
                        type="number"
                        min={0}
                        name="commencement_of_trip"
                        placeholder="Commencement of Trip"
                        value={formData.commencement_of_trip}
                        onChange={handleInputChange}
                        className={errors.commencement_of_trip ? "error" : inputState.commencement_of_trip ? "success" : ""}
                    />
                    {errors.commencement_of_trip && <span className="error-message">{errors.commencement_of_trip}</span>}
                </div>

                <div className="form-field">
                    <label><Hash size={14} /> Conclusion of Trip (Final Reading)<span className="required">*</span></label>
                    <input
                        type="number"
                        min={0}
                        name="conclusion_of_trip"
                        placeholder="Conclusion of Trip"
                        value={formData.conclusion_of_trip}
                        onChange={handleInputChange}
                        className={errors.conclusion_of_trip ? "error" : inputState.conclusion_of_trip ? "success" : ""}
                    />
                    {errors.conclusion_of_trip && <span className="error-message">{errors.conclusion_of_trip}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons dual-buttons">
                <div className="nav-buttons-wrapper">
                    <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                        <ChevronRight size={16} className="rotate-left" /> Previous
                    </button>
                    {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                        <div className="tab-error-message">
                            <AlertCircle size={14} />
                            <span>{getCurrentTabErrorMessage()}</span>
                        </div>
                    )}
                    <button type="button" className="btn-next" onClick={goToNextTab}>
                        Next: Personnel & Purpose <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );

    const renderDetailsSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Users size={18} />
                <h4>Personnel & Purpose</h4>
            </div>
            <div className="form-grid">
                <div className="form-field full-width">
                    <label><Users size={14} /> Person Using Conveyance<span className="required">(Read-Only)</span></label>
                    <Select
                        options={options}
                        isMulti
                        placeholder="Select Name"
                        isDisabled
                        onChange={handleChangecc}
                        value={getSelectedEmployees()}
                        styles={CSSForSelectModern}
                    />
                    {errors.employee && <span className="error-message">{errors.employee}</span>}
                </div>

                <div className="form-field full-width">
                    <label><MapPin size={14} /> Purpose And Place<span className="required">*</span></label>
                    <input
                        type="text"
                        name="purpose_and_place"
                        placeholder="Purpose And Place"
                        value={formData.purpose_and_place}
                        onChange={handleInputChange}
                        className={errors.purpose_and_place ? "error" : inputState.purpose_and_place ? "success" : ""}
                    />
                    {errors.purpose_and_place && <span className="error-message">{errors.purpose_and_place}</span>}
                </div>
            </div>

            <div className="form-actions">
                <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                    <ChevronRight size={16} className="rotate-left" /> Previous: Trip Timing
                </button>
                <div className="submit-buttons">
                    <button type="button" className="btn-secondaryy" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="button" className="btn-primaryy" onClick={handleFormSubmit} disabled={loading}>
                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                        <span>{loading ? 'Updating...' : 'Update'}</span>
                    </button>
                </div>
            </div>

            <p className="error-message" style={{ marginTop: '12px' }}>
                {Object.keys(errors).length > 0 && (
                    Object.keys(errors).length > 5 ? (
                        <span>Please fill all mandatory fields!</span>
                    ) : (
                        Object.keys(errors).map((field) => field.charAt(0).toUpperCase() + field.slice(1)).join(', ') + ' are required!'
                    )
                )}
            </p>
        </div>
    );

    const renderCurrentSection = () => {
        switch (activeSection) {
            case 'vehicle': return renderVehicleSection();
            case 'trip': return renderTripSection();
            case 'details': return renderDetailsSection();
            default: return renderVehicleSection();
        }
    };

    return (
        <>
            <button title='Update Vehicle Details' className="model-edit-button-modern actionn-icon" style={{ background: "#00000075" }} onClick={handleShow}>
                <UpdatePencil modernButton="true" />
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Truck size={24} />
                            </div>
                            <div>
                                <Modal.Title>Update Vehicle Log Details</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Edit trip readings and purpose</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

                    <Modal.Body className="modern-modal-body">
                        <div className="section-navigation">
                            {sections.map((section) => {
                                const Icon = section.icon;
                                const showWarning = tabValidationAttempted[activeSection] && tabHasMissingFields(section.id) && section.id !== activeSection;
                                return (
                                    <button
                                        key={section.id}
                                        className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${showWarning ? 'has-warning' : ''}`}
                                        onClick={() => handleTabSwitch(section.id)}
                                    >
                                        <Icon size={16} />
                                        <span>{section.label}</span>
                                        {showWarning && <div className="warning-dot" title="Missing required fields" />}
                                        {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                                    </button>
                                );
                            })}
                        </div>

                        <form onSubmit={handleFormSubmit} className="project-form">
                            {renderCurrentSection()}
                        </form>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};



const DeleteVehicleLogDetail = ({ getVehicleLogDetail, i }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            let res = await axios.delete(`${BASE_URL}/siteproject/vehiclelogdetail/${i.id}/`);
            if (res.status === 200) {
                await getVehicleLogDetail();
                toast.dismiss(loadingToastId);
                toast.success("Deleted Successfully");
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Vehicle" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#fff"
                    />
                </svg>
            </button>
            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
                    <Modal.Header className="modern-modal-header requirement-modal-header">
                        <div className="header-content">
                            <div className="requirement-header-icon">
                                <Trash2 size={22} />
                            </div>
                            <div>
                                <Modal.Title>Delete Vehicle Log</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    This action cannot be undone
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body requirement-modal-body">
                        <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
                            <AlertCircle size={16} />
                            <span>
                                Are you sure you want to delete the vehicle log for <strong>{i.personusingconveyance}</strong>?
                            </span>
                        </div>

                        <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
                            <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-primaryy"
                                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                                onClick={handleFormSubmitDelete}
                                disabled={loading}
                            >
                                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                                <span>{loading ? 'Deleting...' : 'Delete'}</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};


const AddVehicleBillingDetails = ({ getVehicleBillingDetail, projectid }) => {
    const [vehicleList, setVehicleList] = useState([]);
    const [show, setShow] = useState(false);


    const [setBuffering] = useState(false); //buffering logic
    const initialProject = "null";
    const [setProject] = useState(initialProject);
    const [projectList, setProjectList] = useState([]);

    const handleShow = () => {
        setShow(true);
    }
    const role = sessionStorage.getItem('sitemanagement_role');

    const [formData, setFormData] = useState({
        vehicle_owner_details: "",
        vehicle: "",
        month: "",
        year: "",
        end_date: "",
        extra_amount: "",
        final_total_amount: "",
        less_tds: "",
        payable_amount: "",
        fixed_km: "",
        fixed_bill_amt: "",
        extra_km: "",
        extra_amt_above_fix_km: "",
        total_km: "",
        extra_charges: "",
        project: projectid ? projectid : "null",
        account_holder_name: "",


    });


    console.log("projectid")
    console.log(projectid);

    console.log("object");
    console.log(formData.project)


    const getProjects = async () => {
        // setBuffering(true); //buffering logic // Start Buffering
        try {
            // const pro = await axios.get(`${BASE_URL}/siteproject/project/`);
            const pro = await axios.get(
                sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
                    `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                    : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
                        `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                        : `${BASE_URL}/siteproject/project/`
            );
            const sortedProjects = sortProjects(pro.data, 'site_prcode');
            setProjectList(sortedProjects);

        } catch (err) {
            handleErrorToast(err);
        } finally {
            // setBuffering(false);// End Buffering
        }
    };


    const getVehicle = async () => {
        // setBuffering(true); //buffering logic // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${formData.project ? formData.project : "null"}/`);
            setVehicleList(veh.data);

        } catch (err) {
            handleErrorToast(err);
        } finally {
            // setBuffering(false);// End Buffering
        }
    }

    const initialFormData = {
        vehicle_owner_details: "",
        vehicle: "",
        month: "",
        year: "",
        extra_amount: "",
        end_date: "null",
        final_total_amount: "",
        less_tds: "",
        payable_amount: "",
        fixed_km: "",
        fixed_bill_amt: "",
        extra_km: "",
        extra_amt_above_fix_km: "",
        total_km: "",
        extra_charges: "",
        project: projectid ? projectid : "null",
        account_holder_name: "",
    };



    const handleClose = (event) => {
        if (event) {
            event.preventDefault();
        }
        setErrors({});
        setShow(false);
        setFormData(initialFormData);

    }


    const monthOptions = [
        { id: "01", name: "January" },
        { id: "02", name: "February" },
        { id: "03", name: "March" },
        { id: "04", name: "April" },
        { id: "05", name: "May" },
        { id: "06", name: "June" },
        { id: "07", name: "July" },
        { id: "08", name: "August" },
        { id: "09", name: "September" },
        { id: "10", name: "October" },
        { id: "11", name: "November" },
        { id: "12", name: "December" }
    ];
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20; // starting 20 years ago
    const endYear = currentYear + 20; // up to 20 years in the future
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);


    // !  ************** Validation start **************  ! //
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "vehicle",
            "month",
            "year",
            // "extra_amount",
            "final_total_amount",
            "fixed_bill_amt",
            "end_date",


        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Update input state (for validation or UI purposes)
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        // Update form data and calculate total_km
        if (name === "vehicle") {
            const selectedVehicle = vehicleList.find((vehicle) => vehicle.id === value);

            const updatedFormData = {
                ...formData,
                [name]: value,
                fixed_km: selectedVehicle ? selectedVehicle.fixed_km : "",
                fixed_bill_amt: selectedVehicle ? selectedVehicle.fixed_bill_amt : 0,
                account_holder_name: selectedVehicle ? selectedVehicle.account_holder_name : "",
                extra_amt_above_fix_km: selectedVehicle ? selectedVehicle.extra_amt_above_fix_km : 0,
            };

            // Calculate extra amount
            updatedFormData.extra_amount =
                (updatedFormData.extra_km || 0) * (updatedFormData.extra_amt_above_fix_km || 0);


            // Calculate total_km
            updatedFormData.total_km =
                Number(updatedFormData.fixed_km || 0) + Number(updatedFormData.extra_km || 0);

            // Calculate final total amount
            updatedFormData.final_total_amount =
                updatedFormData.fixed_bill_amt +
                updatedFormData.extra_charges +
                updatedFormData.extra_amount;

            setFormData(updatedFormData);
        } else {
            const updatedFormData = {
                ...formData,
                [name]: value,
            };

            // Calculate extra amount if extra_km or extra_amt_above_fix_km is updated
            if (name === "extra_km" || name === "extra_amt_above_fix_km") {
                updatedFormData.extra_amount =
                    (updatedFormData.extra_km || 0) * (updatedFormData.extra_amt_above_fix_km || 0);
            }

            // Calculate total_km if fixed_km or extra_km is updated
            if (name === "fixed_km" || name === "extra_km") {
                updatedFormData.total_km =
                    Number(updatedFormData.fixed_km || 0) + Number(updatedFormData.extra_km || 0);
            }

            // Calculate final total amount if relevant fields are updated
            if (
                name === "fixed_bill_amt" ||
                name === "extra_km" ||
                name === "extra_amt_above_fix_km"
            ) {
                updatedFormData.final_total_amount =
                    Number(updatedFormData.fixed_bill_amt || 0) +
                    Number(updatedFormData.extra_amount || 0);
            }

            setFormData(updatedFormData);
        }
    };





    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic



            try {
                let ress = await axios.post(
                    `${BASE_URL}/siteproject/vehiclebillingdetails/
`, formData
                );

                if (ress.status === 200 || ress.status === 201) {
                    await getVehicleBillingDetail();
                    toast.dismiss(loadingToastId);
                    toast.success("Vehicle Billing Details Added Successfully");
                    handleClose();
                } else {
                    alert(ress);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    useEffect(() => {
        getProjects();
        if (formData.project !== "null") {
            getVehicle();
        }
        else {
            setVehicleList([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.project]);

    console.log(formData);

    return (



        <>
            <button title="Add Vehicle Billing Details" className="upload-svg" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clip-path="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                {" "} Vehicle Billing Details
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave  width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Add Vehicle Billing Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {
                                    role === "SiteManagement" ? "" : <>
                                        <div title="Project" className="flex-column form-group-selectt">
                                            <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                                                Project
                                            </label>
                                            <br />
                                            <select
                                                type="text"
                                                id="project"
                                                name="project"
                                                placeholder="project"
                                                value={formData.project}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.project ? "error" : inputState.project ? "success" : ""}`}
                                            >

                                                <option value="null">Select a Project</option>
                                                {projectList?.sort((a, b) => a.project_short_name.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                    <option key={index} value={i.id}>{i.project_short_name}</option>
                                                ))}
                                            </select>

                                            {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                                        </div>
                                    </>
                                }
                                <div title="Vehicle" className="flex-column form-group-selectt">
                                    <label htmlFor="vehicle" className="form-labels  font-weight500    font-size-subheading">
                                        {role === "SiteManagement" ? ("Vehicle") : ("Vehicle (Select Project First)")} <span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        type="text"
                                        id="vehicle"
                                        name="vehicle"
                                        placeholder="vehicle"
                                        value={formData.vehicle}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.vehicle ? "error" : inputState.vehicle ? "success" : ""}`}
                                    >

                                        <option value="">Select a vehicle</option>
                                        {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                            <option key={index} value={i.id}>{i.vehicle_num} - {i.name}</option>
                                        ))}
                                    </select>

                                    {errors.vehicle && <span className="error-message font-size-text ">{errors.vehicle}</span>}
                                </div>
                                <div className="flex-column">
                                    <label htmlFor='account_holder_name' className="form-labels  font-weight500 font-size-subheading" title="Vehicle Owner Name">Owner Name </label>
                                    <input
                                        id='account_holder_name'
                                        type="text"
                                        title="Final Total Amount"
                                        min={0}
                                        name="account_holder_name"
                                        placeholder="Owner Name"
                                        value={formData.account_holder_name}
                                        // onChange={handleInputChange}

                                        className={`form-input ${errors.account_holder_name ? 'error' : ''}`}
                                    />
                                    {errors.account_holder_name && <div className="error-message font-size-text">{errors.account_holder_name}</div>}
                                </div>

                                {/* <div title="vehicle_owner_details" className="flex-column form-group-selectt">
                  <label htmlFor="vehicle_owner_details" className="form-labels  font-weight500    font-size-subheading">
                    Vehicle's Owner Detail<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    type="text"
                    id="vehicle_owner_details"
                    name="vehicle_owner_details"
                    placeholder="Vehicle's Owner Detail"
                    value={formData.vehicle_owner_details}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.vehicle_owner_details ? "error" : inputState.vehicle_owner_details ? "success" : ""}`}
                  >

                    <option value="">Owner Detail</option>
                    {vehicleList?.sort((a, b) => a.account_holder_name.localeCompare(b.account_holder_name, 'en', { ignorePunctuation: true })).map((i, index) => (
                      <option key={index} value={i.id}> {i.account_holder_name}</option>
                    ))}
                  </select>
                  <div className="form-group-selection-arrow">
                    <svg

                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="25"
                      fill="currentColor"
                      className="bi bi-caret-down-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                    </svg>
                  </div>
                  {errors.vehicle_owner_details && <span className="error-message font-size-text ">{errors.vehicle_owner_details}</span>}
                </div> */}
                                <div title="Month" className="flex-column form-group-selectt">
                                    <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                        Month<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        type="text"
                                        id="month"
                                        name="month"
                                        placeholder="month"
                                        value={formData.month}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.month ? "error" : inputState.month ? "success" : ""}`}
                                    >

                                        <option value="">Select a month</option>
                                        {monthOptions.map((month) => (
                                            <option key={month.id} value={month.id}>{month.name}</option>
                                        ))}
                                    </select>

                                    {errors.month && <span className="error-message font-size-text ">{errors.month}</span>}
                                </div>
                                <div title="Year" className="flex-column form-group-selectt">
                                    <label htmlFor="year" className="form-labels  font-weight500    font-size-subheading">
                                        Year<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        type="text"
                                        id="year"
                                        name="year"
                                        placeholder="year"
                                        value={formData.year}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.year ? "error" : inputState.year ? "success" : ""}`}
                                    >

                                        <option value="">Select a Year</option>
                                        {years.map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>

                                    {errors.year && <span className="error-message font-size-text ">{errors.year}</span>}
                                </div>
                                <div className="flex-column" title="Date">
                                    <label htmlFor='end_date' className="form-labels  font-weight500 font-size-subheading">End Date<span className="required">*</span></label>
                                    <input
                                        type="date"
                                        name="end_date"
                                        placeholder="Date"
                                        value={formData.end_date}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.date ? 'error' : ''}`}
                                    />
                                    {errors.end_date && <div className="error-message font-size-text">{errors.end_date}</div>}
                                </div>
                                <div className="flex-column">
                                    <label htmlFor='fixed_km' className="form-labels  font-weight500 font-size-subheading" title="Fixed KM">Fixed KM</label>
                                    <input
                                        id='fixed_km'
                                        type="number"
                                        title="Fixed KM"
                                        min={0}
                                        name="fixed_km"
                                        placeholder="Fixed KM"
                                        value={formData.fixed_km}
                                        // onChange={handleInputChange}
                                        disabled
                                        className={`form-input ${errors.fixed_km ? 'error' : ''}`}
                                    />
                                    {errors.fixed_km && <div className="error-message font-size-text">{errors.fixed_km}</div>}
                                </div>
                                <div className="flex-column">
                                    <label htmlFor='extra_km' className="form-labels  font-weight500 font-size-subheading" title="Extra Amount">Extra KM</label>
                                    <input
                                        id='extra_km'
                                        type="number"
                                        title="Extra KM"
                                        min={0}
                                        name="extra_km"
                                        placeholder="Extra KM"
                                        value={formData.extra_km}
                                        onChange={handleInputChange}
                                        // disabled
                                        className={`form-input ${errors.extra_km ? 'error' : ''}`}
                                    />
                                    {errors.extra_km && <div className="error-message font-size-text">{errors.extra_km}</div>}
                                </div>
                                <div className="flex-column">
                                    <label htmlFor='total_km' className="form-labels  font-weight500 font-size-subheading" title="Total Amount">Total KM</label>
                                    <input
                                        id='total_km'
                                        type="number"
                                        title="Total KM"
                                        min={0}
                                        name="total_km"
                                        placeholder="Total KM"
                                        value={formData.total_km}
                                        onChange={handleInputChange}
                                        // disabled
                                        className={`form-input ${errors.total_km ? 'error' : ''}`}
                                    />
                                    {errors.total_km && <div className="error-message font-size-text">{errors.total_km}</div>}
                                </div>
                                <div className="flex-column">
                                    <label htmlFor='extra_amt_above_fix_km' className="form-labels  font-weight500 font-size-subheading" title="Extra Amount Per KM Above Fixed KM">Extra Amount Per KM Above Fixed KM</label>
                                    <input
                                        id='extra_amt_above_fix_km'
                                        type="number"
                                        title="Extra Amount Per KM Above Fixed KM"
                                        min={0}
                                        name="extra_amt_above_fix_km"
                                        placeholder="Extra Amount Per KM Above Fixed KM"
                                        value={formData.extra_amt_above_fix_km}
                                        // onChange={handleInputChange}
                                        disabled
                                        className={`form-input ${errors.extra_amt_above_fix_km ? 'error' : ''}`}
                                    />
                                    {errors.extra_amt_above_fix_km && <div className="error-message font-size-text">{errors.extra_amt_above_fix_km}</div>}
                                </div>
                                <div className="flex-column">
                                    <label htmlFor='fixed_bill_amt' className="form-labels  font-weight500 font-size-subheading" title="Fixed Amount">Fixed Amount<span className="required">*</span></label>
                                    <input
                                        id='fixed_bill_amt'
                                        type="number"
                                        title="Fixed Amount"
                                        min={0}
                                        name="fixed_bill_amt"
                                        placeholder="Fixed Amount"
                                        value={formData.fixed_bill_amt}
                                        disabled
                                        // onChange={handleInputChange}
                                        className={`form-input ${errors.fixed_bill_amt ? 'error' : ''}`}
                                    />
                                    {errors.fixed_bill_amt && <div className="error-message font-size-text">{errors.fixed_bill_amt}</div>}
                                </div>


                                <div className="flex-column">
                                    <label htmlFor='extra_amount' className="form-labels  font-weight500 font-size-subheading" title="Extra Amount">Extra Amount<span className="required">*</span></label>
                                    <input
                                        id='extra_amount'
                                        type="number"
                                        title="Extra Amount"
                                        min={0}
                                        name="extra_amount"
                                        placeholder="Extra Amount"
                                        value={formData.extra_amount}
                                        disabled
                                        // onChange={handleInputChange}
                                        className={`form-input ${errors.extra_amount ? 'error' : ''}`}
                                    />
                                    {errors.extra_amount && <div className="error-message font-size-text">{errors.extra_amount}</div>}
                                </div>



                                <div className="flex-column">
                                    <label htmlFor='final_total_amount' className="form-labels  font-weight500 font-size-subheading" title="Final Total Amount">Final Total Amount <span className="required">*</span></label>
                                    <input
                                        id='final_total_amount'
                                        type="number"
                                        title="Final Total Amount"
                                        min={0}
                                        name="final_total_amount"
                                        placeholder="Final Total Amount"
                                        value={formData.final_total_amount}
                                        // onChange={handleInputChange}
                                        disabled
                                        className={`form-input ${errors.final_total_amount ? 'error' : ''}`}
                                    />
                                    {errors.final_total_amount && <div className="error-message font-size-text">{errors.final_total_amount}</div>}
                                </div>
                                {/* <div className="flex-column">
                  <label htmlFor='less_tds' className="form-labels  font-weight500 font-size-subheading" title="Less TDS">Less TDS <span className="required">*</span></label>
                  <input
                    id='less_tds'
                    type="number"
                    title="Less TDS"
                    min={0}
                    name="less_tds"
                    placeholder="Less TDS"
                    value={formData.less_tds}
                    onChange={handleInputChange}
                    className={`form-input ${errors.less_tds ? 'is-invalid' : ''}`}
                  />
                  {errors.less_tds && <div className="error-message font-size-text">{errors.less_tds}</div>}
                </div>
                <div className="flex-column">
                  <label htmlFor='payable_amount' className="form-labels  font-weight500 font-size-subheading" title="Payable Amount">Payable Amount <span className="required">*</span></label>
                  <input
                    id='payable_amount'
                    type="number"
                    title="Payable Amount"
                    min={0}
                    name="payable_amount"
                    placeholder="Payable Amount"
                    value={formData.payable_amount}
                    onChange={handleInputChange}
                    className={`form-input ${errors.payable_amount ? 'is-invalid' : ''}`}
                  />
                  {errors.payable_amount && <div className="error-message font-size-text">{errors.payable_amount}</div>}
                </div> */}
                                <div className="button-models">
                                    <button className="model-button-cancel model-button font-weight500" onClick={(e) => handleClose(e)}>
                                        Cancel
                                    </button>
                                    <button className="model-button  font-weight500    model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                                        {loading ? 'Adding...' : 'Add'}
                                    </button>
                                </div>
                                <p className="error-message font-size-text">
                                    {isSubmitted && Object.keys(errors).length > 0 && (
                                        Object.keys(errors).length > 5 ? (
                                            <h5 className="text-center">Please fill all mandatory fields!</h5>
                                        ) : (

                                            <h6 className="text-center">
                                                {Object.keys(errors).map((field) =>
                                                    field.charAt(0).toUpperCase() + field.slice(1)
                                                ).join(', ') + ' are required!'}
                                            </h6>
                                        )
                                    )}
                                </p>
                            </form>
                        </div></div>
                </Modal.Body>
            </Modal>
        </>




    )
}


const UpdateVehicleBillingDetail = ({ getVehicleBillingDetail, i }) => {
    const [vehicleList, setVehicleList] = useState([]);
    const [show, setShow] = useState(false);
    // const [setBuffering] = useState(false); //buffering logic

    const handleShow = () => {
        setShow(true);
        setFormData(i);
        getVehicle();

    }
    const role = sessionStorage.getItem('role');


    const handleClose = (event) => {
        if (event) {
            event.preventDefault();
        }
        setShow(false);
        setFormData(i);
        // setProject(i); 
    };


    const getVehicle = async () => {
        // setBuffering(true); //buffering logic // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${i.project_id}`);
            setVehicleList(veh.data);

        } catch (err) {
            //toast Logic
            if (err.response) {
                const errorData = err.response.data;

                if (typeof errorData.error === 'string') {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            // setBuffering(false);// End Buffering
        }
    }

    const [formData, setFormData] = useState({
        vehicle_owner_details: "",
        vehicle: "",
        month: "",
        year: "",
        end_date: "null",
        extra_amount: "",
        final_total_amount: "",
        less_tds: "",
        payable_amount: "",
    });

    const monthOptions = [
        { id: "01", name: "January" },
        { id: "02", name: "February" },
        { id: "03", name: "March" },
        { id: "04", name: "April" },
        { id: "05", name: "May" },
        { id: "06", name: "June" },
        { id: "07", name: "July" },
        { id: "08", name: "August" },
        { id: "09", name: "September" },
        { id: "10", name: "October" },
        { id: "11", name: "November" },
        { id: "12", name: "December" }
    ];
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20; // starting 20 years ago
    const endYear = currentYear + 20; // up to 20 years in the future
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);


    // !  ************** Validation start **************  ! //
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "vehicle",
            "month",
            "year",
            "extra_amount",
            "final_total_amount",
            "end_date",

        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Update input state (for validation or UI purposes)
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        // Update form data and calculate total_km
        if (name === "vehicle") {
            const selectedVehicle = vehicleList.find((vehicle) => vehicle.id === value);

            const updatedFormData = {
                ...formData,
                [name]: value,
                fixed_km: selectedVehicle ? selectedVehicle.fixed_km : "",
                fixed_bill_amt: selectedVehicle ? selectedVehicle.fixed_bill_amt : 0,
                account_holder_name: selectedVehicle ? selectedVehicle.account_holder_name : "",
                extra_amt_above_fix_km: selectedVehicle ? selectedVehicle.extra_amt_above_fix_km : 0,
            };

            // Calculate extra amount
            updatedFormData.extra_amount =
                (updatedFormData.extra_km || 0) * (updatedFormData.extra_amt_above_fix_km || 0);


            // Calculate total_km
            updatedFormData.total_km =
                Number(updatedFormData.fixed_km || 0) + Number(updatedFormData.extra_km || 0);

            // Calculate final total amount
            updatedFormData.final_total_amount =
                updatedFormData.fixed_bill_amt +
                updatedFormData.extra_charges +
                updatedFormData.extra_amount;

            setFormData(updatedFormData);
        } else {
            const updatedFormData = {
                ...formData,
                [name]: value,
            };

            // Calculate extra amount if extra_km or extra_amt_above_fix_km is updated
            if (name === "extra_km" || name === "extra_amt_above_fix_km") {
                updatedFormData.extra_amount =
                    (updatedFormData.extra_km || 0) * (updatedFormData.extra_amt_above_fix_km || 0);
            }

            // Calculate total_km if fixed_km or extra_km is updated
            if (name === "fixed_km" || name === "extra_km") {
                updatedFormData.total_km =
                    Number(updatedFormData.fixed_km || 0) + Number(updatedFormData.extra_km || 0);
            }

            // Calculate final total amount if relevant fields are updated
            if (
                name === "fixed_bill_amt" ||
                name === "extra_km" ||
                name === "extra_amt_above_fix_km"
            ) {
                updatedFormData.final_total_amount =
                    Number(updatedFormData.fixed_bill_amt || 0) +
                    Number(updatedFormData.extra_amount || 0);
            }

            setFormData(updatedFormData);
        }
    };

    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic



            try {
                let ress = await axios.put(
                    `${BASE_URL}/siteproject/vehiclebillingdetails/${i.id}/`, formData);

                if (ress.status === 200) {
                    await getVehicleBillingDetail();
                    handleClose();
                } else {
                    alert(ress);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (


        <div>
            <>
                <button title='Update Billing Details' className='model-edit-button' onClick={handleShow}>
                    <UpdatePencil />
                </button>

                <Modal show={show} onHide={handleClose} dialogClassName="request-leave  width-40vw">
                    <Modal.Header closeButton>
                        <Modal.Title>Update Vehicle Billing Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
                        <div className="parent-div">
                            <div className="bdy-div">
                                <form>

                                    <div title="Vehicle" className="flex-column form-group-selectt">
                                        <label htmlFor="vehicle" className="form-labels  font-weight500    font-size-subheading">
                                            Vehicle <span className="required">*</span>
                                        </label>
                                        <br />
                                        <select
                                            type="text"
                                            id="vehicle"
                                            name="vehicle"
                                            placeholder="vehicle"
                                            value={formData.vehicle}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.vehicle ? "error" : inputState.vehicle ? "success" : ""}`}
                                        >

                                            <option value="">Select a vehicle</option>
                                            {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                <option key={index} value={i.id}>{i.vehicle_num} - {i.name}</option>
                                            ))}
                                        </select>

                                        {errors.vehicle && <span className="error-message font-size-text ">{errors.vehicle}</span>}
                                    </div>

                                    {/* <div className="flex-column">
                  <label htmlFor='account_holder_name' className="form-labels  font-weight500 font-size-subheading" title="Vehicle Owner Name">Owner Name <span className="required">*</span></label>
                  <input
                    id='account_holder_name'
                    type="text"
                    title="Final Total Amount"
                    min={0}
                    name="account_holder_name"
                    placeholder="Owner Name"
                    value={formData.account_holder_name}
                    // onChange={handleInputChange}

                    className={`form-input ${errors.account_holder_name ? 'is-invalid' : ''}`}
                  />
                  {errors.account_holder_name && <div className="error-message font-size-text">{errors.account_holder_name}</div>}
                </div> */}

                                    <div title="Month" className="flex-column form-group-selectt">
                                        <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                            Month<span className="required">*</span>
                                        </label>
                                        <br />
                                        <select
                                            type="text"
                                            id="month"
                                            name="month"
                                            placeholder="month"
                                            value={formData.month}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.month ? "error" : inputState.month ? "success" : ""}`}
                                        >

                                            <option value="">Select a month</option>
                                            {monthOptions.map((month) => (
                                                <option key={month.id} value={month.id}>{month.name}</option>
                                            ))}
                                        </select>

                                        {errors.month && <span className="error-message font-size-text ">{errors.month}</span>}
                                    </div>
                                    <div title="Year" className="flex-column form-group-selectt">
                                        <label htmlFor="year" className="form-labels  font-weight500    font-size-subheading">
                                            Year<span className="required">*</span>
                                        </label>
                                        <br />
                                        <select
                                            type="text"
                                            id="year"
                                            name="year"
                                            placeholder="year"
                                            value={formData.year}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.year ? "error" : inputState.year ? "success" : ""}`}
                                        >

                                            <option value="">Select a Year</option>
                                            {years.map((year) => (
                                                <option key={year} value={year}>{year}</option>
                                            ))}
                                        </select>

                                        {errors.year && <span className="error-message font-size-text ">{errors.year}</span>}
                                    </div>
                                    <div className="flex-column" title="Date">
                                        <label htmlFor='end_date' className="form-labels  font-weight500 font-size-subheading">End Date<span className="required">*</span></label>
                                        <input
                                            type="date"
                                            name="end_date"
                                            placeholder="Date"
                                            value={formData.end_date}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.date ? 'error' : ''}`}
                                        />
                                        {errors.end_date && <div className="error-message font-size-text">{errors.end_date}</div>}
                                    </div>
                                    <div className="flex-column">
                                        <label htmlFor='fixed_km' className="form-labels  font-weight500 font-size-subheading" title="Fixed KM">Fixed KM<span className="required">*</span></label>
                                        <input
                                            id='fixed_km'
                                            type="number"
                                            title="Fixed KM"
                                            min={0}
                                            name="fixed_km"
                                            placeholder="Fixed KM"
                                            value={formData.fixed_km}
                                            // onChange={handleInputChange}
                                            disabled
                                            className={`form-input ${errors.fixed_km ? 'is-invalid' : ''}`}
                                        />
                                        {errors.fixed_km && <div className="error-message font-size-text">{errors.fixed_km}</div>}
                                    </div>
                                    <div className="flex-column">
                                        <label htmlFor='extra_km' className="form-labels  font-weight500 font-size-subheading" title="Extra Amount">Extra KM<span className="required">*</span></label>
                                        <input
                                            id='extra_km'
                                            type="number"
                                            title="Extra KM"
                                            min={0}
                                            name="extra_km"
                                            placeholder="Extra KM"
                                            value={formData.extra_km}
                                            onChange={handleInputChange}
                                            // disabled
                                            className={`form-input ${errors.extra_km ? 'is-invalid' : ''}`}
                                        />
                                        {errors.extra_km && <div className="error-message font-size-text">{errors.extra_km}</div>}
                                    </div>
                                    {/* <div className="flex-column">
                  <label htmlFor='total_km' className="form-labels  font-weight500 font-size-subheading" title="Total Amount">Total KM<span className="required">*</span></label>
                  <input
                    id='total_km'
                    type="number"
                    title="Total KM"
                    min={0}
                    name="total_km"
                    placeholder="Total KM"
                    value={formData.total_km}
                    onChange={handleInputChange}
                    // disabled
                    className={`form-input ${errors.total_km ? 'is-invalid' : ''}`}
                  />
                  {errors.total_km && <div className="error-message font-size-text">{errors.total_km}</div>}
                </div> */}
                                    <div className="flex-column">
                                        <label htmlFor='extra_amt_above_fix_km' className="form-labels  font-weight500 font-size-subheading" title="Extra Amount Per KM Above Fixed KM">Extra Amount Per KM Above Fixed KM<span className="required">*</span></label>
                                        <input
                                            id='extra_amt_above_fix_km'
                                            type="number"
                                            title="Extra Amount Per KM Above Fixed KM"
                                            min={0}
                                            name="extra_amt_above_fix_km"
                                            placeholder="Extra Amount Per KM Above Fixed KM"
                                            value={formData.extra_amt_above_fix_km}
                                            // onChange={handleInputChange}
                                            disabled
                                            className={`form-input ${errors.extra_amt_above_fix_km ? 'is-invalid' : ''}`}
                                        />
                                        {errors.extra_amt_above_fix_km && <div className="error-message font-size-text">{errors.extra_amt_above_fix_km}</div>}
                                    </div>
                                    <div className="flex-column">
                                        <label htmlFor='fixed_bill_amt' className="form-labels  font-weight500 font-size-subheading" title="Fixed Amount">Fixed Amount<span className="required">*</span></label>
                                        <input
                                            id='fixed_bill_amt'
                                            type="number"
                                            title="Fixed Amount"
                                            min={0}
                                            name="fixed_bill_amt"
                                            placeholder="Fixed Amount"
                                            value={formData.fixed_bill_amt}
                                            disabled
                                            // onChange={handleInputChange}
                                            className={`form-input ${errors.fixed_bill_amt ? 'is-invalid' : ''}`}
                                        />
                                        {errors.fixed_bill_amt && <div className="error-message font-size-text">{errors.fixed_bill_amt}</div>}
                                    </div>


                                    {/* <div className="flex-column">
                  <label htmlFor='extra_amount' className="form-labels  font-weight500 font-size-subheading" title="Extra Amount">Extra Amount<span className="required">*</span></label>
                  <input
                    id='extra_amount'
                    type="number"
                    title="Extra Amount"
                    min={0}
                    name="extra_amount"
                    placeholder="Extra Amount"
                    value={formData.extra_amount}
                    disabled
                    // onChange={handleInputChange}
                    className={`form-input ${errors.extra_amount ? 'is-invalid' : ''}`}
                  />
                  {errors.extra_amount && <div className="error-message font-size-text">{errors.extra_amount}</div>}
                </div> */}



                                    {/* <div className="flex-column">
                  <label htmlFor='final_total_amount' className="form-labels  font-weight500 font-size-subheading" title="Final Total Amount">Final Total Amount <span className="required">*</span></label>
                  <input
                    id='final_total_amount'
                    type="number"
                    title="Final Total Amount"
                    min={0}
                    name="final_total_amount"
                    placeholder="Final Total Amount"
                    value={formData.final_total_amount}
                    // onChange={handleInputChange}
                    disabled
                    className={`form-input ${errors.final_total_amount ? 'is-invalid' : ''}`}
                  />
                  {errors.final_total_amount && <div className="error-message font-size-text">{errors.final_total_amount}</div>}
                </div> */}
                                    {/* <div className="flex-column">
                  <label htmlFor='less_tds' className="form-labels  font-weight500 font-size-subheading" title="Less TDS">Less TDS <span className="required">*</span></label>
                  <input
                    id='less_tds'
                    type="number"
                    title="Less TDS"
                    min={0}
                    name="less_tds"
                    placeholder="Less TDS"
                    value={formData.less_tds}
                    onChange={handleInputChange}
                    className={`form-input ${errors.less_tds ? 'is-invalid' : ''}`}
                  />
                  {errors.less_tds && <div className="error-message font-size-text">{errors.less_tds}</div>}
                </div>
                <div className="flex-column">
                  <label htmlFor='payable_amount' className="form-labels  font-weight500 font-size-subheading" title="Payable Amount">Payable Amount <span className="required">*</span></label>
                  <input
                    id='payable_amount'
                    type="number"
                    title="Payable Amount"
                    min={0}
                    name="payable_amount"
                    placeholder="Payable Amount"
                    value={formData.payable_amount}
                    onChange={handleInputChange}
                    className={`form-input ${errors.payable_amount ? 'is-invalid' : ''}`}
                  />
                  {errors.payable_amount && <div className="error-message font-size-text">{errors.payable_amount}</div>}
                </div> */}
                                    <div className="button-models">
                                        <button className="model-button-cancel model-button font-weight500" onClick={(e) => handleClose(e)}>
                                            Cancel
                                        </button>
                                        <button className="model-button  font-weight500    model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                                            {loading ? 'Updating...' : 'Update'}
                                        </button>
                                    </div>
                                </form>
                            </div></div>
                    </Modal.Body>
                </Modal>
            </>

        </div>


    )
}

const DeleteVehicleBillingDetail = ({ getVehicleBillingDetail, i }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            let res = await axios.delete(`${BASE_URL}/siteproject/vehiclebillingdetails/${i.id}/`);
            if (res.status === 200) {
                await getVehicleBillingDetail();
                toast.dismiss(loadingToastId);
                toast.success("Deleted Successfully");
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Vehicle Billing" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#fff"
                    />
                </svg>
            </button>
            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
                    <Modal.Header className="modern-modal-header requirement-modal-header">
                        <div className="header-content">
                            <div className="requirement-header-icon">
                                <Trash2 size={22} />
                            </div>
                            <div>
                                <Modal.Title>Delete Vehicle Billing Detail</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    This action cannot be undone
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body requirement-modal-body">
                        <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
                            <AlertCircle size={16} />
                            <span>
                                Are you sure you want to delete the vehicle billing detail for <strong>{i.vehicleownerdetails}</strong>?
                            </span>
                        </div>

                        <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
                            <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-primaryy"
                                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                                onClick={handleFormSubmitDelete}
                                disabled={loading}
                            >
                                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                                <span>{loading ? 'Deleting...' : 'Delete'}</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const BulkBillingForVehicle = ({ vehicleList, projectId, getData, subCompanyid, list }) => {
    const [show, setShow] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const siteempId = sessionStorage.getItem("sitemanagement_emp_id");
    const [projectIds, setProjectIds] = useState([]);
    const [month, setMonth] = useState("null");
    const [year, setyear] = useState("null");
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [vehicleBillingDetails, setVehicleBillingDetails] = useState([]);
    const [expandedRow, setExpandedRow] = useState(null);

    const Option = (props) => (
        <components.Option {...props}>
            <label title="Star" className="star">
                <input id="star-checkbox" checked={props.isSelected} onChange={() => null} className="checkbox" type="checkbox" />
                <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" className="svg-outline" viewBox="0 0 24 24">
                        <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" className="svg-filled" viewBox="0 0 24 24">
                        <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" className="svg-celebrate">
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                    </svg>
                </div>
            </label>
            {props.label}
        </components.Option>
    );

    const MenuList = (props) => {
        const { options, selectProps } = props;
        const filteredOptions = options.filter((opt) => opt.label.toLowerCase() !== "other");
        const selectedValues = selectProps.value?.map((i) => i.value) || [];
        const filteredValues = filteredOptions.map((i) => i.value);
        const isAllSelected = filteredValues.every((val) => selectedValues.includes(val));

        const handleToggle = () => {
            if (isAllSelected) {
                const preserveOther = selectProps.value?.filter((i) => i.label.toLowerCase() === "other") || [];
                selectProps.onChange(preserveOther);
            } else {
                const preserveOther = selectProps.value?.filter((i) => i.label.toLowerCase() === "other") || [];
                selectProps.onChange([...filteredOptions, ...preserveOther]);
            }
        };

        return (
            <components.MenuList {...props}>
                <button
                    type="button"
                    onClick={handleToggle}
                    style={{
                        width: "100%", padding: "8px 0", fontSize: "13px", cursor: "pointer",
                        fontWeight: "600", borderBottom: "1px solid #e3e3e3", background: "white", color: "#667eea"
                    }}
                >
                    {isAllSelected ? "Unselect All" : "Select All"}
                </button>
                {props.children}
            </components.MenuList>
        );
    };

    const handleShow = () => setShow(true);

    const monthOptions = [
        { id: "01", name: "January" }, { id: "02", name: "February" }, { id: "03", name: "March" },
        { id: "04", name: "April" }, { id: "05", name: "May" }, { id: "06", name: "June" },
        { id: "07", name: "July" }, { id: "08", name: "August" }, { id: "09", name: "September" },
        { id: "10", name: "October" }, { id: "11", name: "November" }, { id: "12", name: "December" }
    ];
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20;
    const endYear = currentYear;
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

    const monthListView = monthOptions.map((i) => ({ value: i.id, label: i.name }));
    const handlemonthListViews = (options) => setMonth(options ? options.value : "null");
    const yearListView = years.slice().sort((a, b) => b - a).map(i => ({ value: i, label: i }));
    const handleyearListViews = (options) => setyear(options ? options.value : "null");

    const [status, setStatus] = useState(0);

    const getProjectdata = async () => {
        try {
            const resUrl = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${siteRole === "AuthorityEngineer" ? siteempId : "null"}/null/${siteRole === "DataEntryOperator" ? siteempId : "null"}/null/`);
            setProjectList(resUrl.data);
            setStatus(resUrl.status);
        } catch (error) {
            toast.error(error);
        }
    };

    useEffect(() => {
        if (show === true && projectList.length === 0) {
            getProjectdata();
        }
    }, [siteRole, show, siteempId, projectList]);

    const projectoption = projectList.sort((a, b) => a.site_prcode - b.site_prcode).map((i) => ({
        value: i.id, label: `${i.site_prcode} - ${i.project_short_name}`
    }));

    const handleProjectOptions = (options) => {
        if (!options || options.length === 0) setProjectIds([]);
        else setProjectIds(options.map(opt => opt.value));
    };

    const [logList, setLogList] = useState([]);

    const getLogs = async () => {
        try {
            const urlResponse = await axios.get(`${BASE_URL}/siteproject/vehiclelogdetailprojectfilter/null/${month}/${year}/`);
            setLogList(urlResponse.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (show === true && year !== "null" && month !== "null") {
            getLogs();
            getVehicleBillingDetail();
        }
    }, [show, month, year]);

    const [getVehicles, setGetVehicles] = useState([]);

    useEffect(() => {
        if (projectIds.length !== 0) {
            setGetVehicles(vehicleList.filter((i) => projectIds.includes(i.project)));
        }
    }, [projectIds]);

    const [getLog, setGetLog] = useState([]);

    useEffect(() => {
        if (logList.length !== 0) {
            setGetLog(logList.filter((i) => projectIds.includes(i.project_id)));
        }
    }, [logList, projectIds]);

    useEffect(() => {
        setLogList([]);
        setyear("null");
        setMonth("null");
    }, [projectIds]);

    const getLogIds = [...new Set(getLog.map(i => i.vehicle))];
    const getVehiclesDetails = getVehicles.filter(vehicle => getLogIds.includes(vehicle.id));

    const result = Object.values(
        getLog.reduce((acc, i) => {
            const km = Number(i.conclusion_of_trip) - Number(i.commencement_of_trip);
            acc[i.vehicle] = acc[i.vehicle]
                ? { ...acc[i.vehicle], total_km: acc[i.vehicle].total_km + km }
                : { id: i.vehicle, total_km: km };
            return acc;
        }, {})
    );

    const [formData, setFormData] = useState([{
        project_id: "null", month: "", year: "", total_km: "", fixed_km: "", extra_km: "",
        fixed_bill_amt: "", extra_amt_above_fix_km: "", extra_charges: "", billing_type: "",
        km_per_ltr: "", fuel_price: "", bank_name: "", acc_number: "", gst_number: "",
        pan_card: "", acc_holder_name: "", ifsc_code: "", mobile_number: "", vehicle: "null",
        project_short_name: "", project_code: "", vehicle_no: "", vehicle_name: "",
    }]);

    const vehicleNumbers = getVehiclesDetails.map(v => v.vehicle_num);
    const getBillingData = vehicleBillingDetails.filter((i) => vehicleNumbers.includes(i.vehicle_num));
    const getNumbers = getBillingData.map(v => v.vehicle_num);
    const getBillingIds = getBillingData.map(v => v.vehicle);
    const vehicleFilterWithid = getVehiclesDetails.filter(vehicle => !getBillingIds.includes(vehicle.id));

    const handleClose = () => {
        setShow(false);
        setFormData([{
            project_id: "null", month: "", year: "", total_km: "", fixed_km: "", extra_km: "",
            fixed_bill_amt: "", extra_amt_above_fix_km: "", extra_charges: "", billing_type: "",
            km_per_ltr: "", fuel_price: "", bank_name: "", acc_number: "", gst_number: "",
            pan_card: "", acc_holder_name: "", ifsc_code: "", mobile_number: "", vehicle: "null",
            project_short_name: "", project_code: "", vehicle_no: "", vehicle_name: "",
        }]);
        setSelectedRows(new Set());
        setProjectIds([]);
        setyear("null");
        setMonth("null");
    };

    const handleCheckboxChange = (id) => {
        setSelectedRows(prev => {
            const updated = new Set(prev);
            if (updated.has(id)) updated.delete(id);
            else updated.add(id);
            return updated;
        });
    };

    const handleSelectAll = () => setSelectedRows(new Set(formData.map(l => l.vehicle)));
    const handleUndoAll = () => setSelectedRows(new Set());
    const isInitialized = useRef(false);
    const prevResultLength = useRef(0);
    const prevResultRef = useRef([]);

    useEffect(() => {
        if (month === "null" || year === "null" || projectIds.length === 0) return;
        if (!Array.isArray(vehicleFilterWithid) || vehicleFilterWithid.length === 0) return;

        setFormData(prev => {
            const updated = vehicleFilterWithid.map(vehicle => {
                const vehicleKmObj = result.find(r => r.id === vehicle.id);
                const totalKm = vehicleKmObj ? Number(vehicleKmObj.total_km) : 0;
                const fixedKm = Number(vehicle.fixed_km) || 0;
                const rate = Number(vehicle.extra_amt_above_fix_km) || 0;
                const extraKm = totalKm > fixedKm ? totalKm - fixedKm : 0;
                const extraCharges = extraKm * rate;

                return {
                    project_id: vehicle.project, month, year, total_km: totalKm, fixed_km: fixedKm,
                    extra_km: extraKm, fixed_bill_amt: vehicle.fixed_bill_amt, extra_amt_above_fix_km: rate,
                    extra_charges: extraCharges, billing_type: vehicle.select_billing_type,
                    km_per_ltr: vehicle.km_per_lit, fuel_price: vehicle.fuel_price, bank_name: vehicle.bank_name,
                    acc_number: vehicle.account_num, gst_number: vehicle.gst_num, pan_card: vehicle.pan_card,
                    acc_holder_name: vehicle.account_holder_name, ifsc_code: vehicle.ifsc_code,
                    mobile_number: vehicle.mobile, vehicle: vehicle.id, vehicle_no: vehicle.vehicle_num,
                    vehicle_name: vehicle.name, project_short_name: vehicle.project_short_name
                };
            });

            const isSame = prev.length === updated.length &&
                prev.every((p, i) => p.total_km === updated[i].total_km && p.extra_km === updated[i].extra_km && p.extra_charges === updated[i].extra_charges);

            if (isSame) return prev;
            return updated;
        });
    }, [vehicleFilterWithid, projectIds, month, year, result]);

    useEffect(() => {
        isInitialized.current = false;
    }, [projectIds, year, month]);

    const getVehicleBillingDetail = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/filter-vehicle-billing/null/null/${month}/${year}/null/`);
            setVehicleBillingDetails(response.data);
        } catch (err) {
            handleErrorToast(err);
        }
    };

    useEffect(() => {
        setFormData([{
            project_id: "null", month: "", year: "", total_km: "", fixed_km: "", extra_km: "",
            fixed_bill_amt: "", extra_amt_above_fix_km: "", extra_charges: "", billing_type: "",
            km_per_ltr: "", fuel_price: "", bank_name: "", acc_number: "", gst_number: "",
            pan_card: "", acc_holder_name: "", ifsc_code: "", mobile_number: "", vehicle: "null",
            project_short_name: "", project_code: "", vehicle_no: "", vehicle_name: "",
        }]);
    }, [projectIds]);

    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [duplicateError, setDuplicateError] = useState(false);

    useEffect(() => {
        setDuplicateError(getNumbers.length !== 0);
    }, [getNumbers]);

    const validateForm = () => {
        const newErrors = {};
        if (projectIds.length === 0) newErrors.projectIds = "This field is required!";
        setErrors(newErrors);
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Uploading: please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/newvehiclebillingbulkcreate/`, formData);
            if (res.status === 201) {
                await getData();
                toast.dismiss(loadingToastId);
                toast.success("Vehicle Bill added successfully.", { autoClose: 1000, pauseOnHover: true, closeOnClick: true });
                handleClose();
            } else {
                throw new Error("Unexpected response status: " + res.status);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleRemoveRow = (removeIndex) => {
        setFormData(prev => prev.filter((_, index) => index !== removeIndex));
    };

    const handleTotalKmChange = (index, value) => {
        const totalKm = Number(value) || 0;
        setFormData(prev => {
            const updated = [...prev];
            const row = { ...updated[index] };
            row.total_km = totalKm;
            const fixedKm = Number(row.fixed_km) || 0;
            const rate = Number(row.extra_amt_above_fix_km) || 0;
            row.extra_km = totalKm > fixedKm ? totalKm - fixedKm : 0;
            row.extra_charges = row.extra_km * rate;
            updated[index] = row;
            return updated;
        });
    };

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const getTotalAmount = (item) => {
        if (item.billing_type === "As per fuel") {
            return (Number(item.total_km) / Number(item.km_per_ltr)) * Number(item.fuel_price);
        }
        return Number(item.extra_charges || 0) + Number(item.fixed_bill_amt || 0);
    };

    const showPreviewTable = ((projectIds.length !== 0 || projectId !== "null") && (month !== "null" && year !== "null")) && vehicleFilterWithid.length !== 0;
    const showEmptyLoader = ((projectIds.length !== 0 || projectId !== "null") && (month !== "null" && year !== "null")) && vehicleFilterWithid.length === 0;

    return (
        <>
            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <>
                    <AddDynamicButton title="Generate Bills" logo={<ReceiptIndianRupeeIcon size={24} />} onClick={handleShow} />

                    {/* <button className="doc-trigger-btn primary" onClick={handleShow}>
                        <FilePlus2 size={13} /> Generate Bills
                    </button> */}

                    <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                        <Modal.Header className="modern-modal-header">
                            <div className="header-content">
                                <div style={{ color: "white" }}>
                                    <ReceiptIndianRupeeIcon size={24} />
                                </div>
                                <div>
                                    <Modal.Title>Generate Bills</Modal.Title>
                                    <p className="header-subtitle" style={{ color: "white" }}>Bulk-generate vehicle billing for selected projects</p>
                                </div>
                            </div>
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Header>

                        <Modal.Body className="modern-modal-body">
                            <div className="form-section">
                                <div className="section-title">
                                    <Filter size={18} />
                                    <h4>Select Criteria</h4>
                                </div>

                                <div className="form-grid">
                                    <div >
                                        <label><Briefcase size={14} /> Site Project<span className="required">*</span></label>
                                        {status === 200 ? (
                                            <Select
                                                options={projectoption}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                placeholder="Select Projects"
                                                onChange={handleProjectOptions}
                                                value={projectoption.filter((opt) => projectIds?.includes(opt.value))}
                                                styles={CSSForSelectModern}
                                            />
                                        ) : (
                                            <div className="loader-minimal" style={{ padding: '20px 0' }}>
                                                <div className="spinner-minimal"></div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-field">
                                        <label><Clock size={14} /> Year<span className="required">*</span></label>
                                        <Select
                                            options={yearListView}
                                            isClearable
                                            placeholder="Select Year"
                                            onChange={handleyearListViews}
                                            value={yearListView.find(opt => opt.value === year) || null}
                                            styles={CSSForSelectModern15VWWidth}
                                        />
                                    </div>

                                    <div className="form-field">
                                        <label><Calendar size={14} /> Month<span className="required">*</span></label>
                                        <Select
                                            options={monthListView}
                                            isClearable
                                            placeholder="Select Month"
                                            onChange={handlemonthListViews}
                                            value={monthListView.find(opt => opt.value === month) || null}
                                            styles={CSSForSelectModern15VWWidth}
                                        />
                                    </div>
                                </div>
                            </div>

                            {showPreviewTable ? (
                                <div className="table-wrapper-minimal table-box scroll-container-table" style={{ marginTop: '16px' }}>
                                    <table className="progress-table-minimal">
                                        <thead className="table-heading">
                                            <tr>
                                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                                <th className="col-period" style={{ width: '15%' }}>Project</th>
                                                <th className="col-period text-center">Vehicle Details</th>
                                                <th className="col-submitted text-center" style={{ width: '15%' }}>Billing Type</th>
                                                <th className="col-approved text-center" style={{ width: '15%' }}>Total Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formData.map((item, index) => {
                                                const isExpanded = expandedRow === index;
                                                const isDuplicate = getNumbers.includes(item.vehicle_no);
                                                const totalAmount = getTotalAmount(item);

                                                return (
                                                    <React.Fragment key={index}>
                                                        <tr className={`progress-row ${isDuplicate ? 'has-pending' : ''}`}>
                                                            <td className="col-sno text-start">{index + 1}.</td>
                                                            <td className="col-period">{item.project_short_name}</td>
                                                            <td className="col-period">
                                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                                    <Truck size={12} />
                                                                    <span>{item.vehicle_name} • {item.vehicle_no}</span>
                                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                                </button>
                                                                {isDuplicate && (
                                                                    <div style={{ fontSize: '10px', color: '#ef4444', marginTop: '4px', paddingLeft: '4px', fontWeight: 600 }}>
                                                                        Already billed this period
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="col-submitted text-center">
                                                                <span className="badge-value">{item.billing_type || "-"}</span>
                                                            </td>
                                                            <td className="col-approved text-center">
                                                                <span className="badge-value">₹{formatCurrencyIndian(totalAmount.toFixed(2))}</span>
                                                            </td>
                                                        </tr>

                                                        {isExpanded && (
                                                            <tr className="expanded-row">
                                                                <td colSpan={5}>
                                                                    <div className="expanded-content-attractive">
                                                                        <div className="expanded-content-header">
                                                                            <div className="expanded-content-title">
                                                                                <Sparkles size={13} />
                                                                                <span>Billing Breakdown</span>
                                                                            </div>
                                                                        </div>

                                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                                <div className="stage-header">
                                                                                    <Truck size={14} />
                                                                                    <span>Vehicle Rate Details</span>
                                                                                </div>
                                                                                <div className="stage-content">
                                                                                    {item.billing_type === "As per fuel" ? (
                                                                                        <>
                                                                                            <div className="stage-row"><span className="stage-label">Fuel Price</span><span className="amount">₹{formatCurrencyIndian(item.fuel_price) || "-"}</span></div>
                                                                                            <div className="stage-row"><span className="stage-label">KM per Litre</span><span className="amount">{item.km_per_ltr || "-"} KM</span></div>
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <div className="stage-row"><span className="stage-label">Fixed KM</span><span className="amount">{item.fixed_km || "-"} KM</span></div>
                                                                                            <div className="stage-row"><span className="stage-label">Fixed Amount</span><span className="amount">₹{item.fixed_bill_amt || "-"}</span></div>
                                                                                            <div className="stage-row"><span className="stage-label">Extra Amount</span><span className="amount">₹{formatCurrencyIndian(item.extra_amt_above_fix_km) || "-"}</span></div>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                                                                <div className="stage-header">
                                                                                    <Landmark size={14} />
                                                                                    <span>Bank Details</span>
                                                                                </div>
                                                                                <div className="stage-content">
                                                                                    <div className="stage-row"><span className="stage-label">Bank Name</span><span className="amount">{item.bank_name || "-"}</span></div>
                                                                                    <div className="stage-row"><span className="stage-label">Account No.</span><span className="amount">{item.acc_number || "-"}</span></div>
                                                                                    <div className="stage-row"><span className="stage-label">IFSC Code</span><span className="amount">{item.ifsc_code || "-"}</span></div>
                                                                                    <div className="stage-row"><span className="stage-label">PAN No.</span><span className="amount">{item.pan_card || "-"}</span></div>
                                                                                    <div className="stage-row"><span className="stage-label">Holder Name</span><span className="amount">{item.acc_holder_name || "-"}</span></div>
                                                                                    <div className="stage-row"><span className="stage-label">Phone No.</span><span className="amount">{item.mobile_number || "-"}</span></div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="stage-card approved" style={{ flex: 1, minWidth: '240px' }}>
                                                                                <div className="stage-header">
                                                                                    <Wallet size={14} />
                                                                                    <span>Amount Details</span>
                                                                                </div>
                                                                                <div className="stage-content">
                                                                                    <div className="stage-row"><span className="stage-label">Distance Covered</span><span className="amount">{item.total_km || "-"} KM</span></div>
                                                                                    {item.billing_type === "As per fuel" ? (
                                                                                        <div className="stage-row"><span className="stage-label">Fuel Consumed</span><span className="amount">{(Number(item.total_km) / Number(item.km_per_ltr)).toFixed(2) || "-"} L</span></div>
                                                                                    ) : (
                                                                                        <>
                                                                                            {item.total_km > item.fixed_km && (
                                                                                                <>
                                                                                                    <div className="stage-row"><span className="stage-label">Fixed KM</span><span className="amount">{item.fixed_km || "0"} KM</span></div>
                                                                                                    <div className="stage-row"><span className="stage-label">Extra KM</span><span className="amount">{item.extra_km || "0"} KM</span></div>
                                                                                                    <div className="stage-row"><span className="stage-label">Total KM</span><span className="amount">{Number(item.fixed_km) + Number(item.extra_km)} KM</span></div>
                                                                                                </>
                                                                                            )}
                                                                                            <div className="stage-row"><span className="stage-label">Fixed Amount</span><span className="amount">₹{formatCurrencyIndian(item.fixed_bill_amt) || "-"}</span></div>
                                                                                            <div className="stage-row"><span className="stage-label">Extra Amount</span><span className="amount">₹{formatCurrencyIndian(item.extra_charges) || "-"}</span></div>
                                                                                        </>
                                                                                    )}
                                                                                    <div className="stage-row"><span className="stage-label">Total Amount</span><span className="amount" style={{ fontWeight: 700 }}>₹{formatCurrencyIndian(totalAmount.toFixed(2))}</span></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : showEmptyLoader ? (
                                <div className="empty-state-attractive">
                                    <div className="empty-state-icon-wrap">
                                        <Truck size={32} />
                                    </div>
                                    <h4 className="empty-state-title">No New Bills to Generate</h4>
                                    <p className="empty-state-subtitle">
                                        All vehicles for this project, month, and year already have bills generated.
                                    </p>
                                </div>
                            ) : (
                                <div className="empty-state-attractive">
                                    <div className="empty-state-icon-wrap">
                                        <Filter size={32} />
                                    </div>
                                    <h4 className="empty-state-title">Select Criteria to Continue</h4>
                                    <p className="empty-state-subtitle">
                                        Choose a project, month, and year to preview generated bills.
                                    </p>
                                </div>
                            )}

                            <div className="form-actions" style={{ marginTop: '16px' }}>
                                <div></div>
                                <div className="submit-buttons">
                                    <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading || !showPreviewTable}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Generating...' : 'Generate Bills'}</span>
                                    </button>
                                </div>
                            </div>

                            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                        </Modal.Body>
                    </Modal>
                </>
            )}
        </>
    );
};


const GenerateVehicleBillingDetails = ({ getVehicleBillingDetail, projectid, vehicleList, subCompanyid, projectList }) => {

    const [show, setShow] = useState(false);


    const handleShow = () => {

        setShow(true);
    }

    const handleClose = (e) => {
        // getVehicle();
        // e.preventDefault();
        setShow(false);
    }





    const { projectID } = usePermission();

    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const [formData, setFormData] = useState({
        month: datearray[1],
        year: datearray[0],
        numberproject: siteRole === "SiteManagement" ? "single" : '',
        project: projectID ? projectID : "null",
        date: '',
    });

    console.log("formData")
    console.log(formData)








    const monthOptions = [
        { id: "01", name: "January" },
        { id: "02", name: "February" },
        { id: "03", name: "March" },
        { id: "04", name: "April" },
        { id: "05", name: "May" },
        { id: "06", name: "June" },
        { id: "07", name: "July" },
        { id: "08", name: "August" },
        { id: "09", name: "September" },
        { id: "10", name: "October" },
        { id: "11", name: "November" },
        { id: "12", name: "December" }
    ];
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20; // starting 20 years ago
    const endYear = currentYear + 20; // up to 20 years in the future
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);





    const handleInputChange = (e) => {
        const { name, value } = e.target;



        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // ?  ************** Validation End **************  ! //

    const [generateAllProjectloading, setGenerateAllProjectLoading] = useState(false); //loading logic
    const handleGenerateAllProject = async (e) => {
        e.preventDefault();

        setGenerateAllProjectLoading(true); //loading logic

        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic



        try {
            let ress = await axios.post(
                `${BASE_URL}/siteproject/generate-vehicle-bill-by-all-project/${formData.month}/${formData.year}/`
            );
            console.log(ress, 'res')
            if (ress.status === 200) {


                await getVehicleBillingDetail();
                setShow(false);
            } else {
                // alert(ress);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setGenerateAllProjectLoading(false); // Ensure loading state is stopped even in case of error //loading logic
            toast.dismiss(loadingToastId);
        }



    };


    const [errors, setErrors] = useState({});
    // !  ************** Validation start **************  ! //
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "month",
            "year",
        ]
        console.log(formData.month)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }

    const validateForm2 = () => {
        const newErrors = {};
        const requiredFields = [
            "month",
            "year",
        ]
        console.log(formData.month)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }


    const [generateAllVehicleloading, setGenerateAllVehicleLoading] = useState(false); //loading logic
    const handleGenerateAllVechicle = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setGenerateAllVehicleLoading(true); //loading logic

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let ress = await axios.post(
                    `${BASE_URL}/siteproject/generate-vehicle-bill-by-all-vehicle/${formData.month}/${formData.year}/`
                );

                if (ress.status === 200) {
                    await getVehicleBillingDetail();
                    setShow(false);
                } else if (ress.status === 400) {
                    toast.error("Billing for this project and month already exists.")
                    setShow(false);
                } else {

                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setGenerateAllVehicleLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }


    };

    // const [projectList, setProjectList] = useState([]);
    // const getProjects = async () => {

    //   try {
    //     // const pro = await axios.get(`${BASE_URL}/siteproject/project/`);
    //     const pro = await axios.get(
    //       sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
    //         `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
    //         : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
    //           `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
    //           : `${BASE_URL}/siteproject/project/`
    //     );
    //     const sortedProjects = sortProjects(pro.data, 'site_prcode');
    //     setProjectList(sortedProjects);

    //   } catch (err) {
    //     handleErrorToast(err);
    //   } finally {

    //   }
    // };

    const [generateSingleProjectloading, setGenerateSingleProjectLoading] = useState(false);

    const handleGenerateSingleProject = async (e) => {
        e.preventDefault();

        setGenerateSingleProjectLoading(true); //loading logic

        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic



        try {
            const ress = await axios.post(
                `${BASE_URL}/siteproject/generate-vehicle-bill-by-project/${formData.project}/${formData.month < 9 ? `0${formData.month}` : `${formData.month}`}/${formData.year}/`,


            );


            if (ress.status === 200) {
                await getVehicleBillingDetail();
                setShow(false);

            } else if (ress.status === 400) {
                toast.error("Billing for this project and month already exists.")
                setShow(false);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setGenerateSingleProjectLoading(false); // Ensure loading state is stopped even in case of error //loading logic
            toast.dismiss(loadingToastId);
        }



    };

    return (
        <>
            <button title="Generate Vehicle Billing Details" className="clearbutton" onClick={handleShow}>
                <span className="transition"></span>
                <span className="gradient"></span>
                <span className="label"> <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clip-path="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg> {" "} Generate Bills</span>


            </button>

            <Modal show={show}
                onHide={(e) => handleClose(e)}
                dialogClassName="request-leave  width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Generate Bills</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>

                                {siteRole === "SiteManagement" ? ("") : (<div title="project" className="flex-column form-group-selectt">
                                    <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                                        What to Generate Bill for ?
                                    </label>
                                    <br />
                                    <select
                                        id="numberproject"
                                        name="numberproject"
                                        value={formData.numberproject}
                                        onChange={handleInputChange}
                                        className="form-input form-group-selection"
                                    >
                                        <option value="">Generate Bill for </option>
                                        {/* <option value="single">Single</option> */}
                                        <option value="All">All</option>
                                    </select>

                                    <div>
                                        {errors.numberproject && (
                                            <span className="error-message font-size-text ">{errors.numberproject}</span>
                                        )}
                                    </div>
                                </div>)}
                                {

                                    formData.numberproject === "single" && siteRole !== "SiteManagement" &&
                                    <div title="Project" className="flex-column form-group-selectt">
                                        <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                                            Project<span className="required">*</span>
                                        </label>
                                        <br />
                                        <select
                                            type="text"
                                            id="project"
                                            name="project"
                                            placeholder="project"
                                            value={formData.project}
                                            onChange={handleInputChange}
                                            className='form-input form-group-selection'
                                        >

                                            <option value="null">Select a Project</option>
                                            {projectList?.sort((a, b) => a.project_short_name.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                <option key={index} value={i.id}>{i.project_short_name}</option>
                                            ))}
                                        </select>

                                        <div className="form-group-selection-arrow">

                                        </div>

                                    </div>
                                }




                                <div title="Month" className="flex-column form-group-selectt">
                                    <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                        Month<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        type="text"
                                        id="month"
                                        name="month"
                                        placeholder="month"
                                        value={formData.month}
                                        onChange={handleInputChange}
                                        className={`form-input-date form-group-selection `}
                                    >

                                        <option value="">Select a month</option>
                                        {monthOptions.map((month) => (
                                            <option key={month.id} value={month.id}>{month.name}</option>
                                        ))}
                                    </select>


                                </div>


                                <div title="Year" className="flex-column form-group-selectt">
                                    <label htmlFor="year" className="form-labels  font-weight500    font-size-subheading">
                                        Year<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        type="text"
                                        id="year"
                                        name="year"
                                        placeholder="year"
                                        value={formData.year}
                                        onChange={handleInputChange}
                                        className={`form-input-date form-group-selection`}
                                    >

                                        <option value="">Select a Year</option>
                                        {years.map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>


                                </div>




                                <div>
                                    {formData.numberproject === "single" ? (<>
                                        <button className="model-button  font-weight500  model-button-bill   model-button-leave font-size-heading" title="generateSingleProjectloading" onClick={handleGenerateSingleProject} disabled={generateAllProjectloading} >
                                            {generateSingleProjectloading ? 'Generating...' : 'Generate For Single Project'}
                                        </button>
                                    </>) : (<>
                                        <button className="model-button  font-weight500  model-button-bill   model-button-leave font-size-heading" title="generateAllProjectloading" onClick={handleGenerateAllProject} disabled={generateAllProjectloading} >
                                            {generateAllProjectloading ? 'Generating...' : 'Generate For All Project'}
                                        </button>
                                    </>)}

                                </div>

                                <div>
                                    {/* {siteRole === "SiteManagement" ? ("") : (
                    <button className="model-button  font-weight500 model-button-bill    model-button-leave font-size-heading" title='generateAllVehicleloading' onClick={handleGenerateAllVechicle} disabled={generateAllVehicleloading} >
                      {generateAllVehicleloading ? 'Generating...' : 'Generate For All Vehicle'}
                    </button>
                  )} */}
                                </div>
                                {/* 
                <div>
                <GenerateforVehicle vehicleList={vehicleList} />
                
                </div> */}



                                <div className="button-models">
                                    <button className="model-button-cancel model-button font-weight500" onClick={(e) => handleClose(e)}>
                                        Cancel
                                    </button>

                                </div>
                            </form>
                        </div></div>
                </Modal.Body>
            </Modal>
        </>




    )
}


// !  ********* Vehicle Billing Details Components End******** ?//






const VehicleModelTable = ({ p_id, site_prcode, usedin, subCompanyid }) => {
    const [vehicleModel, setVehiclemodel] = useState([]);
    const [buffer, setBuffering] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedSearch, setSearch] = useState("");
    const { projectID } = usePermission();
    const [selectedProject, setSelectedProject] = useState(projectID ? projectID : p_id ? p_id : "null");
    const [subcompanyList, setSubCompanyList] = useState([]);
    const [subcompany, setSubCompany] = useState(subCompanyid ? subCompanyid : "null");
    const [showFilters, setShowFilters] = useState(true);
    const [expandedRow, setExpandedRow] = useState(null);
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const navigate = useNavigate();
    const role = sessionStorage.getItem('sitemanagement_role');
    const project_idd = sessionStorage.getItem('sitemanagement_project');

    const ViewVechile = (vehicle) => {
        navigate(`/${urlParts[3]}/Vechiclelogbook/${vehicle}/`);
    };

    const getSubCompany = async () => {
        try {
            const subcompany = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(subcompany.data);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        getSubCompany();
    }, []);

    const getVehicle = async () => {
        setBuffering(true);
        try {
            const ress = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${selectedProject}/${subcompany}/`);
            setVehiclemodel(ress.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getVehicle();
    }, [selectedProject, subcompany]);

    const applyFilters = () => {
        let filteredData = vehicleModel;
        if (selectedSearch !== "") {
            const lowercaseSelectedName = selectedSearch.toLowerCase();
            filteredData = filteredData.filter(project => {
                const name = project.name.toString().toLowerCase().includes(lowercaseSelectedName);
                const num = project.vehicle_num.toString().toLowerCase().includes(lowercaseSelectedName);
                return name || num;
            });
        }
        if (selectedProject !== "null") {
            filteredData = filteredData.filter(project => project.project === selectedProject);
        }
        setFilteredData(filteredData);
    };

    useEffect(() => {
        applyFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSearch, vehicleModel, selectedProject]);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const showFilterBar = sessionStorage.getItem('sitemanagement_role') !== "SiteManagement" && !p_id;
    const hasActiveFilters = (subcompany !== "null" && subcompany !== subCompanyid) || selectedProject !== "null" || selectedSearch !== "";

    const clearAllFilters = () => {
        setSubCompany(subCompanyid || "null");
        setSelectedProject("null");
        setSearch("");
    };

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        {role === "Admin" &&
                            <>
                                {subCompanyid !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" && (
                                    <div className={`filter-chip ${subcompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                        <div className="filter-chip-content">

                                            <SubCompanyModern toggleCompany={subcompany} setToggleCompany={setSubCompany} cssType="modern" />
                                        </div>
                                    </div>
                                )}

                                <div className={`filter-chip ${selectedProject !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                                    <div className="filter-chip-content">
                                        <Projects usedFor="filter" value="id" subcompany={subcompany} toggleProject={selectedProject} setToggleProject={setSelectedProject} />
                                    </div>
                                </div>
                            </>
                        }


                        <div className="filter-chip" style={{ minWidth: '260px' }}>
                            <div ><Search size={15} /></div>
                            <div className="filter-chip-content" style={{ width: '100%' }}>
                                <input
                                    className="modern-select"
                                    style={{ width: '100%' }}
                                    placeholder="Vehicle Number / Vehicle Name"
                                    value={selectedSearch}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && role === "Admin" && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats + toggle + actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Truck size={14} />
                        <span>Showing</span>
                        <strong>{filteredData.length} vehicles</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>

                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>


                    {role !== "ViewAccess" && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                            <AddVehicleModel getVehicle={getVehicle} projectId={p_id ? p_id : project_idd} subCompanyid={subcompany} site_prcode={site_prcode} />
                            {role === "Admin" && <VehicleModelBulk getVehicle={getVehicle} site_prcode={site_prcode} />}
                        </div>
                    )}
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading" style={{ zIndex: 1000 }}>
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                {!p_id && <th className="col-period" style={{ width: '15%' }}>Project</th>}
                                <th className="col-period text-center">Vehicle Details</th>
                                <th className="col-submitted text-center" style={{ width: '12%' }}>BOQ Rate</th>
                                <th className="col-approved text-center" style={{ width: '12%' }}>Document</th>
                                <th className="col-status text-center" style={{ width: '10%' }}>Log</th>
                                {role !== "SiteManagement" && role !== "ViewAccess" && <th className="col-action text-center" style={{ width: '12%' }}>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((vehicle, index) => {
                                const isExpanded = expandedRow === index;
                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            {!p_id && <td className="col-period">{vehicle?.project_short_name}</td>}
                                            <td className="col-period">
                                                <div className="flex-row" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                    <button className="period-trigger" style={{ width: "40%", textAlign: 'left', justifyContent: 'center' }} onClick={() => toggleRow(index)}>
                                                        <Truck size={12} />
                                                        <span>{vehicle?.name} • {vehicle?.vehicle_num}</span>
                                                        {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                    </button>
                                                </div>
                                            </td>
                                            <td className="col-submitted text-center">
                                                <span className="badge-value">₹{formatCurrencyIndian(vehicle?.boqtransportation_rate || 0)}</span>
                                            </td>
                                            <td className="col-approved text-center">
                                                <DocumentModel siteVehicle={vehicleModel} vehicle={vehicle.id} getDocument={getVehicle} title={"Vehicle Document"} />
                                            </td>
                                            <td className="col-status text-center">
                                                <button className="action-icon" style={{ backgroundColor: "#00000075" }} onClick={() => ViewVechile(vehicle.id)} title="View Vehicle Log">
                                                    <LucideReceiptText size={18} color='white' />
                                                </button>
                                            </td>
                                            {role !== "SiteManagement" && role !== "ViewAccess" && (
                                                <td className="col-action">
                                                    <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                        {!(role === "Checker" && isMoreThan24Hours(vehicle.created_at)) && (
                                                            <>
                                                                {vehicle.lock === false && (
                                                                    <UpdateVehicle i={vehicle} getVehicle={getVehicle} usedIn={usedin} subCompanyid={subcompany} />
                                                                )}
                                                                {role === "Admin" && (
                                                                    <Lock apiName="vehicle" id={vehicle.id} i={vehicle} usedFor="Vehicle" getData={getVehicle} />
                                                                )}
                                                                {sessionStorage.getItem('sitemanagement_role') !== "Account" && vehicle.lock === false && (
                                                                    <DeleteVehicle i={vehicle} getVehicle={getVehicle} />
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </td>
                                            )}
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={p_id ? (role !== "SiteManagement" && role !== "ViewAccess" ? 6 : 5) : (role !== "SiteManagement" && role !== "ViewAccess" ? 7 : 6)}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Full Vehicle Details</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Truck size={14} />
                                                                    <span>Vehicle Info</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row"><span className="stage-label">Start Date</span><span className="amount">{formattedDateLong(vehicle?.vehicle_start_date) || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Agreement Duration</span><span className="amount">{vehicle?.agreement_duration ?? "0"} months</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Agreement End</span><span className="amount">{formattedDateLong(vehicle?.agreement_end_date) || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Vehicle End Date</span><span className="amount">{formattedDateLong(vehicle?.end_date) || "-"}</span></div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Landmark size={14} />
                                                                    <span>Bank Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row"><span className="stage-label">Bank Name</span><span className="amount">{vehicle?.bank_name || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Holder Name</span><span className="amount">{vehicle?.account_holder_name || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Account No.</span><span className="amount">{vehicle?.account_num || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">IFSC Code</span><span className="amount">{vehicle?.ifsc_code || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">PAN No.</span><span className="amount">{vehicle?.pan_card || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">GST No.</span><span className="amount">{vehicle?.gst_num || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Mobile No.</span><span className="amount">{vehicle?.mobile || "-"}</span></div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card approved" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Wallet size={14} />
                                                                    <span>Billing Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row"><span className="stage-label">Billing Type</span><span className="amount">{vehicle?.select_billing_type || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Fixed KM</span><span className="amount">{vehicle?.fixed_km || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Fixed Bill Amount</span><span className="amount">{vehicle?.fixed_bill_amt ? `₹${formatCurrencyIndian(vehicle.fixed_bill_amt)}` : "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Extra Amount</span><span className="amount">{vehicle?.extra_amt_above_fix_km ? `₹${formatCurrencyIndian(vehicle.extra_amt_above_fix_km)}` : "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Fuel Price</span><span className="amount">{vehicle?.fuel_price ? `₹${formatCurrencyIndian(vehicle.fuel_price)}` : "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">KM Per Litre</span><span className="amount">{vehicle?.km_per_lit || "-"}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {vehicle?.address && (
                                                            <div style={{ marginTop: '12px', padding: '10px 14px', background: '#f8fafc', borderRadius: '10px', fontSize: '12px', color: '#475569' }}>
                                                                <strong style={{ color: '#1e293b' }}>Address: </strong>{vehicle.address}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {filteredData.length === 0 && (
                                <tr>
                                    <td colSpan={p_id ? 6 : 7}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Truck size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Vehicles Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters or search to find what you're looking for.
                                            </p>

                                            {hasActiveFilters && role === "Admin" && (
                                                <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};




// const VehicleLogDetails = ({ subCompanyid }) => {
//     const { projectID } = usePermission();
//     const siteRole = sessionStorage.getItem("sitemanagement_role");
//     const [VehicleLogDetails, setVehicleLogDetails] = useState([]);
//     const [siteLogDetails, setSiteLogDetails] = useState([]);
//     const [buffer, setBuffering] = useState(true); //buffering logic
//     const [vehicle, setVehicle] = useState("null");
//     const [subcompanyList, setSubCompanyList] = useState([]);
//     const [subcompany, setSubCompany] = useState(subCompanyid || "null");
//     const [showFilters, setShowFilters] = useState(true);

//     const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
//     const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
//     const today = new Date();
//     const yesterday = new Date();
//     today.setDate(today.getDate() - 1);

//     const [project, setProject] = useState(projectID ? projectID : "null");

//     const [fromdate, setFromDate] = useState(siteRole === "SiteManagement" ? startDate.toISOString().split('T')[0] : yesterday.toISOString().split('T')[0]);
//     const [todate, setToDate] = useState(siteRole === "SiteManagement" ? endDate.toISOString().split('T')[0] : today.toISOString().split('T')[0]);
//     const [frommdate, setFrommDate] = useState(yesterday.toISOString().split('T')[0]);
//     const [toodate, setTooDate] = useState(today.toISOString().split('T')[0]);
//     const [fromTime, setFromTime] = useState("null");
//     const [toTime, setToTime] = useState("null");
//     const [projectList, setProjectList] = useState([]);
//     const [vehicleList, setVehicleList] = useState([]);

//     const getStartEndOfMonth = () => {
//         return { start: startDate, end: endDate };
//     };

//     const getSubCompany = async () => {
//         try {
//             const subcompany = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//             setSubCompanyList(subcompany.data)
//         } catch (error) {
//             console.error(error);
//         }
//     };
//     useEffect(() => {
//         getSubCompany();
//     }, []);

//     const getPreviousAndCurrentDate = () => {
//         const today = new Date();
//         const yesterday = new Date();
//         yesterday.setDate(today.getDate() - 1);
//         return { from: yesterday, to: today };
//     };

//     useEffect(() => {
//         if (siteRole === "Admin") {
//             const { from, to } = getPreviousAndCurrentDate();
//             setFromDate(from.toISOString().split('T')[0]);
//             setToDate(to.toISOString().split('T')[0]);
//         } else {
//             const { start, end } = getStartEndOfMonth();
//             setFromDate(start.toISOString().split('T')[0]);
//             setToDate(end.toISOString().split('T')[0]);
//         }
//     }, [siteRole]);

//     const getVehicle = async () => {
//         try {
//             const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${project}/${subcompany}/`);
//             setVehicleList(veh.data);
//         } catch (err) {
//             if (err.response) {
//                 const errorData = err.response.data;
//                 if (typeof errorData.error === 'string') {
//                     toast.error(`Error: ${errorData.error}`);
//                 } else if (typeof errorData === 'object' && errorData !== null) {
//                     Object.entries(errorData).forEach(([field, messages]) => {
//                         messages.forEach(message => toast.error(`"${field}": ${message}`));
//                     });
//                 } else {
//                     toast.error('Error:- Failed to Process!');
//                 }
//             } else {
//                 toast.error('Error processing your request.');
//             }
//         } finally {
//         }
//     }

//     const getVehicleLogDetail = async () => {
//         setBuffering(true);
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/vehiclelogdetailbyallfilter/${vehicle}/${project}/${fromdate}/${todate}/${fromTime}/${toTime}/${subcompany}/`);
//             const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
//             setVehicleLogDetails(sortedData);
//         }
//         catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setTimeout(() => [
//                 setBuffering(false)
//             ], 2000)
//         }
//     }
//     useEffect(() => {
//         getVehicle();
//         getVehicleLogDetail();
//     }, [vehicle, project, fromdate, todate, fromTime, toTime, subcompany]);

//     const showFilterBar = siteRole !== "SiteManagement";
//     const hasActiveFilters =
//         (subcompany !== "null" && subcompany !== subCompanyid) ||
//         project !== "null" ||
//         vehicle !== "null" ||
//         fromTime !== "null" ||
//         toTime !== "null";

//     const clearAllFilters = () => {
//         setSubCompany(subCompanyid || "null");
//         setProject(projectID ? projectID : "null");
//         setVehicle("null");
//         setFromTime("null");
//         setToTime("null");
//         if (siteRole === "Admin") {
//             const { from, to } = getPreviousAndCurrentDate();
//             setFromDate(from.toISOString().split('T')[0]);
//             setToDate(to.toISOString().split('T')[0]);
//         } else {
//             const { start, end } = getStartEndOfMonth();
//             setFromDate(start.toISOString().split('T')[0]);
//             setToDate(end.toISOString().split('T')[0]);
//         }
//     };

//     return (
//         <div className="progress-modern-container">
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//             {showFilterBar && showFilters && (
//                 <div className="filter-bar-attractive">
//                     <div className="filter-group-attractive">
//                         {subCompanyid !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" && (
//                             <div className={`filter-chip ${subcompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
//                                 <div className="filter-chip-content">
//                                     <SubCompany toggleCompany={subcompany} setToggleCompany={setSubCompany} />
//                                 </div>
//                             </div>
//                         )}

//                         <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
//                             <div className="filter-chip-content">
//                                 <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={subcompany} />
//                             </div>
//                         </div>

//                         <div className={`filter-chip ${vehicle !== "null" ? "active" : ""}`} style={{ minWidth: '220px' }}>
//                             <div><Truck size={15} /></div>
//                             <div className="filter-chip-content" style={{ width: '100%' }}>
//                                 <select
//                                     id="vehicle"
//                                     name="vehicle"
//                                     value={vehicle}
//                                     onChange={(e) => setVehicle(e.target.value)}
//                                     style={{ cursor: 'pointer', width: '100%' }}
//                                     className="modern-select"
//                                 >
//                                     <option value="null">Select Vehicle</option>
//                                     {vehicleList
//                                         .sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }))
//                                         .map((i, index) => (
//                                             <option key={index} value={i.id}>
//                                                 {i.name}-{i.vehicle_num}
//                                             </option>
//                                         ))}
//                                 </select>
//                             </div>
//                         </div>

//                         <div className="filter-chip">
//                             <div className="filter-chip-content">
//                                 <input
//                                     className="modern-select"
//                                     title="From Date"
//                                     type="date"
//                                     value={fromdate}
//                                     onChange={(e) => setFromDate(e.target.value)}
//                                 />
//                             </div>
//                         </div>

//                         <div className="filter-chip">
//                             <div className="filter-chip-content">
//                                 <input
//                                     className="modern-select"
//                                     title="To Date"
//                                     type="date"
//                                     value={todate}
//                                     onChange={(e) => setToDate(e.target.value)}
//                                 />
//                             </div>
//                         </div>

//                         <div className={`filter-chip ${fromTime !== "null" ? "active" : ""}`}>
//                             <div className="filter-chip-content">
//                                 <input
//                                     className="modern-select"
//                                     title="From Time"
//                                     type="time"
//                                     value={fromTime === "null" ? "" : fromTime}
//                                     onChange={(e) => setFromTime(e.target.value || "null")}
//                                 />
//                             </div>
//                         </div>

//                         <div className={`filter-chip ${toTime !== "null" ? "active" : ""}`}>
//                             <div className="filter-chip-content">
//                                 <input
//                                     className="modern-select"
//                                     title="To Time"
//                                     type="time"
//                                     value={toTime === "null" ? "" : toTime}
//                                     onChange={(e) => setToTime(e.target.value || "null")}
//                                 />
//                             </div>
//                         </div>

//                         {hasActiveFilters && (
//                             <button className="clear-filters-btn" onClick={clearAllFilters}>
//                                 <X size={13} />
//                                 Clear
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             )}

//             {/* Stats + toggle + actions */}
//             <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <div className="stats-minimal-row">
//                     <div className="stat-minimal-item">
//                         <Truck size={14} />
//                         <span>Showing</span>
//                         <strong>{VehicleLogDetails.length} logs</strong>
//                     </div>
//                 </div>

//                 <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
//                     {showFilterBar && (
//                         <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
//                             <Filter size={14} />
//                             <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
//                             {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
//                         </button>
//                     )}

//                     {siteRole !== "ViewAccess" && (
//                         <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
//                             <AddVehicleLogDetails subCompanyid={subcompany} getVehicleLogDetail={getVehicleLogDetail} projectid={projectID} projectList={projectList} />
//                         </div>
//                     )}
//                 </div>
//             </div>

//             <div className="table-css-white-background overflow-hidden flex-column ">
//                 <div className="table-box scroll-container-table">
//                     <table className="table-css width-100vw">
//                         <thead className="table-heading">
//                             <tr className="custom-table-head-tr ">
//                                 <th className='table-heading-text text-left-sr'>S.No.</th>
//                                 <th className="table-heading-text text-center">Project Name</th>
//                                 <th className='table-heading-text text-center'>Vehicle Name</th>
//                                 <th className='table-heading-text text-center'>Vehicle Number</th>
//                                 <th className='table-heading-text text-center'>Date</th>
//                                 <th className='table-heading-text text-center'>From Time</th>
//                                 <th className='table-heading-text text-center'>To Time</th>
//                                 <th className='table-heading-text text-center'>Commencement of Trip</th>
//                                 <th className='table-heading-text text-center'>Conclusion of Trip</th>
//                                 <th className='table-heading-text text-start'>Person Using Conveyance</th>
//                                 <th className='table-heading-text text-start'>Purpose And Place</th>
//                                 {(siteRole !== "SiteManagement" && siteRole !== "ViewAccess") &&
//                                     <th className='table-heading-text text-center' style={{ justifyContent: 'right', paddingRight: '40px' }}>Action</th>
//                                 }
//                             </tr>
//                         </thead>
//                         {buffer ? (
//                             <div className='spinner-bgdatil'></div>
//                         ) : (
//                             <tbody>
//                                 {VehicleLogDetails.length > 0 ? (<>{VehicleLogDetails.map((vehicle, monthIndex) => (
//                                     <React.Fragment key={monthIndex}>
//                                         <tr className='custom-table-head-td'>
//                                             <td className="table-body text-left-sr">{monthIndex + 1}</td>
//                                             <td className="table-body text-center">{vehicle.project_short_name}</td>
//                                             <td className="table-body text-center">{vehicle.vehicle_name}</td>
//                                             <td className="table-body text-center">{vehicle.vehicle_number}</td>
//                                             <td className="table-body text-center">{formattedDateLong(vehicle.date)}</td>
//                                             <td className="table-body text-center">{vehicle.from_time}</td>
//                                             <td className="table-body text-center">
//                                                 {vehicle.to_time}
//                                             </td>
//                                             <td className="table-body text-center">{vehicle.commencement_of_trip} Km</td>
//                                             <td className="table-body text-center">{vehicle.conclusion_of_trip} Km</td>
//                                             <td className="table-body text-center">
//                                                 {Array.isArray(vehicle.employee) && vehicle.employee.length > 0
//                                                     ?
//                                                     <>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px">S.no.</td>
//                                                             <td style={{ padding: "0px 4px" }}>|</td>
//                                                             <td className="padding-bottom-5px">Emp.Code</td>
//                                                             <td style={{ padding: "0px 4px" }}>|</td>
//                                                             <td className="text-start">
//                                                                 Emp. Name
//                                                             </td>
//                                                         </tr>
//                                                         {vehicle.employee_details.map((i, index) => (
//                                                             <>
//                                                                 <tr key={index}>
//                                                                     <td className="padding-bottom-5px"> {index + 1}.</td>
//                                                                     <td style={{ padding: "0px 4px" }}>|</td>
//                                                                     <td className="padding-bottom-5px"> {i.emp_code}</td>
//                                                                     <td style={{ padding: "0px 4px" }}>|</td>
//                                                                     <td className="">
//                                                                         {i.name}
//                                                                     </td>
//                                                                 </tr>
//                                                             </>
//                                                         ))}
//                                                     </>
//                                                     : vehicle.personusingconveyance
//                                                 }
//                                             </td>
//                                             <td className="table-body text-start"><div style={{ width: "100px", whiteSpace: "wrap" }}>{vehicle.purpose_and_place}</div></td>
//                                             {
//                                                 vehicle.created_at &&
//                                                     siteRole !== "SiteManagement" && siteRole !== "ViewAccess" &&
//                                                     !(siteRole === "Checker" && isMoreThan24Hours(vehicle.created_at)) ? (
//                                                     <td className="table-body text-right" style={{ justifyContent: 'center' }}>
//                                                         <div className="flex-row">
//                                                             <UpdateVehicleLogDetail i={vehicle} getVehicleLogDetail={getVehicleLogDetail} />
//                                                             {siteRole !== "Account" && (
//                                                                 <DeleteVehicleLogDetail i={vehicle} getVehicleLogDetail={getVehicleLogDetail} />
//                                                             )}
//                                                         </div>
//                                                     </td>
//                                                 ) : <td className="table-body text-center" style={{ justifyContent: 'center' }}>-</td>
//                                             }
//                                         </tr>
//                                     </React.Fragment>
//                                 ))}</>) : (<tr className='custom-table-head-td'>
//                                     <td colSpan={11} style={{ textAlign: 'center' }}>
//                                     </td>
//                                 </tr>)}
//                             </tbody>
//                         )}
//                     </table>
//                 </div>
//             </div>
//         </div>
//     )
// }


const VehicleLogDetails = ({ subCompanyid }) => {
    const { projectID } = usePermission();
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const [VehicleLogDetails, setVehicleLogDetails] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [vehicle, setVehicle] = useState("null");
    const [subcompanyList, setSubCompanyList] = useState([]);
    const [subcompany, setSubCompany] = useState(subCompanyid || "null");
    const [showFilters, setShowFilters] = useState(true);
    const [expandedRow, setExpandedRow] = useState(null);

    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    const today = new Date();
    const yesterday = new Date();
    today.setDate(today.getDate() - 1);

    const [project, setProject] = useState(projectID ? projectID : "null");

    const [fromdate, setFromDate] = useState(siteRole === "SiteManagement" ? startDate.toISOString().split('T')[0] : yesterday.toISOString().split('T')[0]);
    const [todate, setToDate] = useState(siteRole === "SiteManagement" ? endDate.toISOString().split('T')[0] : today.toISOString().split('T')[0]);
    const [fromTime, setFromTime] = useState("null");
    const [toTime, setToTime] = useState("null");
    const [projectList, setProjectList] = useState([]);
    const [vehicleList, setVehicleList] = useState([]);

    const getStartEndOfMonth = () => ({ start: startDate, end: endDate });

    const getSubCompany = async () => {
        try {
            const subcompany = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(subcompany.data);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        getSubCompany();
    }, []);

    const getPreviousAndCurrentDate = () => {
        const today = new Date();
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        return { from: yesterday, to: today };
    };

    useEffect(() => {
        if (siteRole === "Admin") {
            const { from, to } = getPreviousAndCurrentDate();
            setFromDate(from.toISOString().split('T')[0]);
            setToDate(to.toISOString().split('T')[0]);
        } else {
            const { start, end } = getStartEndOfMonth();
            setFromDate(start.toISOString().split('T')[0]);
            setToDate(end.toISOString().split('T')[0]);
        }
    }, [siteRole]);

    const getVehicle = async () => {
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${project}/${subcompany}/`);
            setVehicleList(veh.data);
        } catch (err) {
            if (err.response) {
                const errorData = err.response.data;
                if (typeof errorData.error === 'string') {
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        }
    };

    const getVehicleLogDetail = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/vehiclelogdetailbyallfilter/${vehicle}/${project}/${fromdate}/${todate}/${fromTime}/${toTime}/${subcompany}/`);
            const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
            setVehicleLogDetails(sortedData);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setTimeout(() => setBuffering(false), 2000);
        }
    };

    useEffect(() => {
        getVehicle();
        getVehicleLogDetail();
    }, [vehicle, project, fromdate, todate, fromTime, toTime, subcompany]);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const showFilterBar = siteRole !== "SiteManagement";
    const hasActiveFilters =
        (subcompany !== "null" && subcompany !== subCompanyid) ||
        project !== "null" ||
        vehicle !== "null" ||
        fromTime !== "null" ||
        toTime !== "null";

    const clearAllFilters = () => {
        setSubCompany(subCompanyid || "null");
        setProject(projectID ? projectID : "null");
        setVehicle("null");
        setFromTime("null");
        setToTime("null");
        if (siteRole === "Admin") {
            const { from, to } = getPreviousAndCurrentDate();
            setFromDate(from.toISOString().split('T')[0]);
            setToDate(to.toISOString().split('T')[0]);
        } else {
            const { start, end } = getStartEndOfMonth();
            setFromDate(start.toISOString().split('T')[0]);
            setToDate(end.toISOString().split('T')[0]);
        }
    };

    return (
        <div className="progress-modern-container">
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        {siteRole === "Admin" &&
                            <>
                                {subCompanyid !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" && (
                                    <div className={`filter-chip ${subcompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                        <div className="filter-chip-content">
                                            <SubCompany toggleCompany={subcompany} setToggleCompany={setSubCompany} />
                                        </div>
                                    </div>
                                )}

                                <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                                    <div className="filter-chip-content">
                                        <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={subcompany} />
                                    </div>
                                </div>
                            </>
                        }

                        <div className={`filter-chip ${vehicle !== "null" ? "active" : ""}`} style={{ minWidth: '220px', padding: "0px" }}>
                            <div className="filter-chip-content" style={{ width: '100%', padding: "0px" }}>
                                <VehicleModern cssType="modern" toggleProject={project} toggleSubCompany={subcompany} toggleVehicle={vehicle} setToggleVehicle={setVehicle} />

                            </div>
                        </div>

                        <div className="filter-chip">
                            <div className="filter-chip-content">
                                <input className="modern-select" title="From Date" type="date" value={fromdate} onChange={(e) => setFromDate(e.target.value)} />
                            </div>
                        </div>

                        <div className="filter-chip">
                            <div className="filter-chip-content">
                                <input className="modern-select" title="To Date" type="date" value={todate} onChange={(e) => setToDate(e.target.value)} />
                            </div>
                        </div>

                        <div className={`filter-chip ${fromTime !== "null" ? "active" : ""}`}>
                            <div className="filter-chip-content">
                                <input className="modern-select" title="From Time" type="time" value={fromTime === "null" ? "" : fromTime} onChange={(e) => setFromTime(e.target.value || "null")} />
                            </div>
                        </div>

                        <div className={`filter-chip ${toTime !== "null" ? "active" : ""}`}>
                            <div className="filter-chip-content">
                                <input className="modern-select" title="To Time" type="time" value={toTime === "null" ? "" : toTime} onChange={(e) => setToTime(e.target.value || "null")} />
                            </div>
                        </div>
                        {siteRole === "Admin" &&
                            <>
                                {hasActiveFilters && (
                                    <button className="clear-filters-btn" onClick={clearAllFilters}>
                                        <X size={13} />
                                        Clear
                                    </button>
                                )}
                            </>
                        }
                    </div>
                </div>
            )}

            {/* Stats + toggle + actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Truck size={14} />
                        <span>Showing</span>
                        <strong>{VehicleLogDetails.length} logs</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>

                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>


                    {siteRole !== "ViewAccess" && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                            <AddVehicleLogDetails subCompanyid={subcompany} getVehicleLogDetail={getVehicleLogDetail} projectid={projectID} projectList={projectList} />
                        </div>
                    )}
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '10%' }}>Project</th>
                                <th className="col-period text-center" style={{ width: '10%' }}>Vehicle / Trip Details</th>
                                <th className="col-submitted text-center" style={{ width: '10%' }}>Time</th>
                                <th className="col-approved text-center" style={{ width: '10%' }}>Distance</th>
                                {(siteRole !== "SiteManagement" && siteRole !== "ViewAccess") && <th className="col-action text-center" style={{ width: '10%' }}>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {VehicleLogDetails.map((vehicle, index) => {
                                const isExpanded = expandedRow === index;
                                const canEdit = vehicle.created_at && siteRole !== "SiteManagement" && siteRole !== "ViewAccess" && !(siteRole === "Checker" && isMoreThan24Hours(vehicle.created_at));

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">{vehicle.project_short_name}</td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <Truck size={12} />
                                                    <span>{vehicle.vehicle_name} • {vehicle.vehicle_number}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                    {formattedDateLong(vehicle.date)}
                                                </div>
                                            </td>
                                            <td className="col-submitted">
                                                <div className="progress-badge">
                                                    <span className="badge-label">From</span>
                                                    <span className="badge-value">{vehicle.from_time || "-"}</span>
                                                </div>
                                                <div className="progress-badge">
                                                    <span className="badge-label">To</span>
                                                    <span className="badge-value">{vehicle.to_time || "-"}</span>
                                                </div>
                                            </td>
                                            <td className="col-approved">
                                                <div className="progress-badge approved">
                                                    <span className="badge-label">Start</span>
                                                    <span className="badge-value">{vehicle.commencement_of_trip} Km</span>
                                                </div>
                                                <div className="progress-badge approved">
                                                    <span className="badge-label">End</span>
                                                    <span className="badge-value">{vehicle.conclusion_of_trip} Km</span>
                                                </div>
                                            </td>
                                            {(siteRole !== "SiteManagement" && siteRole !== "ViewAccess") && (
                                                <td className="col-action text-center">
                                                    {canEdit ? (
                                                        <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                            <UpdateVehicleLogDetail i={vehicle} getVehicleLogDetail={getVehicleLogDetail} />
                                                            {siteRole !== "Account" && (
                                                                <DeleteVehicleLogDetail i={vehicle} getVehicleLogDetail={getVehicleLogDetail} />
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <span style={{ color: '#cbd5e1', fontSize: '12px' }}>-</span>
                                                    )}
                                                </td>
                                            )}
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={(siteRole !== "SiteManagement" && siteRole !== "ViewAccess") ? 6 : 5}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Trip Details</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '260px' }}>
                                                                <div className="stage-header">
                                                                    <Users size={14} />
                                                                    <span>Person(s) Using Conveyance</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    {Array.isArray(vehicle.employee) && vehicle.employee.length > 0 ? (
                                                                        vehicle.employee_details.map((emp, empIndex) => (
                                                                            <div className="stage-row" key={empIndex}>
                                                                                <span className="stage-label">{empIndex + 1}. {emp.emp_code}</span>
                                                                                <span className="amount">{emp.name}</span>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <div className="stage-row">
                                                                            <span className="amount">{vehicle.personusingconveyance || "-"}</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '260px' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={14} />
                                                                    <span>Purpose & Place</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="amount">{vehicle.purpose_and_place || "-"}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {VehicleLogDetails.length === 0 && (
                                <tr>
                                    <td colSpan={(siteRole !== "SiteManagement" && siteRole !== "ViewAccess") ? 6 : 5}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Truck size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Vehicle Logs Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters or date range to view logs.
                                            </p>
                                            {hasActiveFilters && siteRole === "Admin" && (
                                                <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

// const VehicleBillingDetails = ({ subCompanyid }) => {
//     const [vehicleBillingDetails, setVehicleBillingDetails] = useState([]);
//     const [buffer, setBuffering] = useState(false); //buffering logic
//     const { projectID } = usePermission();
//     const sitemanagement = sessionStorage.getItem("sitemanagement_role")
//     const [project, setProject] = useState(projectID ? projectID : "null");
//     const [search, setSearch] = useState("")
//     const [projectList, setProjectList] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [vehicle, setVehicle] = useState("null");
//     const [vehicleList, setVehicleList] = useState([]);
//     const [subcompany, setSubCompany] = useState(subCompanyid || "null");
//     const tableRef = useRef(null);

//     const today = new Date();
//     today.setDate(today.getDate() - 1);
//     const year = today.getFullYear();
//     const month = today.getMonth() + 1;
//     const employeeId = sessionStorage.getItem('sitemanagement_emp_id');

//     const [filterMonth, setFilterMonth] = useState(`${month ? `0${month}` : "null"}`);
//     const [filterYear, setFilterYear] = useState(`${year ? year : 'null'}`);
//     const siteRole = sessionStorage.getItem("sitemanagement_role");
//     const getProjects = async () => {
//         setBuffering(true); //buffering logic // Start Buffering
//         try {
//             const pro = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${role === "AuthorityEngineer" ? employeeId : "null"}/null/${role === "DataEntryOperator" ? employeeId : "null"}/null/`);

//             const sortedProjects = sortProjects(pro.data, 'site_prcode');
//             setProjectList(sortedProjects);

//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };
//     const getVehicleBillingDetail = async () => {
//         setBuffering(true);
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/filter-vehicle-billing/${project}/${vehicle}/${filterMonth}/${filterYear}/null/`);
//             setVehicleBillingDetails(response.data);

//         }
//         catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     }
//     useEffect(() => {
//         getVehicleBillingDetail();
//         getProjects();
//         getVehicle();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [project, vehicle, filterMonth, filterYear, subcompany]);

//     const monthOptions = [
//         { id: "01", name: "January" },
//         { id: "02", name: "February" },
//         { id: "03", name: "March" },
//         { id: "04", name: "April" },
//         { id: "05", name: "May" },
//         { id: "06", name: "June" },
//         { id: "07", name: "July" },
//         { id: "08", name: "August" },
//         { id: "09", name: "September" },
//         { id: 10, name: "October" },
//         { id: 11, name: "November" },
//         { id: 12, name: "December" }
//     ];
//     const getMonthName = (monthNumber) => {
//         const month = monthOptions.find(m => m.id.toString() === monthNumber);
//         return month ? month.name : '';
//     };

//     const currentYear = new Date().getFullYear();
//     const startYear = currentYear - 20; // starting 20 years ago
//     const endYear = currentYear + 20; // up to 20 years in the future
//     const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);



//     const getVehicle = async () => {
//         setBuffering(true); //buffering logic // Start Buffering
//         try {
//             const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${project}/${subcompany}/`);
//             setVehicleList(veh.data);

//         } catch (err) {
//             //toast Logic
//             if (err.response) {
//                 const errorData = err.response.data;

//                 if (typeof errorData.error === 'string') {
//                     // Single error message
//                     toast.error(`Error: ${errorData.error}`);
//                 } else if (typeof errorData === 'object' && errorData !== null) {
//                     // Multiple error messages
//                     Object.entries(errorData).forEach(([field, messages]) => {
//                         messages.forEach(message => toast.error(`"${field}": ${message}`));
//                     });
//                 } else {
//                     toast.error('Error:- Failed to Process!');
//                 }
//             } else {
//                 toast.error('Error processing your request.');
//             }
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     }



//     const [subcompanyList, setSubCompanyList] = useState([]);
//     const getSubCompany = async () => {
//         try {
//             const subcompany = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//             setSubCompanyList(subcompany.data)

//         } catch (error) {
//             console.error(error);

//         }
//     };
//     useEffect(() => {
//         getSubCompany();
//     }, []);

//     const role = sessionStorage.getItem('sitemanagement_role');


//     console.log(vehicleBillingDetails)

//     return (
//         <div>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />


//             <div className="attendance-subcont">
//                 <div className="field-cont" >
//                     <div className="flex-row" style={{ width: siteRole === "ViewAccess" ? "100%" : "60vw", flexWrap: 'wrap' }}>
//                         <div title='Month Filter' className="field-cont-div">
//                             <Month />

//                             <select
//                                 className="attendance-input-field width-10vw date-field"
//                                 type="text"
//                                 value={filterMonth}
//                                 onChange={(e) => setFilterMonth(e.target.value)}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 <option value="null">Select Month</option>
//                                 <option value="01">January</option>
//                                 <option value="02">February</option>
//                                 <option value="03">March</option>
//                                 <option value="04">April</option>
//                                 <option value="05">May</option>
//                                 <option value="06">June</option>
//                                 <option value="07">July</option>
//                                 <option value="08">August</option>
//                                 <option value="09">September</option>
//                                 <option value="10">October</option>
//                                 <option value="11">November</option>
//                                 <option value="12">December</option>
//                             </select>

//                             <hr className="field-cont-hr" />
//                         </div>

//                         <div title='Year Filter' className="field-cont-div">
//                             <Year />

//                             <select
//                                 className="attendance-input-field width-10vw   date-field"
//                                 type="text"
//                                 value={filterYear}
//                                 onChange={(e) => setFilterYear(e.target.value)}
//                                 style={{ cursor: 'pointer' }}
//                             >
//                                 <option value="null">Select Year</option>
//                                 {years.reverse().map((year) => (
//                                     <option key={year} value={year}>{year}</option>
//                                 ))}
//                             </select>

//                             <hr className="field-cont-hr" />
//                         </div>

//                         {siteRole === "SiteManagement" ? ("") : (
//                             <>
//                                 {
//                                     subCompanyid !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" &&
//                                     <SubCompany toggleCompany={subcompany} setToggleCompany={setSubCompany} />
//                                 }
//                                 <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={subcompany} />
//                             </>
//                         )}

//                         <div title="Vehicle Filter" className="field-cont-div ">
//                             <CircularGrid />
//                             <select
//                                 id="vehicle"
//                                 name="vehicle"
//                                 placeholder="vehicle"
//                                 value={vehicle}
//                                 onChange={(e) => setVehicle(e.target.value)}
//                                 style={{ cursor: 'pointer' }}
//                                 className={`attendance-input-field width-10vw`}
//                             >

//                                 <option value="null">Select Vehicle</option>
//                                 {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
//                                     <option key={index} value={i.id}>{i.name}-{i.vehicle_num}</option>
//                                 ))}
//                             </select>


//                         </div>
//                     </div>


//                 </div>
//                 {role !== "ViewAccess" &&
//                     <div className='field-cont-div'>
//                         <DownloadVehicleBill projectList={vehicleBillingDetails} />
//                         {/* {role === "SiteManagement" ?
//             <AddVehicleBillingDetails projectid={sessionStorage.getItem('sitemanagement_project')} getVehicleBillingDetail={getVehicleBillingDetail} />
//             :
//             <AddVehicleBillingDetails getVehicleBillingDetail={getVehicleBillingDetail} />

//           } */}
//                         {/* <AddMultipleVehicleBilling getData={getVehicleBillingDetail} /> */}
//                         {(role !== "SiteManagement") &&
//                             <BulkBillingForVehicle vehicleList={vehicleList} list={vehicleBillingDetails} getData={getVehicleBillingDetail} />}

//                     </div>
//                 }
//             </div>
//             {/* {role === "Admin" &&
//               <VehicleBillingStats year={filterYear} month={filterMonth} />} */}

//             <div className='table-box scroll-container-table'>
//                 <table className="table-css  width-100vw" ref={tableRef}>
//                     <thead className="table-heading">
//                         <tr className="custom-table-head-tr">
//                             <th className='table-heading-text'>S.no.</th>
//                             <th className="table-heading-text">Project Short Name</th>
//                             <th className="table-heading-text text-center">Vehicle Details</th>
//                             <th className="table-heading-text text-center">Bill Duration</th>
//                             <th className="table-heading-text">Billing Type</th>
//                             <th className="table-heading-text text-center">Bank Details</th>
//                             <th className="table-heading-text text-center">Amount Details</th>
//                             <th className="table-heading-text text-center">Status</th>
//                             <th className="table-heading-text">Remarks</th>
//                             {role !== "ViewAccess" &&

//                                 <th className='table-heading-text text-center' >Action</th>
//                             }
//                         </tr>




//                     </thead>
//                     {buffer ? (
//                         <div className="spinner-bgdatil"></div>
//                     ) : (
//                         <tbody>
//                             {vehicleBillingDetails.map((vehicle, monthIndex) => (
//                                 <React.Fragment key={monthIndex}>
//                                     <tr className='custom-table-head-td'>
//                                         <td className="table-body">{monthIndex + 1}.</td>
//                                         <td className="table-body">{vehicle.vehicle_details.project_short_name}</td>
//                                         <td className="table-heading-text">
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">Vehicle Name</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{vehicle.vehicle_name || "-"}</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">Vehicle Number</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{vehicle.vehicle_num || "-"}</td>
//                                             </tr>
//                                             {vehicle.billing_type === "As per fuel" ?
//                                                 <>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Fuel Prize</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">₹ {formatCurrencyIndian(vehicle.fuel_price) || "-"}</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">KM per Litre</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">{vehicle.km_per_ltr || "-"} KM</td>
//                                                     </tr>
//                                                 </> :
//                                                 <>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Fixed KM</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">{vehicle.fixed_km || "-"} KM</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Fixed Amount</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">₹ {vehicle.fixed_bill_amt || "-"}</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Extra Amount </td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">₹ {formatCurrencyIndian(vehicle.extra_amt_above_fix_km) || "-"}</td>
//                                                     </tr>
//                                                 </>
//                                             }



//                                         </td>
//                                         <td className="table-heading-text text-center">{vehicle.month}/{vehicle.year}</td>
//                                         <td className="table-heading-text">{vehicle.billing_type || "-"}</td>

//                                         <td className="table-heading-text">
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">Bank Name</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{vehicle.bank_name || "-"}</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">Account Number</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{vehicle.acc_number || "-"}</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">IFSC Code</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{vehicle.ifsc_code || "-"}</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">PAN No.</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{vehicle.pan_card || "-"}</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">Account Holder Name</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{vehicle.acc_holder_name || "-"}</td>
//                                             </tr>
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">Phone No.</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{vehicle.mobile_number || "-"}</td>
//                                             </tr>
//                                         </td>


//                                         <td className="table-heading-text">
//                                             <tr>
//                                                 <td className="padding-bottom-5px table-body">Distance Covered</td>
//                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                 <td className="text-start">{(vehicle.total_km) || "-"}
//                                                     KM</td>
//                                             </tr>

//                                             {vehicle.billing_type === "As per fuel" ?
//                                                 <>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Fuel Consumed</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">{(Number(vehicle.total_km) / Number(vehicle.km_per_ltr)).toFixed(2) || "-"} L</td>

//                                                     </tr>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Total Amount</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">
//                                                             ₹ {formatCurrencyIndian(
//                                                                 Number((Number(vehicle.total_km) / Number(vehicle.km_per_ltr)) * Number(vehicle.fuel_price)).toFixed(2)
//                                                             ) || "-"}
//                                                         </td>
//                                                     </tr>
//                                                 </>
//                                                 :
//                                                 <>
//                                                     {vehicle.total_km > vehicle.fixed_km &&
//                                                         <>
//                                                             <tr>
//                                                                 <td className="padding-bottom-5px table-body">Fixed KM</td>
//                                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                                 <td className="text-start">{vehicle.fixed_km || "0"} KM</td>
//                                                             </tr>
//                                                             <tr>
//                                                                 <td className="padding-bottom-5px table-body">Extra KM</td>
//                                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                                 <td className="text-start">{vehicle.extra_km || "0"} KM</td>
//                                                             </tr>
//                                                             <tr>
//                                                                 <td className="padding-bottom-5px table-body">Total KM</td>
//                                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                                 <td className="text-start">{Number(vehicle.fixed_km) + Number(vehicle.extra_km)} KM</td>
//                                                             </tr>
//                                                         </>
//                                                     }
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Fixed Amount</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">₹ {formatCurrencyIndian(vehicle.fixed_bill_amt) || "-"}</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Extra Amount</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">₹ {formatCurrencyIndian(vehicle.extra_charges) || "-"}</td>
//                                                     </tr>
//                                                     <tr>
//                                                         <td className="padding-bottom-5px table-body">Total Amount</td>
//                                                         <td style={{ padding: "0px 4px" }}>:</td>
//                                                         <td className="text-start">₹ {formatCurrencyIndian(Number(vehicle.extra_charges) + Number(vehicle.fixed_bill_amt)) || "-"}</td>
//                                                     </tr>
//                                                 </>
//                                             }
//                                         </td>
//                                         <ViewDynamicApprovalStatus dynamic_approval={vehicle.dynamic_approval} Table="Vehicle" />
//                                         <ViewDynamicApprovalRemarks dynamic_approval={vehicle?.dynamic_approval} />
//                                         {/* <ViewRequestStatus i={vehicle} approval_stages_data={vehicle?.approval_stages_data} />

//                       <ViewRequestRemarks i={vehicle} approval_stages_data={vehicle?.approval_stages_data} /> */}
//                                         {siteRole !== "ViewAccess" &&

//                                             <td className="  table-heading-text" style={{ justifyContent: 'right' }}>
//                                                 <div className='flex-row'>
//                                                     {/* {
//                             vehicle.admin_approval_status_c1 !== "pending" &&
//                               vehicle.admin_approval_status_c2 !== "pending" &&
//                               vehicle.checker_approval_status !== "pending" &&
//                               vehicle.authority_approval_status !== "pending" &&
//                               vehicle.account_status_a !== "pending" &&
//                               vehicle.account_status_b !== "pending" ? <Vehicle i={vehicle} getOfficeBill={getVehicleBillingDetail} /> : null
//                           } */}
//                                                     {/* <Vehicle i={vehicle} getOfficeBill={getVehicleBillingDetail} /> */}
//                                                     {siteRole === "Account" || siteRole === "SiteManagement" ? "" :
//                                                         <DeleteVehicleBillingDetail i={vehicle} getVehicleBillingDetail={getVehicleBillingDetail} />
//                                                     }
//                                                 </div>
//                                             </td>
//                                         }
//                                     </tr>
//                                 </React.Fragment>
//                             ))}
//                         </tbody>
//                     )}
//                 </table>
//             </div>


//         </div>
//     )

// }

const VehicleBillingDetails = ({ subCompanyid }) => {
    const [vehicleBillingDetails, setVehicleBillingDetails] = useState([]);
    const [buffer, setBuffering] = useState(false);
    const { projectID } = usePermission();
    const [project, setProject] = useState(projectID ? projectID : "null");
    const [projectList, setProjectList] = useState([]);
    const [vehicle, setVehicle] = useState("null");
    const [vehicleList, setVehicleList] = useState([]);
    const [subcompany, setSubCompany] = useState(subCompanyid || "null");
    const [showFilters, setShowFilters] = useState(true);
    const [expandedRow, setExpandedRow] = useState(null);
    const tableRef = useRef(null);

    const today = new Date();
    today.setDate(today.getDate() - 1);
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const employeeId = sessionStorage.getItem('sitemanagement_emp_id');
    const role = sessionStorage.getItem('sitemanagement_role');
    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const [filterMonth, setFilterMonth] = useState(`${month ? `0${month}` : "null"}`);
    const [filterYear, setFilterYear] = useState(`${year ? year : 'null'}`);

    const getProjects = async () => {
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${role === "AuthorityEngineer" ? employeeId : "null"}/null/${role === "DataEntryOperator" ? employeeId : "null"}/null/`);
            const sortedProjects = sortProjects(pro.data, 'site_prcode');
            setProjectList(sortedProjects);
        } catch (err) {
            handleErrorToast(err);
        }
    };

    const getVehicleBillingDetail = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/filter-vehicle-billing/${project}/${vehicle}/${filterMonth}/${filterYear}/null/`);
            setVehicleBillingDetails(response.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getVehicleBillingDetail();
        getProjects();
        getVehicle();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project, vehicle, filterMonth, filterYear, subcompany]);

    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20;
    const endYear = currentYear + 20;
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

    const getVehicle = async () => {
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${project}/${subcompany}/`);
            setVehicleList(veh.data);
        } catch (err) {
            if (err.response) {
                const errorData = err.response.data;
                if (typeof errorData.error === 'string') {
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        }
    };

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const subcompany = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(subcompany.data);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        getSubCompany();
    }, []);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const showFilterBar = siteRole !== "SiteManagement";
    const hasActiveFilters =
        filterMonth !== `${month ? `0${month}` : "null"}` ||
        filterYear !== `${year ? year : 'null'}` ||
        (subcompany !== "null" && subcompany !== subCompanyid) ||
        project !== "null" ||
        vehicle !== "null";

    const clearAllFilters = () => {
        setFilterMonth(`${month ? `0${month}` : "null"}`);
        setFilterYear(`${year ? year : 'null'}`);
        setSubCompany(subCompanyid || "null");
        setProject(projectID ? projectID : "null");
        setVehicle("null");
    };

    const getTotalAmount = (vehicle) => {
        if (vehicle.billing_type === "As per fuel") {
            return (Number(vehicle.total_km) / Number(vehicle.km_per_ltr)) * Number(vehicle.fuel_price);
        }
        return Number(vehicle.extra_charges || 0) + Number(vehicle.fixed_bill_amt || 0);
    };

    return (
        <div className="progress-modern-container">
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            {showFilters && (
                <div className="filter-bar-attractive" style={{ padding: "0px" }}>
                    <div className="filter-group-attractive" style={{ padding: "0px" }}>
                        <div className={`filter-chip ${filterMonth !== `${month ? `0${month}` : "null"}` ? "active" : ""}`} style={{ padding: "0px" }}>

                            <Monthprefix0 filterMonth={filterMonth} setFilterMonth={setFilterMonth} cssType="modern" />
                        </div>

                        <div className={`filter-chip ${filterYear !== `${year ? year : 'null'}` ? "active" : ""}`} style={{ padding: "0px" }}>
                            <div className="filter-chip-content">
                                <YearModern filterYear={filterYear} setFilterYear={setFilterYear} cssType="modern" />

                            </div>
                        </div>

                        {subCompanyid !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" && (
                            <div className={`filter-chip ${subcompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                <div className="filter-chip-content">
                                    <SubCompany toggleCompany={subcompany} setToggleCompany={setSubCompany} />
                                </div>
                            </div>
                        )}
                        {role === "Admin" &&
                            <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                                <div className="filter-chip-content">
                                    <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={subcompany} />
                                </div>
                            </div>
                        }

                        <div className={`filter-chip ${vehicle !== "null" ? "active" : ""}`} style={{ minWidth: '220px', padding: '0px' }}>
                            <div className="filter-chip-content" style={{ width: '100%' }}>

                                <VehicleModern cssType="modern" toggleProject={project} toggleSubCompany={subcompany} toggleVehicle={vehicle} setToggleVehicle={setVehicle} />
                            </div>
                        </div>

                        {hasActiveFilters && role === "Admin" && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats + toggle + actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Truck size={14} />
                        <span>Showing</span>
                        <strong>{vehicleBillingDetails.length} bills</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>

                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>


                    {role !== "ViewAccess" && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                            <DownloadVehicleBill projectList={vehicleBillingDetails} />
                            {role !== "SiteManagement" && (
                                <BulkBillingForVehicle vehicleList={vehicleList} list={vehicleBillingDetails} getData={getVehicleBillingDetail} />
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal" ref={tableRef}>
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '15%' }}>Project</th>
                                <th className="col-period text-center">Vehicle / Duration</th>
                                <th className="col-submitted text-center" style={{ width: '15%' }}>Billing Type</th>
                                <th className="col-approved text-center" style={{ width: '15%' }}>Total Amount</th>
                                <th className="col-status text-center" style={{ width: '12%' }}>Status</th>
                                {role !== "ViewAccess" && <th className="col-action text-center" style={{ width: '8%' }}>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {vehicleBillingDetails.map((vehicle, index) => {
                                const isExpanded = expandedRow === index;
                                const totalAmount = getTotalAmount(vehicle);

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">{vehicle.vehicle_details.project_short_name}</td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <Truck size={12} />
                                                    <span>{vehicle.vehicle_name} • {vehicle.vehicle_num}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                    {vehicle.month}/{vehicle.year}
                                                </div>
                                            </td>
                                            <td className="col-submitted text-center">
                                                <span className="badge-value">{vehicle.billing_type || "-"}</span>
                                            </td>
                                            <td className="col-approved text-center">
                                                <span className="badge-value">₹{formatCurrencyIndian(totalAmount.toFixed(2))}</span>
                                            </td>
                                            <td className="col-status text-center">
                                                <ViewDynamicApprovalStatus dynamic_approval={vehicle.dynamic_approval} Table="Vehicle" />
                                            </td>
                                            {role !== "ViewAccess" && (
                                                <td className="col-action text-center">
                                                    {siteRole === "Account" || siteRole === "SiteManagement" ? (
                                                        <span style={{ color: '#cbd5e1', fontSize: '12px' }}>-</span>
                                                    ) : (
                                                        <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                            <DeleteVehicleBillingDetail i={vehicle} getVehicleBillingDetail={getVehicleBillingDetail} />
                                                        </div>
                                                    )}
                                                </td>
                                            )}
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={role !== "ViewAccess" ? 7 : 6}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Billing Breakdown</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Truck size={14} />
                                                                    <span>Vehicle Rate Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    {vehicle.billing_type === "As per fuel" ? (
                                                                        <>
                                                                            <div className="stage-row"><span className="stage-label">Fuel Price</span><span className="amount">₹{formatCurrencyIndian(vehicle.fuel_price) || "-"}</span></div>
                                                                            <div className="stage-row"><span className="stage-label">KM per Litre</span><span className="amount">{vehicle.km_per_ltr || "-"} KM</span></div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div className="stage-row"><span className="stage-label">Fixed KM</span><span className="amount">{vehicle.fixed_km || "-"} KM</span></div>
                                                                            <div className="stage-row"><span className="stage-label">Fixed Amount</span><span className="amount">₹{vehicle.fixed_bill_amt || "-"}</span></div>
                                                                            <div className="stage-row"><span className="stage-label">Extra Amount</span><span className="amount">₹{formatCurrencyIndian(vehicle.extra_amt_above_fix_km) || "-"}</span></div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Landmark size={14} />
                                                                    <span>Bank Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row"><span className="stage-label">Bank Name</span><span className="amount">{vehicle.bank_name || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Account No.</span><span className="amount">{vehicle.acc_number || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">IFSC Code</span><span className="amount">{vehicle.ifsc_code || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">PAN No.</span><span className="amount">{vehicle.pan_card || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Holder Name</span><span className="amount">{vehicle.acc_holder_name || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Phone No.</span><span className="amount">{vehicle.mobile_number || "-"}</span></div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card approved" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Wallet size={14} />
                                                                    <span>Amount Details</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row"><span className="stage-label">Distance Covered</span><span className="amount">{vehicle.total_km || "-"} KM</span></div>
                                                                    {vehicle.billing_type === "As per fuel" ? (
                                                                        <>
                                                                            <div className="stage-row"><span className="stage-label">Fuel Consumed</span><span className="amount">{(Number(vehicle.total_km) / Number(vehicle.km_per_ltr)).toFixed(2) || "-"} L</span></div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {vehicle.total_km > vehicle.fixed_km && (
                                                                                <>
                                                                                    <div className="stage-row"><span className="stage-label">Fixed KM</span><span className="amount">{vehicle.fixed_km || "0"} KM</span></div>
                                                                                    <div className="stage-row"><span className="stage-label">Extra KM</span><span className="amount">{vehicle.extra_km || "0"} KM</span></div>
                                                                                    <div className="stage-row"><span className="stage-label">Total KM</span><span className="amount">{Number(vehicle.fixed_km) + Number(vehicle.extra_km)} KM</span></div>
                                                                                </>
                                                                            )}
                                                                            <div className="stage-row"><span className="stage-label">Fixed Amount</span><span className="amount">₹{formatCurrencyIndian(vehicle.fixed_bill_amt) || "-"}</span></div>
                                                                            <div className="stage-row"><span className="stage-label">Extra Amount</span><span className="amount">₹{formatCurrencyIndian(vehicle.extra_charges) || "-"}</span></div>
                                                                        </>
                                                                    )}
                                                                    <div className="stage-row"><span className="stage-label">Total Amount</span><span className="amount" style={{ fontWeight: 700 }}>₹{formatCurrencyIndian(totalAmount.toFixed(2))}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="stage-card" style={{ background: 'white' }}>
                                                            <div className="stage-header">
                                                                <FileText size={14} />
                                                                <span>Remarks</span>
                                                            </div>
                                                            <div className="stage-content">
                                                                <ViewDynamicApprovalRemarks dynamic_approval={vehicle?.dynamic_approval} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {vehicleBillingDetails.length === 0 && (
                                <tr>
                                    <td colSpan={role !== "ViewAccess" ? 7 : 6}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Truck size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Billing Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters to view billing records.
                                            </p>
                                            {role === "Admin" &&
                                                <>
                                                    {hasActiveFilters && (
                                                        <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                            <X size={13} />
                                                            Clear Filters
                                                        </button>
                                                    )}
                                                </>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

const VehicleManagement = () => {
    const projectId = sessionStorage.getItem("sitemanagement_project");
    const role = sessionStorage.getItem("sitemanagement_role");
    const [toggleState, setToggleState] = useState(role === "Checker" ? 2 : 1);
    const subCompanyid = sessionStorage.getItem("sitemanagement_project_sub_company");

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1: return "Vehicle Details";
            case 2: return "Vehicle Log Details";
            case 3: return "Vehicle Billing Details";
            default: return "Vehicle Details";
        }
    };

    const tabs = [
        { id: 1, label: 'Vehicle Details', icon: Truck },
        { id: 2, label: 'Vehicle Log Detail', icon: FileText },
        { id: 3, label: 'Vehicle Billing Details', icon: IndianRupee },
    ];

    const renderActiveComponent = () => {
        switch (toggleState) {
            case 1: return <VehicleModelTable subCompanyid={subCompanyid} />;
            case 2: return <VehicleLogDetails subCompanyid={subCompanyid} />;
            case 3: return <VehicleBillingDetails subCompanyid={subCompanyid} />;
            default: return null;
        }
    };

    return (
        <>

            <div className="project-details-modern">
                <div className="project-content-modern">
                    {/* Modern Tabs */}
                    <div className="modern-tabs-container">
                        <div className="tabs-scroll" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <div style={{ display: 'flex' }}>
                                {tabs.map((tab) => {
                                    const Icon = tab.icon;
                                    return (
                                        <button
                                            key={tab.id}
                                            className={`modern-tab-btn ${toggleState === tab.id ? 'active' : ''}`}
                                            onClick={() => setToggleState(tab.id)}
                                        >
                                            <Icon size={16} />
                                            <span>{tab.label}</span>
                                            {toggleState === tab.id && <div className="active-indicator" />}
                                        </button>
                                    );
                                })}
                            </div>


                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content-modern">
                        {renderActiveComponent()}
                    </div>
                </div>
            </div>
        </>
    );
};
export { VehicleManagement, VehicleModelTable, AddVehicleModel, AddVehicleBillingDetails, AddVehicleLogDetails, DownloadVehicleBill }